/**
* @vue/shared v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function ot(e) {
  const t = /* @__PURE__ */ Object.create(null);
  for (const o of e.split(",")) t[o] = 1;
  return (o) => o in t;
}
const q = process.env.NODE_ENV !== "production" ? Object.freeze({}) : {}, $t = process.env.NODE_ENV !== "production" ? Object.freeze([]) : [], ue = () => {
}, Qs = () => !1, no = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // uppercase letter
(e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), Oo = (e) => e.startsWith("onUpdate:"), te = Object.assign, Nn = (e, t) => {
  const o = e.indexOf(t);
  o > -1 && e.splice(o, 1);
}, Zs = Object.prototype.hasOwnProperty, H = (e, t) => Zs.call(e, t), T = Array.isArray, Et = (e) => Ro(e) === "[object Map]", kr = (e) => Ro(e) === "[object Set]", I = (e) => typeof e == "function", Z = (e) => typeof e == "string", nt = (e) => typeof e == "symbol", J = (e) => e !== null && typeof e == "object", On = (e) => (J(e) || I(e)) && I(e.then) && I(e.catch), Ir = Object.prototype.toString, Ro = (e) => Ir.call(e), Dn = (e) => Ro(e).slice(8, -1), jo = (e) => Ro(e) === "[object Object]", Vn = (e) => Z(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, Gt = /* @__PURE__ */ ot(
  // the leading comma is intentional so empty string "" is also included
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
), ei = /* @__PURE__ */ ot(
  "bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo"
), Fo = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  return (o) => t[o] || (t[o] = e(o));
}, ti = /-(\w)/g, Oe = Fo(
  (e) => e.replace(ti, (t, o) => o ? o.toUpperCase() : "")
), oi = /\B([A-Z])/g, Ae = Fo(
  (e) => e.replace(oi, "-$1").toLowerCase()
), zo = Fo((e) => e.charAt(0).toUpperCase() + e.slice(1)), yt = Fo(
  (e) => e ? `on${zo(e)}` : ""
), ht = (e, t) => !Object.is(e, t), Lt = (e, ...t) => {
  for (let o = 0; o < e.length; o++)
    e[o](...t);
}, Do = (e, t, o, n = !1) => {
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: !1,
    writable: n,
    value: o
  });
}, ni = (e) => {
  const t = parseFloat(e);
  return isNaN(t) ? e : t;
}, Gn = (e) => {
  const t = Z(e) ? Number(e) : NaN;
  return isNaN(t) ? e : t;
};
let Jn;
const ro = () => Jn || (Jn = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function le(e) {
  if (T(e)) {
    const t = {};
    for (let o = 0; o < e.length; o++) {
      const n = e[o], r = Z(n) ? li(n) : le(n);
      if (r)
        for (const s in r)
          t[s] = r[s];
    }
    return t;
  } else if (Z(e) || J(e))
    return e;
}
const ri = /;(?![^(]*\))/g, si = /:([^]+)/, ii = /\/\*[^]*?\*\//g;
function li(e) {
  const t = {};
  return e.replace(ii, "").split(ri).forEach((o) => {
    if (o) {
      const n = o.split(si);
      n.length > 1 && (t[n[0].trim()] = n[1].trim());
    }
  }), t;
}
function Mt(e) {
  let t = "";
  if (Z(e))
    t = e;
  else if (T(e))
    for (let o = 0; o < e.length; o++) {
      const n = Mt(e[o]);
      n && (t += n + " ");
    }
  else if (J(e))
    for (const o in e)
      e[o] && (t += o + " ");
  return t.trim();
}
const ci = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot", ai = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view", ui = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics", fi = /* @__PURE__ */ ot(ci), di = /* @__PURE__ */ ot(ai), pi = /* @__PURE__ */ ot(ui), hi = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly", gi = /* @__PURE__ */ ot(hi);
function Pr(e) {
  return !!e || e === "";
}
const $r = (e) => !!(e && e.__v_isRef === !0), re = (e) => Z(e) ? e : e == null ? "" : T(e) || J(e) && (e.toString === Ir || !I(e.toString)) ? $r(e) ? re(e.value) : JSON.stringify(e, Mr, 2) : String(e), Mr = (e, t) => $r(t) ? Mr(e, t.value) : Et(t) ? {
  [`Map(${t.size})`]: [...t.entries()].reduce(
    (o, [n, r], s) => (o[Jo(n, s) + " =>"] = r, o),
    {}
  )
} : kr(t) ? {
  [`Set(${t.size})`]: [...t.values()].map((o) => Jo(o))
} : nt(t) ? Jo(t) : J(t) && !T(t) && !jo(t) ? String(t) : t, Jo = (e, t = "") => {
  var o;
  return (
    // Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    nt(e) ? `Symbol(${(o = e.description) != null ? o : t})` : e
  );
};
/**
* @vue/reactivity v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function Je(e, ...t) {
  console.warn(`[Vue warn] ${e}`, ...t);
}
let Te;
class mi {
  constructor(t = !1) {
    this.detached = t, this._active = !0, this.effects = [], this.cleanups = [], this._isPaused = !1, this.parent = Te, !t && Te && (this.index = (Te.scopes || (Te.scopes = [])).push(
      this
    ) - 1);
  }
  get active() {
    return this._active;
  }
  pause() {
    if (this._active) {
      this._isPaused = !0;
      let t, o;
      if (this.scopes)
        for (t = 0, o = this.scopes.length; t < o; t++)
          this.scopes[t].pause();
      for (t = 0, o = this.effects.length; t < o; t++)
        this.effects[t].pause();
    }
  }
  /**
   * Resumes the effect scope, including all child scopes and effects.
   */
  resume() {
    if (this._active && this._isPaused) {
      this._isPaused = !1;
      let t, o;
      if (this.scopes)
        for (t = 0, o = this.scopes.length; t < o; t++)
          this.scopes[t].resume();
      for (t = 0, o = this.effects.length; t < o; t++)
        this.effects[t].resume();
    }
  }
  run(t) {
    if (this._active) {
      const o = Te;
      try {
        return Te = this, t();
      } finally {
        Te = o;
      }
    } else process.env.NODE_ENV !== "production" && Je("cannot run an inactive effect scope.");
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  on() {
    Te = this;
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  off() {
    Te = this.parent;
  }
  stop(t) {
    if (this._active) {
      this._active = !1;
      let o, n;
      for (o = 0, n = this.effects.length; o < n; o++)
        this.effects[o].stop();
      for (this.effects.length = 0, o = 0, n = this.cleanups.length; o < n; o++)
        this.cleanups[o]();
      if (this.cleanups.length = 0, this.scopes) {
        for (o = 0, n = this.scopes.length; o < n; o++)
          this.scopes[o].stop(!0);
        this.scopes.length = 0;
      }
      if (!this.detached && this.parent && !t) {
        const r = this.parent.scopes.pop();
        r && r !== this && (this.parent.scopes[this.index] = r, r.index = this.index);
      }
      this.parent = void 0;
    }
  }
}
function bi() {
  return Te;
}
let W;
const Yo = /* @__PURE__ */ new WeakSet();
class Rr {
  constructor(t) {
    this.fn = t, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0, Te && Te.active && Te.effects.push(this);
  }
  pause() {
    this.flags |= 64;
  }
  resume() {
    this.flags & 64 && (this.flags &= -65, Yo.has(this) && (Yo.delete(this), this.trigger()));
  }
  /**
   * @internal
   */
  notify() {
    this.flags & 2 && !(this.flags & 32) || this.flags & 8 || Fr(this);
  }
  run() {
    if (!(this.flags & 1))
      return this.fn();
    this.flags |= 2, Yn(this), zr(this);
    const t = W, o = je;
    W = this, je = !0;
    try {
      return this.fn();
    } finally {
      process.env.NODE_ENV !== "production" && W !== this && Je(
        "Active effect was not restored correctly - this is likely a Vue internal bug."
      ), Hr(this), W = t, je = o, this.flags &= -3;
    }
  }
  stop() {
    if (this.flags & 1) {
      for (let t = this.deps; t; t = t.nextDep)
        Tn(t);
      this.deps = this.depsTail = void 0, Yn(this), this.onStop && this.onStop(), this.flags &= -2;
    }
  }
  trigger() {
    this.flags & 64 ? Yo.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
  }
  /**
   * @internal
   */
  runIfDirty() {
    ln(this) && this.run();
  }
  get dirty() {
    return ln(this);
  }
}
let jr = 0, Jt, Yt;
function Fr(e, t = !1) {
  if (e.flags |= 8, t) {
    e.next = Yt, Yt = e;
    return;
  }
  e.next = Jt, Jt = e;
}
function Sn() {
  jr++;
}
function Cn() {
  if (--jr > 0)
    return;
  if (Yt) {
    let t = Yt;
    for (Yt = void 0; t; ) {
      const o = t.next;
      t.next = void 0, t.flags &= -9, t = o;
    }
  }
  let e;
  for (; Jt; ) {
    let t = Jt;
    for (Jt = void 0; t; ) {
      const o = t.next;
      if (t.next = void 0, t.flags &= -9, t.flags & 1)
        try {
          t.trigger();
        } catch (n) {
          e || (e = n);
        }
      t = o;
    }
  }
  if (e) throw e;
}
function zr(e) {
  for (let t = e.deps; t; t = t.nextDep)
    t.version = -1, t.prevActiveLink = t.dep.activeLink, t.dep.activeLink = t;
}
function Hr(e) {
  let t, o = e.depsTail, n = o;
  for (; n; ) {
    const r = n.prevDep;
    n.version === -1 ? (n === o && (o = r), Tn(n), vi(n)) : t = n, n.dep.activeLink = n.prevActiveLink, n.prevActiveLink = void 0, n = r;
  }
  e.deps = t, e.depsTail = o;
}
function ln(e) {
  for (let t = e.deps; t; t = t.nextDep)
    if (t.dep.version !== t.version || t.dep.computed && (Lr(t.dep.computed) || t.dep.version !== t.version))
      return !0;
  return !!e._dirty;
}
function Lr(e) {
  if (e.flags & 4 && !(e.flags & 16) || (e.flags &= -17, e.globalVersion === Qt))
    return;
  e.globalVersion = Qt;
  const t = e.dep;
  if (e.flags |= 2, t.version > 0 && !e.isSSR && e.deps && !ln(e)) {
    e.flags &= -3;
    return;
  }
  const o = W, n = je;
  W = e, je = !0;
  try {
    zr(e);
    const r = e.fn(e._value);
    (t.version === 0 || ht(r, e._value)) && (e._value = r, t.version++);
  } catch (r) {
    throw t.version++, r;
  } finally {
    W = o, je = n, Hr(e), e.flags &= -3;
  }
}
function Tn(e, t = !1) {
  const { dep: o, prevSub: n, nextSub: r } = e;
  if (n && (n.nextSub = r, e.prevSub = void 0), r && (r.prevSub = n, e.nextSub = void 0), process.env.NODE_ENV !== "production" && o.subsHead === e && (o.subsHead = r), o.subs === e && (o.subs = n, !n && o.computed)) {
    o.computed.flags &= -5;
    for (let s = o.computed.deps; s; s = s.nextDep)
      Tn(s, !0);
  }
  !t && !--o.sc && o.map && o.map.delete(o.key);
}
function vi(e) {
  const { prevDep: t, nextDep: o } = e;
  t && (t.nextDep = o, e.prevDep = void 0), o && (o.prevDep = t, e.nextDep = void 0);
}
let je = !0;
const Br = [];
function rt() {
  Br.push(je), je = !1;
}
function st() {
  const e = Br.pop();
  je = e === void 0 ? !0 : e;
}
function Yn(e) {
  const { cleanup: t } = e;
  if (e.cleanup = void 0, t) {
    const o = W;
    W = void 0;
    try {
      t();
    } finally {
      W = o;
    }
  }
}
let Qt = 0;
class _i {
  constructor(t, o) {
    this.sub = t, this.dep = o, this.version = o.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
  }
}
class An {
  constructor(t) {
    this.computed = t, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, process.env.NODE_ENV !== "production" && (this.subsHead = void 0);
  }
  track(t) {
    if (!W || !je || W === this.computed)
      return;
    let o = this.activeLink;
    if (o === void 0 || o.sub !== W)
      o = this.activeLink = new _i(W, this), W.deps ? (o.prevDep = W.depsTail, W.depsTail.nextDep = o, W.depsTail = o) : W.deps = W.depsTail = o, Ur(o);
    else if (o.version === -1 && (o.version = this.version, o.nextDep)) {
      const n = o.nextDep;
      n.prevDep = o.prevDep, o.prevDep && (o.prevDep.nextDep = n), o.prevDep = W.depsTail, o.nextDep = void 0, W.depsTail.nextDep = o, W.depsTail = o, W.deps === o && (W.deps = n);
    }
    return process.env.NODE_ENV !== "production" && W.onTrack && W.onTrack(
      te(
        {
          effect: W
        },
        t
      )
    ), o;
  }
  trigger(t) {
    this.version++, Qt++, this.notify(t);
  }
  notify(t) {
    Sn();
    try {
      if (process.env.NODE_ENV !== "production")
        for (let o = this.subsHead; o; o = o.nextSub)
          o.sub.onTrigger && !(o.sub.flags & 8) && o.sub.onTrigger(
            te(
              {
                effect: o.sub
              },
              t
            )
          );
      for (let o = this.subs; o; o = o.prevSub)
        o.sub.notify() && o.sub.dep.notify();
    } finally {
      Cn();
    }
  }
}
function Ur(e) {
  if (e.dep.sc++, e.sub.flags & 4) {
    const t = e.dep.computed;
    if (t && !e.dep.subs) {
      t.flags |= 20;
      for (let n = t.deps; n; n = n.nextDep)
        Ur(n);
    }
    const o = e.dep.subs;
    o !== e && (e.prevSub = o, o && (o.nextSub = e)), process.env.NODE_ENV !== "production" && e.dep.subsHead === void 0 && (e.dep.subsHead = e), e.dep.subs = e;
  }
}
const cn = /* @__PURE__ */ new WeakMap(), xt = Symbol(
  process.env.NODE_ENV !== "production" ? "Object iterate" : ""
), an = Symbol(
  process.env.NODE_ENV !== "production" ? "Map keys iterate" : ""
), Zt = Symbol(
  process.env.NODE_ENV !== "production" ? "Array iterate" : ""
);
function ce(e, t, o) {
  if (je && W) {
    let n = cn.get(e);
    n || cn.set(e, n = /* @__PURE__ */ new Map());
    let r = n.get(o);
    r || (n.set(o, r = new An()), r.map = n, r.key = o), process.env.NODE_ENV !== "production" ? r.track({
      target: e,
      type: t,
      key: o
    }) : r.track();
  }
}
function Ke(e, t, o, n, r, s) {
  const l = cn.get(e);
  if (!l) {
    Qt++;
    return;
  }
  const a = (u) => {
    u && (process.env.NODE_ENV !== "production" ? u.trigger({
      target: e,
      type: t,
      key: o,
      newValue: n,
      oldValue: r,
      oldTarget: s
    }) : u.trigger());
  };
  if (Sn(), t === "clear")
    l.forEach(a);
  else {
    const u = T(e), h = u && Vn(o);
    if (u && o === "length") {
      const p = Number(n);
      l.forEach((d, b) => {
        (b === "length" || b === Zt || !nt(b) && b >= p) && a(d);
      });
    } else
      switch ((o !== void 0 || l.has(void 0)) && a(l.get(o)), h && a(l.get(Zt)), t) {
        case "add":
          u ? h && a(l.get("length")) : (a(l.get(xt)), Et(e) && a(l.get(an)));
          break;
        case "delete":
          u || (a(l.get(xt)), Et(e) && a(l.get(an)));
          break;
        case "set":
          Et(e) && a(l.get(xt));
          break;
      }
  }
  Cn();
}
function At(e) {
  const t = M(e);
  return t === e ? t : (ce(t, "iterate", Zt), _e(e) ? t : t.map(ge));
}
function Ho(e) {
  return ce(e = M(e), "iterate", Zt), e;
}
const yi = {
  __proto__: null,
  [Symbol.iterator]() {
    return Xo(this, Symbol.iterator, ge);
  },
  concat(...e) {
    return At(this).concat(
      ...e.map((t) => T(t) ? At(t) : t)
    );
  },
  entries() {
    return Xo(this, "entries", (e) => (e[1] = ge(e[1]), e));
  },
  every(e, t) {
    return Ze(this, "every", e, t, void 0, arguments);
  },
  filter(e, t) {
    return Ze(this, "filter", e, t, (o) => o.map(ge), arguments);
  },
  find(e, t) {
    return Ze(this, "find", e, t, ge, arguments);
  },
  findIndex(e, t) {
    return Ze(this, "findIndex", e, t, void 0, arguments);
  },
  findLast(e, t) {
    return Ze(this, "findLast", e, t, ge, arguments);
  },
  findLastIndex(e, t) {
    return Ze(this, "findLastIndex", e, t, void 0, arguments);
  },
  // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
  forEach(e, t) {
    return Ze(this, "forEach", e, t, void 0, arguments);
  },
  includes(...e) {
    return Qo(this, "includes", e);
  },
  indexOf(...e) {
    return Qo(this, "indexOf", e);
  },
  join(e) {
    return At(this).join(e);
  },
  // keys() iterator only reads `length`, no optimisation required
  lastIndexOf(...e) {
    return Qo(this, "lastIndexOf", e);
  },
  map(e, t) {
    return Ze(this, "map", e, t, void 0, arguments);
  },
  pop() {
    return Bt(this, "pop");
  },
  push(...e) {
    return Bt(this, "push", e);
  },
  reduce(e, ...t) {
    return Xn(this, "reduce", e, t);
  },
  reduceRight(e, ...t) {
    return Xn(this, "reduceRight", e, t);
  },
  shift() {
    return Bt(this, "shift");
  },
  // slice could use ARRAY_ITERATE but also seems to beg for range tracking
  some(e, t) {
    return Ze(this, "some", e, t, void 0, arguments);
  },
  splice(...e) {
    return Bt(this, "splice", e);
  },
  toReversed() {
    return At(this).toReversed();
  },
  toSorted(e) {
    return At(this).toSorted(e);
  },
  toSpliced(...e) {
    return At(this).toSpliced(...e);
  },
  unshift(...e) {
    return Bt(this, "unshift", e);
  },
  values() {
    return Xo(this, "values", ge);
  }
};
function Xo(e, t, o) {
  const n = Ho(e), r = n[t]();
  return n !== e && !_e(e) && (r._next = r.next, r.next = () => {
    const s = r._next();
    return s.value && (s.value = o(s.value)), s;
  }), r;
}
const wi = Array.prototype;
function Ze(e, t, o, n, r, s) {
  const l = Ho(e), a = l !== e && !_e(e), u = l[t];
  if (u !== wi[t]) {
    const d = u.apply(e, s);
    return a ? ge(d) : d;
  }
  let h = o;
  l !== e && (a ? h = function(d, b) {
    return o.call(this, ge(d), b, e);
  } : o.length > 2 && (h = function(d, b) {
    return o.call(this, d, b, e);
  }));
  const p = u.call(l, h, n);
  return a && r ? r(p) : p;
}
function Xn(e, t, o, n) {
  const r = Ho(e);
  let s = o;
  return r !== e && (_e(e) ? o.length > 3 && (s = function(l, a, u) {
    return o.call(this, l, a, u, e);
  }) : s = function(l, a, u) {
    return o.call(this, l, ge(a), u, e);
  }), r[t](s, ...n);
}
function Qo(e, t, o) {
  const n = M(e);
  ce(n, "iterate", Zt);
  const r = n[t](...o);
  return (r === -1 || r === !1) && Vo(o[0]) ? (o[0] = M(o[0]), n[t](...o)) : r;
}
function Bt(e, t, o = []) {
  rt(), Sn();
  const n = M(e)[t].apply(e, o);
  return Cn(), st(), n;
}
const Ei = /* @__PURE__ */ ot("__proto__,__v_isRef,__isVue"), Wr = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(nt)
);
function xi(e) {
  nt(e) || (e = String(e));
  const t = M(this);
  return ce(t, "has", e), t.hasOwnProperty(e);
}
class Kr {
  constructor(t = !1, o = !1) {
    this._isReadonly = t, this._isShallow = o;
  }
  get(t, o, n) {
    if (o === "__v_skip") return t.__v_skip;
    const r = this._isReadonly, s = this._isShallow;
    if (o === "__v_isReactive")
      return !r;
    if (o === "__v_isReadonly")
      return r;
    if (o === "__v_isShallow")
      return s;
    if (o === "__v_raw")
      return n === (r ? s ? Qr : Xr : s ? Yr : Jr).get(t) || // receiver is not the reactive proxy, but has the same prototype
      // this means the receiver is a user proxy of the reactive proxy
      Object.getPrototypeOf(t) === Object.getPrototypeOf(n) ? t : void 0;
    const l = T(t);
    if (!r) {
      let u;
      if (l && (u = yi[o]))
        return u;
      if (o === "hasOwnProperty")
        return xi;
    }
    const a = Reflect.get(
      t,
      o,
      // if this is a proxy wrapping a ref, return methods using the raw ref
      // as receiver so that we don't have to call `toRaw` on the ref in all
      // its class methods
      se(t) ? t : n
    );
    return (nt(o) ? Wr.has(o) : Ei(o)) || (r || ce(t, "get", o), s) ? a : se(a) ? l && Vn(o) ? a : a.value : J(a) ? r ? Zr(a) : Bo(a) : a;
  }
}
class qr extends Kr {
  constructor(t = !1) {
    super(!1, t);
  }
  set(t, o, n, r) {
    let s = t[o];
    if (!this._isShallow) {
      const u = tt(s);
      if (!_e(n) && !tt(n) && (s = M(s), n = M(n)), !T(t) && se(s) && !se(n))
        return u ? !1 : (s.value = n, !0);
    }
    const l = T(t) && Vn(o) ? Number(o) < t.length : H(t, o), a = Reflect.set(
      t,
      o,
      n,
      se(t) ? t : r
    );
    return t === M(r) && (l ? ht(n, s) && Ke(t, "set", o, n, s) : Ke(t, "add", o, n)), a;
  }
  deleteProperty(t, o) {
    const n = H(t, o), r = t[o], s = Reflect.deleteProperty(t, o);
    return s && n && Ke(t, "delete", o, void 0, r), s;
  }
  has(t, o) {
    const n = Reflect.has(t, o);
    return (!nt(o) || !Wr.has(o)) && ce(t, "has", o), n;
  }
  ownKeys(t) {
    return ce(
      t,
      "iterate",
      T(t) ? "length" : xt
    ), Reflect.ownKeys(t);
  }
}
class Gr extends Kr {
  constructor(t = !1) {
    super(!0, t);
  }
  set(t, o) {
    return process.env.NODE_ENV !== "production" && Je(
      `Set operation on key "${String(o)}" failed: target is readonly.`,
      t
    ), !0;
  }
  deleteProperty(t, o) {
    return process.env.NODE_ENV !== "production" && Je(
      `Delete operation on key "${String(o)}" failed: target is readonly.`,
      t
    ), !0;
  }
}
const Ni = /* @__PURE__ */ new qr(), Oi = /* @__PURE__ */ new Gr(), Di = /* @__PURE__ */ new qr(!0), Vi = /* @__PURE__ */ new Gr(!0), un = (e) => e, ho = (e) => Reflect.getPrototypeOf(e);
function Si(e, t, o) {
  return function(...n) {
    const r = this.__v_raw, s = M(r), l = Et(s), a = e === "entries" || e === Symbol.iterator && l, u = e === "keys" && l, h = r[e](...n), p = o ? un : t ? fn : ge;
    return !t && ce(
      s,
      "iterate",
      u ? an : xt
    ), {
      // iterator protocol
      next() {
        const { value: d, done: b } = h.next();
        return b ? { value: d, done: b } : {
          value: a ? [p(d[0]), p(d[1])] : p(d),
          done: b
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function go(e) {
  return function(...t) {
    if (process.env.NODE_ENV !== "production") {
      const o = t[0] ? `on key "${t[0]}" ` : "";
      Je(
        `${zo(e)} operation ${o}failed: target is readonly.`,
        M(this)
      );
    }
    return e === "delete" ? !1 : e === "clear" ? void 0 : this;
  };
}
function Ci(e, t) {
  const o = {
    get(r) {
      const s = this.__v_raw, l = M(s), a = M(r);
      e || (ht(r, a) && ce(l, "get", r), ce(l, "get", a));
      const { has: u } = ho(l), h = t ? un : e ? fn : ge;
      if (u.call(l, r))
        return h(s.get(r));
      if (u.call(l, a))
        return h(s.get(a));
      s !== l && s.get(r);
    },
    get size() {
      const r = this.__v_raw;
      return !e && ce(M(r), "iterate", xt), Reflect.get(r, "size", r);
    },
    has(r) {
      const s = this.__v_raw, l = M(s), a = M(r);
      return e || (ht(r, a) && ce(l, "has", r), ce(l, "has", a)), r === a ? s.has(r) : s.has(r) || s.has(a);
    },
    forEach(r, s) {
      const l = this, a = l.__v_raw, u = M(a), h = t ? un : e ? fn : ge;
      return !e && ce(u, "iterate", xt), a.forEach((p, d) => r.call(s, h(p), h(d), l));
    }
  };
  return te(
    o,
    e ? {
      add: go("add"),
      set: go("set"),
      delete: go("delete"),
      clear: go("clear")
    } : {
      add(r) {
        !t && !_e(r) && !tt(r) && (r = M(r));
        const s = M(this);
        return ho(s).has.call(s, r) || (s.add(r), Ke(s, "add", r, r)), this;
      },
      set(r, s) {
        !t && !_e(s) && !tt(s) && (s = M(s));
        const l = M(this), { has: a, get: u } = ho(l);
        let h = a.call(l, r);
        h ? process.env.NODE_ENV !== "production" && Qn(l, a, r) : (r = M(r), h = a.call(l, r));
        const p = u.call(l, r);
        return l.set(r, s), h ? ht(s, p) && Ke(l, "set", r, s, p) : Ke(l, "add", r, s), this;
      },
      delete(r) {
        const s = M(this), { has: l, get: a } = ho(s);
        let u = l.call(s, r);
        u ? process.env.NODE_ENV !== "production" && Qn(s, l, r) : (r = M(r), u = l.call(s, r));
        const h = a ? a.call(s, r) : void 0, p = s.delete(r);
        return u && Ke(s, "delete", r, void 0, h), p;
      },
      clear() {
        const r = M(this), s = r.size !== 0, l = process.env.NODE_ENV !== "production" ? Et(r) ? new Map(r) : new Set(r) : void 0, a = r.clear();
        return s && Ke(
          r,
          "clear",
          void 0,
          void 0,
          l
        ), a;
      }
    }
  ), [
    "keys",
    "values",
    "entries",
    Symbol.iterator
  ].forEach((r) => {
    o[r] = Si(r, e, t);
  }), o;
}
function Lo(e, t) {
  const o = Ci(e, t);
  return (n, r, s) => r === "__v_isReactive" ? !e : r === "__v_isReadonly" ? e : r === "__v_raw" ? n : Reflect.get(
    H(o, r) && r in n ? o : n,
    r,
    s
  );
}
const Ti = {
  get: /* @__PURE__ */ Lo(!1, !1)
}, Ai = {
  get: /* @__PURE__ */ Lo(!1, !0)
}, ki = {
  get: /* @__PURE__ */ Lo(!0, !1)
}, Ii = {
  get: /* @__PURE__ */ Lo(!0, !0)
};
function Qn(e, t, o) {
  const n = M(o);
  if (n !== o && t.call(e, n)) {
    const r = Dn(e);
    Je(
      `Reactive ${r} contains both the raw and reactive versions of the same object${r === "Map" ? " as keys" : ""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
    );
  }
}
const Jr = /* @__PURE__ */ new WeakMap(), Yr = /* @__PURE__ */ new WeakMap(), Xr = /* @__PURE__ */ new WeakMap(), Qr = /* @__PURE__ */ new WeakMap();
function Pi(e) {
  switch (e) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function $i(e) {
  return e.__v_skip || !Object.isExtensible(e) ? 0 : Pi(Dn(e));
}
function Bo(e) {
  return tt(e) ? e : Uo(
    e,
    !1,
    Ni,
    Ti,
    Jr
  );
}
function Mi(e) {
  return Uo(
    e,
    !1,
    Di,
    Ai,
    Yr
  );
}
function Zr(e) {
  return Uo(
    e,
    !0,
    Oi,
    ki,
    Xr
  );
}
function qe(e) {
  return Uo(
    e,
    !0,
    Vi,
    Ii,
    Qr
  );
}
function Uo(e, t, o, n, r) {
  if (!J(e))
    return process.env.NODE_ENV !== "production" && Je(
      `value cannot be made ${t ? "readonly" : "reactive"}: ${String(
        e
      )}`
    ), e;
  if (e.__v_raw && !(t && e.__v_isReactive))
    return e;
  const s = r.get(e);
  if (s)
    return s;
  const l = $i(e);
  if (l === 0)
    return e;
  const a = new Proxy(
    e,
    l === 2 ? n : o
  );
  return r.set(e, a), a;
}
function Nt(e) {
  return tt(e) ? Nt(e.__v_raw) : !!(e && e.__v_isReactive);
}
function tt(e) {
  return !!(e && e.__v_isReadonly);
}
function _e(e) {
  return !!(e && e.__v_isShallow);
}
function Vo(e) {
  return e ? !!e.__v_raw : !1;
}
function M(e) {
  const t = e && e.__v_raw;
  return t ? M(t) : e;
}
function Ri(e) {
  return !H(e, "__v_skip") && Object.isExtensible(e) && Do(e, "__v_skip", !0), e;
}
const ge = (e) => J(e) ? Bo(e) : e, fn = (e) => J(e) ? Zr(e) : e;
function se(e) {
  return e ? e.__v_isRef === !0 : !1;
}
function at(e) {
  return ji(e, !1);
}
function ji(e, t) {
  return se(e) ? e : new Fi(e, t);
}
class Fi {
  constructor(t, o) {
    this.dep = new An(), this.__v_isRef = !0, this.__v_isShallow = !1, this._rawValue = o ? t : M(t), this._value = o ? t : ge(t), this.__v_isShallow = o;
  }
  get value() {
    return process.env.NODE_ENV !== "production" ? this.dep.track({
      target: this,
      type: "get",
      key: "value"
    }) : this.dep.track(), this._value;
  }
  set value(t) {
    const o = this._rawValue, n = this.__v_isShallow || _e(t) || tt(t);
    t = n ? t : M(t), ht(t, o) && (this._rawValue = t, this._value = n ? t : ge(t), process.env.NODE_ENV !== "production" ? this.dep.trigger({
      target: this,
      type: "set",
      key: "value",
      newValue: t,
      oldValue: o
    }) : this.dep.trigger());
  }
}
function es(e) {
  return se(e) ? e.value : e;
}
const zi = {
  get: (e, t, o) => t === "__v_raw" ? e : es(Reflect.get(e, t, o)),
  set: (e, t, o, n) => {
    const r = e[t];
    return se(r) && !se(o) ? (r.value = o, !0) : Reflect.set(e, t, o, n);
  }
};
function ts(e) {
  return Nt(e) ? e : new Proxy(e, zi);
}
class Hi {
  constructor(t, o, n) {
    this.fn = t, this.setter = o, this._value = void 0, this.dep = new An(this), this.__v_isRef = !0, this.deps = void 0, this.depsTail = void 0, this.flags = 16, this.globalVersion = Qt - 1, this.next = void 0, this.effect = this, this.__v_isReadonly = !o, this.isSSR = n;
  }
  /**
   * @internal
   */
  notify() {
    if (this.flags |= 16, !(this.flags & 8) && // avoid infinite self recursion
    W !== this)
      return Fr(this, !0), !0;
    process.env.NODE_ENV;
  }
  get value() {
    const t = process.env.NODE_ENV !== "production" ? this.dep.track({
      target: this,
      type: "get",
      key: "value"
    }) : this.dep.track();
    return Lr(this), t && (t.version = this.dep.version), this._value;
  }
  set value(t) {
    this.setter ? this.setter(t) : process.env.NODE_ENV !== "production" && Je("Write operation failed: computed value is readonly");
  }
}
function Li(e, t, o = !1) {
  let n, r;
  I(e) ? n = e : (n = e.get, r = e.set);
  const s = new Hi(n, r, o);
  return process.env.NODE_ENV, s;
}
const mo = {}, So = /* @__PURE__ */ new WeakMap();
let wt;
function Bi(e, t = !1, o = wt) {
  if (o) {
    let n = So.get(o);
    n || So.set(o, n = []), n.push(e);
  } else process.env.NODE_ENV !== "production" && !t && Je(
    "onWatcherCleanup() was called when there was no active watcher to associate with."
  );
}
function Ui(e, t, o = q) {
  const { immediate: n, deep: r, once: s, scheduler: l, augmentJob: a, call: u } = o, h = (S) => {
    (o.onWarn || Je)(
      "Invalid watch source: ",
      S,
      "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types."
    );
  }, p = (S) => r ? S : _e(S) || r === !1 || r === 0 ? dt(S, 1) : dt(S);
  let d, b, N, V, $ = !1, ie = !1;
  if (se(e) ? (b = () => e.value, $ = _e(e)) : Nt(e) ? (b = () => p(e), $ = !0) : T(e) ? (ie = !0, $ = e.some((S) => Nt(S) || _e(S)), b = () => e.map((S) => {
    if (se(S))
      return S.value;
    if (Nt(S))
      return p(S);
    if (I(S))
      return u ? u(S, 2) : S();
    process.env.NODE_ENV !== "production" && h(S);
  })) : I(e) ? t ? b = u ? () => u(e, 2) : e : b = () => {
    if (N) {
      rt();
      try {
        N();
      } finally {
        st();
      }
    }
    const S = wt;
    wt = d;
    try {
      return u ? u(e, 3, [V]) : e(V);
    } finally {
      wt = S;
    }
  } : (b = ue, process.env.NODE_ENV !== "production" && h(e)), t && r) {
    const S = b, ee = r === !0 ? 1 / 0 : r;
    b = () => dt(S(), ee);
  }
  const U = bi(), D = () => {
    d.stop(), U && U.active && Nn(U.effects, d);
  };
  if (s && t) {
    const S = t;
    t = (...ee) => {
      S(...ee), D();
    };
  }
  let L = ie ? new Array(e.length).fill(mo) : mo;
  const ne = (S) => {
    if (!(!(d.flags & 1) || !d.dirty && !S))
      if (t) {
        const ee = d.run();
        if (r || $ || (ie ? ee.some((Q, Y) => ht(Q, L[Y])) : ht(ee, L))) {
          N && N();
          const Q = wt;
          wt = d;
          try {
            const Y = [
              ee,
              // pass undefined as the old value when it's changed for the first time
              L === mo ? void 0 : ie && L[0] === mo ? [] : L,
              V
            ];
            u ? u(t, 3, Y) : (
              // @ts-expect-error
              t(...Y)
            ), L = ee;
          } finally {
            wt = Q;
          }
        }
      } else
        d.run();
  };
  return a && a(ne), d = new Rr(b), d.scheduler = l ? () => l(ne, !1) : ne, V = (S) => Bi(S, !1, d), N = d.onStop = () => {
    const S = So.get(d);
    if (S) {
      if (u)
        u(S, 4);
      else
        for (const ee of S) ee();
      So.delete(d);
    }
  }, process.env.NODE_ENV !== "production" && (d.onTrack = o.onTrack, d.onTrigger = o.onTrigger), t ? n ? ne(!0) : L = d.run() : l ? l(ne.bind(null, !0), !0) : d.run(), D.pause = d.pause.bind(d), D.resume = d.resume.bind(d), D.stop = D, D;
}
function dt(e, t = 1 / 0, o) {
  if (t <= 0 || !J(e) || e.__v_skip || (o = o || /* @__PURE__ */ new Set(), o.has(e)))
    return e;
  if (o.add(e), t--, se(e))
    dt(e.value, t, o);
  else if (T(e))
    for (let n = 0; n < e.length; n++)
      dt(e[n], t, o);
  else if (kr(e) || Et(e))
    e.forEach((n) => {
      dt(n, t, o);
    });
  else if (jo(e)) {
    for (const n in e)
      dt(e[n], t, o);
    for (const n of Object.getOwnPropertySymbols(e))
      Object.prototype.propertyIsEnumerable.call(e, n) && dt(e[n], t, o);
  }
  return e;
}
/**
* @vue/runtime-core v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
const Ot = [];
function bo(e) {
  Ot.push(e);
}
function vo() {
  Ot.pop();
}
let Zo = !1;
function x(e, ...t) {
  if (Zo) return;
  Zo = !0, rt();
  const o = Ot.length ? Ot[Ot.length - 1].component : null, n = o && o.appContext.config.warnHandler, r = Wi();
  if (n)
    zt(
      n,
      o,
      11,
      [
        // eslint-disable-next-line no-restricted-syntax
        e + t.map((s) => {
          var l, a;
          return (a = (l = s.toString) == null ? void 0 : l.call(s)) != null ? a : JSON.stringify(s);
        }).join(""),
        o && o.proxy,
        r.map(
          ({ vnode: s }) => `at <${Go(o, s.type)}>`
        ).join(`
`),
        r
      ]
    );
  else {
    const s = [`[Vue warn]: ${e}`, ...t];
    r.length && s.push(`
`, ...Ki(r)), console.warn(...s);
  }
  st(), Zo = !1;
}
function Wi() {
  let e = Ot[Ot.length - 1];
  if (!e)
    return [];
  const t = [];
  for (; e; ) {
    const o = t[0];
    o && o.vnode === e ? o.recurseCount++ : t.push({
      vnode: e,
      recurseCount: 0
    });
    const n = e.component && e.component.parent;
    e = n && n.vnode;
  }
  return t;
}
function Ki(e) {
  const t = [];
  return e.forEach((o, n) => {
    t.push(...n === 0 ? [] : [`
`], ...qi(o));
  }), t;
}
function qi({ vnode: e, recurseCount: t }) {
  const o = t > 0 ? `... (${t} recursive calls)` : "", n = e.component ? e.component.parent == null : !1, r = ` at <${Go(
    e.component,
    e.type,
    n
  )}`, s = ">" + o;
  return e.props ? [r, ...Gi(e.props), s] : [r + s];
}
function Gi(e) {
  const t = [], o = Object.keys(e);
  return o.slice(0, 3).forEach((n) => {
    t.push(...os(n, e[n]));
  }), o.length > 3 && t.push(" ..."), t;
}
function os(e, t, o) {
  return Z(t) ? (t = JSON.stringify(t), o ? t : [`${e}=${t}`]) : typeof t == "number" || typeof t == "boolean" || t == null ? o ? t : [`${e}=${t}`] : se(t) ? (t = os(e, M(t.value), !0), o ? t : [`${e}=Ref<`, t, ">"]) : I(t) ? [`${e}=fn${t.name ? `<${t.name}>` : ""}`] : (t = M(t), o ? t : [`${e}=`, t]);
}
const kn = {
  sp: "serverPrefetch hook",
  bc: "beforeCreate hook",
  c: "created hook",
  bm: "beforeMount hook",
  m: "mounted hook",
  bu: "beforeUpdate hook",
  u: "updated",
  bum: "beforeUnmount hook",
  um: "unmounted hook",
  a: "activated hook",
  da: "deactivated hook",
  ec: "errorCaptured hook",
  rtc: "renderTracked hook",
  rtg: "renderTriggered hook",
  0: "setup function",
  1: "render function",
  2: "watcher getter",
  3: "watcher callback",
  4: "watcher cleanup function",
  5: "native event handler",
  6: "component event handler",
  7: "vnode hook",
  8: "directive hook",
  9: "transition hook",
  10: "app errorHandler",
  11: "app warnHandler",
  12: "ref function",
  13: "async component loader",
  14: "scheduler flush",
  15: "component update",
  16: "app unmount cleanup function"
};
function zt(e, t, o, n) {
  try {
    return n ? e(...n) : e();
  } catch (r) {
    so(r, t, o);
  }
}
function Ye(e, t, o, n) {
  if (I(e)) {
    const r = zt(e, t, o, n);
    return r && On(r) && r.catch((s) => {
      so(s, t, o);
    }), r;
  }
  if (T(e)) {
    const r = [];
    for (let s = 0; s < e.length; s++)
      r.push(Ye(e[s], t, o, n));
    return r;
  } else process.env.NODE_ENV !== "production" && x(
    `Invalid value type passed to callWithAsyncErrorHandling(): ${typeof e}`
  );
}
function so(e, t, o, n = !0) {
  const r = t ? t.vnode : null, { errorHandler: s, throwUnhandledErrorInProduction: l } = t && t.appContext.config || q;
  if (t) {
    let a = t.parent;
    const u = t.proxy, h = process.env.NODE_ENV !== "production" ? kn[o] : `https://vuejs.org/error-reference/#runtime-${o}`;
    for (; a; ) {
      const p = a.ec;
      if (p) {
        for (let d = 0; d < p.length; d++)
          if (p[d](e, u, h) === !1)
            return;
      }
      a = a.parent;
    }
    if (s) {
      rt(), zt(s, null, 10, [
        e,
        u,
        h
      ]), st();
      return;
    }
  }
  Ji(e, o, r, n, l);
}
function Ji(e, t, o, n = !0, r = !1) {
  if (process.env.NODE_ENV !== "production") {
    const s = kn[t];
    if (o && bo(o), x(`Unhandled error${s ? ` during execution of ${s}` : ""}`), o && vo(), n)
      throw e;
    console.error(e);
  } else {
    if (r)
      throw e;
    console.error(e);
  }
}
const ve = [];
let We = -1;
const Rt = [];
let ut = null, Pt = 0;
const ns = /* @__PURE__ */ Promise.resolve();
let Co = null;
const Yi = 100;
function rs(e) {
  const t = Co || ns;
  return e ? t.then(this ? e.bind(this) : e) : t;
}
function Xi(e) {
  let t = We + 1, o = ve.length;
  for (; t < o; ) {
    const n = t + o >>> 1, r = ve[n], s = eo(r);
    s < e || s === e && r.flags & 2 ? t = n + 1 : o = n;
  }
  return t;
}
function Wo(e) {
  if (!(e.flags & 1)) {
    const t = eo(e), o = ve[ve.length - 1];
    !o || // fast path when the job id is larger than the tail
    !(e.flags & 2) && t >= eo(o) ? ve.push(e) : ve.splice(Xi(t), 0, e), e.flags |= 1, ss();
  }
}
function ss() {
  Co || (Co = ns.then(cs));
}
function is(e) {
  T(e) ? Rt.push(...e) : ut && e.id === -1 ? ut.splice(Pt + 1, 0, e) : e.flags & 1 || (Rt.push(e), e.flags |= 1), ss();
}
function Zn(e, t, o = We + 1) {
  for (process.env.NODE_ENV !== "production" && (t = t || /* @__PURE__ */ new Map()); o < ve.length; o++) {
    const n = ve[o];
    if (n && n.flags & 2) {
      if (e && n.id !== e.uid || process.env.NODE_ENV !== "production" && In(t, n))
        continue;
      ve.splice(o, 1), o--, n.flags & 4 && (n.flags &= -2), n(), n.flags & 4 || (n.flags &= -2);
    }
  }
}
function ls(e) {
  if (Rt.length) {
    const t = [...new Set(Rt)].sort(
      (o, n) => eo(o) - eo(n)
    );
    if (Rt.length = 0, ut) {
      ut.push(...t);
      return;
    }
    for (ut = t, process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map()), Pt = 0; Pt < ut.length; Pt++) {
      const o = ut[Pt];
      process.env.NODE_ENV !== "production" && In(e, o) || (o.flags & 4 && (o.flags &= -2), o.flags & 8 || o(), o.flags &= -2);
    }
    ut = null, Pt = 0;
  }
}
const eo = (e) => e.id == null ? e.flags & 2 ? -1 : 1 / 0 : e.id;
function cs(e) {
  process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map());
  const t = process.env.NODE_ENV !== "production" ? (o) => In(e, o) : ue;
  try {
    for (We = 0; We < ve.length; We++) {
      const o = ve[We];
      if (o && !(o.flags & 8)) {
        if (process.env.NODE_ENV !== "production" && t(o))
          continue;
        o.flags & 4 && (o.flags &= -2), zt(
          o,
          o.i,
          o.i ? 15 : 14
        ), o.flags & 4 || (o.flags &= -2);
      }
    }
  } finally {
    for (; We < ve.length; We++) {
      const o = ve[We];
      o && (o.flags &= -2);
    }
    We = -1, ve.length = 0, ls(e), Co = null, (ve.length || Rt.length) && cs(e);
  }
}
function In(e, t) {
  const o = e.get(t) || 0;
  if (o > Yi) {
    const n = t.i, r = n && Ks(n.type);
    return so(
      `Maximum recursive updates exceeded${r ? ` in component <${r}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`,
      null,
      10
    ), !0;
  }
  return e.set(t, o + 1), !1;
}
let Ge = !1;
const _o = /* @__PURE__ */ new Map();
process.env.NODE_ENV !== "production" && (ro().__VUE_HMR_RUNTIME__ = {
  createRecord: en(as),
  rerender: en(el),
  reload: en(tl)
});
const St = /* @__PURE__ */ new Map();
function Qi(e) {
  const t = e.type.__hmrId;
  let o = St.get(t);
  o || (as(t, e.type), o = St.get(t)), o.instances.add(e);
}
function Zi(e) {
  St.get(e.type.__hmrId).instances.delete(e);
}
function as(e, t) {
  return St.has(e) ? !1 : (St.set(e, {
    initialDef: To(t),
    instances: /* @__PURE__ */ new Set()
  }), !0);
}
function To(e) {
  return qs(e) ? e.__vccOpts : e;
}
function el(e, t) {
  const o = St.get(e);
  o && (o.initialDef.render = t, [...o.instances].forEach((n) => {
    t && (n.render = t, To(n.type).render = t), n.renderCache = [], Ge = !0, n.update(), Ge = !1;
  }));
}
function tl(e, t) {
  const o = St.get(e);
  if (!o) return;
  t = To(t), er(o.initialDef, t);
  const n = [...o.instances];
  for (let r = 0; r < n.length; r++) {
    const s = n[r], l = To(s.type);
    let a = _o.get(l);
    a || (l !== o.initialDef && er(l, t), _o.set(l, a = /* @__PURE__ */ new Set())), a.add(s), s.appContext.propsCache.delete(s.type), s.appContext.emitsCache.delete(s.type), s.appContext.optionsCache.delete(s.type), s.ceReload ? (a.add(s), s.ceReload(t.styles), a.delete(s)) : s.parent ? Wo(() => {
      Ge = !0, s.parent.update(), Ge = !1, a.delete(s);
    }) : s.appContext.reload ? s.appContext.reload() : typeof window < "u" ? window.location.reload() : console.warn(
      "[HMR] Root or manually mounted instance modified. Full reload required."
    ), s.root.ce && s !== s.root && s.root.ce._removeChildStyle(l);
  }
  is(() => {
    _o.clear();
  });
}
function er(e, t) {
  te(e, t);
  for (const o in e)
    o !== "__file" && !(o in t) && delete e[o];
}
function en(e) {
  return (t, o) => {
    try {
      return e(t, o);
    } catch (n) {
      console.error(n), console.warn(
        "[HMR] Something went wrong during Vue component hot-reload. Full reload required."
      );
    }
  };
}
let Re, Kt = [], dn = !1;
function io(e, ...t) {
  Re ? Re.emit(e, ...t) : dn || Kt.push({ event: e, args: t });
}
function Pn(e, t) {
  var o, n;
  Re = e, Re ? (Re.enabled = !0, Kt.forEach(({ event: r, args: s }) => Re.emit(r, ...s)), Kt = []) : /* handle late devtools injection - only do this if we are in an actual */ /* browser environment to avoid the timer handle stalling test runner exit */ /* (#4815) */ typeof window < "u" && // some envs mock window but not fully
  window.HTMLElement && // also exclude jsdom
  // eslint-disable-next-line no-restricted-syntax
  !((n = (o = window.navigator) == null ? void 0 : o.userAgent) != null && n.includes("jsdom")) ? ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = t.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((s) => {
    Pn(s, t);
  }), setTimeout(() => {
    Re || (t.__VUE_DEVTOOLS_HOOK_REPLAY__ = null, dn = !0, Kt = []);
  }, 3e3)) : (dn = !0, Kt = []);
}
function ol(e, t) {
  io("app:init", e, t, {
    Fragment: ae,
    Text: lo,
    Comment: De,
    Static: Eo
  });
}
function nl(e) {
  io("app:unmount", e);
}
const rl = /* @__PURE__ */ $n(
  "component:added"
  /* COMPONENT_ADDED */
), us = /* @__PURE__ */ $n(
  "component:updated"
  /* COMPONENT_UPDATED */
), sl = /* @__PURE__ */ $n(
  "component:removed"
  /* COMPONENT_REMOVED */
), il = (e) => {
  Re && typeof Re.cleanupBuffer == "function" && // remove the component if it wasn't buffered
  !Re.cleanupBuffer(e) && sl(e);
};
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function $n(e) {
  return (t) => {
    io(
      e,
      t.appContext.app,
      t.uid,
      t.parent ? t.parent.uid : void 0,
      t
    );
  };
}
const ll = /* @__PURE__ */ fs(
  "perf:start"
  /* PERFORMANCE_START */
), cl = /* @__PURE__ */ fs(
  "perf:end"
  /* PERFORMANCE_END */
);
function fs(e) {
  return (t, o, n) => {
    io(e, t.appContext.app, t.uid, t, o, n);
  };
}
function al(e, t, o) {
  io(
    "component:emit",
    e.appContext.app,
    e,
    t,
    o
  );
}
let pe = null, ds = null;
function Ao(e) {
  const t = pe;
  return pe = e, ds = e && e.type.__scopeId || null, t;
}
function ps(e, t = pe, o) {
  if (!t || e._n)
    return e;
  const n = (...r) => {
    n._d && dr(-1);
    const s = Ao(t);
    let l;
    try {
      l = e(...r);
    } finally {
      Ao(s), n._d && dr(1);
    }
    return process.env.NODE_ENV !== "production" && us(t), l;
  };
  return n._n = !0, n._c = !0, n._d = !0, n;
}
function hs(e) {
  ei(e) && x("Do not use built-in directive ids as custom directive id: " + e);
}
function vt(e, t, o, n) {
  const r = e.dirs, s = t && t.dirs;
  for (let l = 0; l < r.length; l++) {
    const a = r[l];
    s && (a.oldValue = s[l].value);
    let u = a.dir[n];
    u && (rt(), Ye(u, o, 8, [
      e.el,
      a,
      e,
      t
    ]), st());
  }
}
const ul = Symbol("_vte"), fl = (e) => e.__isTeleport;
function Mn(e, t) {
  e.shapeFlag & 6 && e.component ? (e.transition = t, Mn(e.component.subTree, t)) : e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function dl(e, t) {
  return I(e) ? (
    // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    te({ name: e.name }, t, { setup: e })
  ) : e;
}
function gs(e) {
  e.ids = [e.ids[0] + e.ids[2]++ + "-", 0, 0];
}
const pl = /* @__PURE__ */ new WeakSet();
function ko(e, t, o, n, r = !1) {
  if (T(e)) {
    e.forEach(
      (V, $) => ko(
        V,
        t && (T(t) ? t[$] : t),
        o,
        n,
        r
      )
    );
    return;
  }
  if (jt(n) && !r) {
    n.shapeFlag & 512 && n.type.__asyncResolved && n.component.subTree.component && ko(e, t, o, n.component.subTree);
    return;
  }
  const s = n.shapeFlag & 4 ? Bn(n.component) : n.el, l = r ? null : s, { i: a, r: u } = e;
  if (process.env.NODE_ENV !== "production" && !a) {
    x(
      "Missing ref owner context. ref cannot be used on hoisted vnodes. A vnode with ref must be created inside the render function."
    );
    return;
  }
  const h = t && t.r, p = a.refs === q ? a.refs = {} : a.refs, d = a.setupState, b = M(d), N = d === q ? () => !1 : (V) => process.env.NODE_ENV !== "production" && (H(b, V) && !se(b[V]) && x(
    `Template ref "${V}" used on a non-ref value. It will not work in the production build.`
  ), pl.has(b[V])) ? !1 : H(b, V);
  if (h != null && h !== u && (Z(h) ? (p[h] = null, N(h) && (d[h] = null)) : se(h) && (h.value = null)), I(u))
    zt(u, a, 12, [l, p]);
  else {
    const V = Z(u), $ = se(u);
    if (V || $) {
      const ie = () => {
        if (e.f) {
          const U = V ? N(u) ? d[u] : p[u] : u.value;
          r ? T(U) && Nn(U, s) : T(U) ? U.includes(s) || U.push(s) : V ? (p[u] = [s], N(u) && (d[u] = p[u])) : (u.value = [s], e.k && (p[e.k] = u.value));
        } else V ? (p[u] = l, N(u) && (d[u] = l)) : $ ? (u.value = l, e.k && (p[e.k] = l)) : process.env.NODE_ENV !== "production" && x("Invalid template ref type:", u, `(${typeof u})`);
      };
      l ? (ie.id = -1, Ce(ie, o)) : ie();
    } else process.env.NODE_ENV !== "production" && x("Invalid template ref type:", u, `(${typeof u})`);
  }
}
ro().requestIdleCallback;
ro().cancelIdleCallback;
const jt = (e) => !!e.type.__asyncLoader, Rn = (e) => e.type.__isKeepAlive;
function hl(e, t) {
  ms(e, "a", t);
}
function gl(e, t) {
  ms(e, "da", t);
}
function ms(e, t, o = fe) {
  const n = e.__wdc || (e.__wdc = () => {
    let r = o;
    for (; r; ) {
      if (r.isDeactivated)
        return;
      r = r.parent;
    }
    return e();
  });
  if (Ko(t, n, o), o) {
    let r = o.parent;
    for (; r && r.parent; )
      Rn(r.parent.vnode) && ml(n, t, o, r), r = r.parent;
  }
}
function ml(e, t, o, n) {
  const r = Ko(
    t,
    e,
    n,
    !0
    /* prepend */
  );
  jn(() => {
    Nn(n[t], r);
  }, o);
}
function Ko(e, t, o = fe, n = !1) {
  if (o) {
    const r = o[e] || (o[e] = []), s = t.__weh || (t.__weh = (...l) => {
      rt();
      const a = ao(o), u = Ye(t, o, e, l);
      return a(), st(), u;
    });
    return n ? r.unshift(s) : r.push(s), s;
  } else if (process.env.NODE_ENV !== "production") {
    const r = yt(kn[e].replace(/ hook$/, ""));
    x(
      `${r} is called when there is no active component instance to be associated with. Lifecycle injection APIs can only be used during execution of setup(). If you are using async setup(), make sure to register lifecycle hooks before the first await statement.`
    );
  }
}
const it = (e) => (t, o = fe) => {
  (!oo || e === "sp") && Ko(e, (...n) => t(...n), o);
}, bl = it("bm"), bs = it("m"), vl = it(
  "bu"
), _l = it("u"), yl = it(
  "bum"
), jn = it("um"), wl = it(
  "sp"
), El = it("rtg"), xl = it("rtc");
function Nl(e, t = fe) {
  Ko("ec", e, t);
}
const Ol = Symbol.for("v-ndc");
function tn(e, t, o, n) {
  let r;
  const s = o, l = T(e);
  if (l || Z(e)) {
    const a = l && Nt(e);
    let u = !1;
    a && (u = !_e(e), e = Ho(e)), r = new Array(e.length);
    for (let h = 0, p = e.length; h < p; h++)
      r[h] = t(
        u ? ge(e[h]) : e[h],
        h,
        void 0,
        s
      );
  } else if (typeof e == "number") {
    process.env.NODE_ENV !== "production" && !Number.isInteger(e) && x(`The v-for range expect an integer value but got ${e}.`), r = new Array(e);
    for (let a = 0; a < e; a++)
      r[a] = t(a + 1, a, void 0, s);
  } else if (J(e))
    if (e[Symbol.iterator])
      r = Array.from(
        e,
        (a, u) => t(a, u, void 0, s)
      );
    else {
      const a = Object.keys(e);
      r = new Array(a.length);
      for (let u = 0, h = a.length; u < h; u++) {
        const p = a[u];
        r[u] = t(e[p], p, u, s);
      }
    }
  else
    r = [];
  return r;
}
function Dl(e, t, o = {}, n, r) {
  if (pe.ce || pe.parent && jt(pe.parent) && pe.parent.ce)
    return B(), _n(
      ae,
      null,
      [Ie("slot", o, n)],
      64
    );
  let s = e[t];
  process.env.NODE_ENV !== "production" && s && s.length > 1 && (x(
    "SSR-optimized slot function detected in a non-SSR-optimized render function. You need to mark this component with $dynamic-slots in the parent template."
  ), s = () => []), s && s._c && (s._d = !1), B();
  const l = s && vs(s(o)), a = o.key || // slot content array of a dynamic conditional slot may have a branch
  // key attached in the `createSlots` helper, respect that
  l && l.key, u = _n(
    ae,
    {
      key: (a && !nt(a) ? a : `_${t}`) + // #7256 force differentiate fallback content from actual content
      ""
    },
    l || [],
    l && e._ === 1 ? 64 : -2
  );
  return u.scopeId && (u.slotScopeIds = [u.scopeId + "-s"]), s && s._c && (s._d = !0), u;
}
function vs(e) {
  return e.some((t) => co(t) ? !(t.type === De || t.type === ae && !vs(t.children)) : !0) ? e : null;
}
const pn = (e) => e ? Us(e) ? Bn(e) : pn(e.parent) : null, Dt = (
  // Move PURE marker to new line to workaround compiler discarding it
  // due to type annotation
  /* @__PURE__ */ te(/* @__PURE__ */ Object.create(null), {
    $: (e) => e,
    $el: (e) => e.vnode.el,
    $data: (e) => e.data,
    $props: (e) => process.env.NODE_ENV !== "production" ? qe(e.props) : e.props,
    $attrs: (e) => process.env.NODE_ENV !== "production" ? qe(e.attrs) : e.attrs,
    $slots: (e) => process.env.NODE_ENV !== "production" ? qe(e.slots) : e.slots,
    $refs: (e) => process.env.NODE_ENV !== "production" ? qe(e.refs) : e.refs,
    $parent: (e) => pn(e.parent),
    $root: (e) => pn(e.root),
    $host: (e) => e.ce,
    $emit: (e) => e.emit,
    $options: (e) => ws(e),
    $forceUpdate: (e) => e.f || (e.f = () => {
      Wo(e.update);
    }),
    $nextTick: (e) => e.n || (e.n = rs.bind(e.proxy)),
    $watch: (e) => rc.bind(e)
  })
), Fn = (e) => e === "_" || e === "$", on = (e, t) => e !== q && !e.__isScriptSetup && H(e, t), _s = {
  get({ _: e }, t) {
    if (t === "__v_skip")
      return !0;
    const { ctx: o, setupState: n, data: r, props: s, accessCache: l, type: a, appContext: u } = e;
    if (process.env.NODE_ENV !== "production" && t === "__isVue")
      return !0;
    let h;
    if (t[0] !== "$") {
      const N = l[t];
      if (N !== void 0)
        switch (N) {
          case 1:
            return n[t];
          case 2:
            return r[t];
          case 4:
            return o[t];
          case 3:
            return s[t];
        }
      else {
        if (on(n, t))
          return l[t] = 1, n[t];
        if (r !== q && H(r, t))
          return l[t] = 2, r[t];
        if (
          // only cache other properties when instance has declared (thus stable)
          // props
          (h = e.propsOptions[0]) && H(h, t)
        )
          return l[t] = 3, s[t];
        if (o !== q && H(o, t))
          return l[t] = 4, o[t];
        hn && (l[t] = 0);
      }
    }
    const p = Dt[t];
    let d, b;
    if (p)
      return t === "$attrs" ? (ce(e.attrs, "get", ""), process.env.NODE_ENV !== "production" && $o()) : process.env.NODE_ENV !== "production" && t === "$slots" && ce(e, "get", t), p(e);
    if (
      // css module (injected by vue-loader)
      (d = a.__cssModules) && (d = d[t])
    )
      return d;
    if (o !== q && H(o, t))
      return l[t] = 4, o[t];
    if (
      // global properties
      b = u.config.globalProperties, H(b, t)
    )
      return b[t];
    process.env.NODE_ENV !== "production" && pe && (!Z(t) || // #1091 avoid internal isRef/isVNode checks on component instance leading
    // to infinite warning loop
    t.indexOf("__v") !== 0) && (r !== q && Fn(t[0]) && H(r, t) ? x(
      `Property ${JSON.stringify(
        t
      )} must be accessed via $data because it starts with a reserved character ("$" or "_") and is not proxied on the render context.`
    ) : e === pe && x(
      `Property ${JSON.stringify(t)} was accessed during render but is not defined on instance.`
    ));
  },
  set({ _: e }, t, o) {
    const { data: n, setupState: r, ctx: s } = e;
    return on(r, t) ? (r[t] = o, !0) : process.env.NODE_ENV !== "production" && r.__isScriptSetup && H(r, t) ? (x(`Cannot mutate <script setup> binding "${t}" from Options API.`), !1) : n !== q && H(n, t) ? (n[t] = o, !0) : H(e.props, t) ? (process.env.NODE_ENV !== "production" && x(`Attempting to mutate prop "${t}". Props are readonly.`), !1) : t[0] === "$" && t.slice(1) in e ? (process.env.NODE_ENV !== "production" && x(
      `Attempting to mutate public property "${t}". Properties starting with $ are reserved and readonly.`
    ), !1) : (process.env.NODE_ENV !== "production" && t in e.appContext.config.globalProperties ? Object.defineProperty(s, t, {
      enumerable: !0,
      configurable: !0,
      value: o
    }) : s[t] = o, !0);
  },
  has({
    _: { data: e, setupState: t, accessCache: o, ctx: n, appContext: r, propsOptions: s }
  }, l) {
    let a;
    return !!o[l] || e !== q && H(e, l) || on(t, l) || (a = s[0]) && H(a, l) || H(n, l) || H(Dt, l) || H(r.config.globalProperties, l);
  },
  defineProperty(e, t, o) {
    return o.get != null ? e._.accessCache[t] = 0 : H(o, "value") && this.set(e, t, o.value, null), Reflect.defineProperty(e, t, o);
  }
};
process.env.NODE_ENV !== "production" && (_s.ownKeys = (e) => (x(
  "Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead."
), Reflect.ownKeys(e)));
function Vl(e) {
  const t = {};
  return Object.defineProperty(t, "_", {
    configurable: !0,
    enumerable: !1,
    get: () => e
  }), Object.keys(Dt).forEach((o) => {
    Object.defineProperty(t, o, {
      configurable: !0,
      enumerable: !1,
      get: () => Dt[o](e),
      // intercepted by the proxy so no need for implementation,
      // but needed to prevent set errors
      set: ue
    });
  }), t;
}
function Sl(e) {
  const {
    ctx: t,
    propsOptions: [o]
  } = e;
  o && Object.keys(o).forEach((n) => {
    Object.defineProperty(t, n, {
      enumerable: !0,
      configurable: !0,
      get: () => e.props[n],
      set: ue
    });
  });
}
function Cl(e) {
  const { ctx: t, setupState: o } = e;
  Object.keys(M(o)).forEach((n) => {
    if (!o.__isScriptSetup) {
      if (Fn(n[0])) {
        x(
          `setup() return property ${JSON.stringify(
            n
          )} should not start with "$" or "_" which are reserved prefixes for Vue internals.`
        );
        return;
      }
      Object.defineProperty(t, n, {
        enumerable: !0,
        configurable: !0,
        get: () => o[n],
        set: ue
      });
    }
  });
}
function tr(e) {
  return T(e) ? e.reduce(
    (t, o) => (t[o] = null, t),
    {}
  ) : e;
}
function Tl() {
  const e = /* @__PURE__ */ Object.create(null);
  return (t, o) => {
    e[o] ? x(`${t} property "${o}" is already defined in ${e[o]}.`) : e[o] = t;
  };
}
let hn = !0;
function Al(e) {
  const t = ws(e), o = e.proxy, n = e.ctx;
  hn = !1, t.beforeCreate && or(t.beforeCreate, e, "bc");
  const {
    // state
    data: r,
    computed: s,
    methods: l,
    watch: a,
    provide: u,
    inject: h,
    // lifecycle
    created: p,
    beforeMount: d,
    mounted: b,
    beforeUpdate: N,
    updated: V,
    activated: $,
    deactivated: ie,
    beforeDestroy: U,
    beforeUnmount: D,
    destroyed: L,
    unmounted: ne,
    render: S,
    renderTracked: ee,
    renderTriggered: Q,
    errorCaptured: Y,
    serverPrefetch: R,
    // public API
    expose: ye,
    inheritAttrs: $e,
    // assets
    components: we,
    directives: Ct,
    filters: uo
  } = t, Fe = process.env.NODE_ENV !== "production" ? Tl() : null;
  if (process.env.NODE_ENV !== "production") {
    const [F] = e.propsOptions;
    if (F)
      for (const j in F)
        Fe("Props", j);
  }
  if (h && kl(h, n, Fe), l)
    for (const F in l) {
      const j = l[F];
      I(j) ? (process.env.NODE_ENV !== "production" ? Object.defineProperty(n, F, {
        value: j.bind(o),
        configurable: !0,
        enumerable: !0,
        writable: !0
      }) : n[F] = j.bind(o), process.env.NODE_ENV !== "production" && Fe("Methods", F)) : process.env.NODE_ENV !== "production" && x(
        `Method "${F}" has type "${typeof j}" in the component definition. Did you reference the function correctly?`
      );
    }
  if (r) {
    process.env.NODE_ENV !== "production" && !I(r) && x(
      "The data option must be a function. Plain object usage is no longer supported."
    );
    const F = r.call(o, o);
    if (process.env.NODE_ENV !== "production" && On(F) && x(
      "data() returned a Promise - note data() cannot be async; If you intend to perform data fetching before component renders, use async setup() + <Suspense>."
    ), !J(F))
      process.env.NODE_ENV !== "production" && x("data() should return an object.");
    else if (e.data = Bo(F), process.env.NODE_ENV !== "production")
      for (const j in F)
        Fe("Data", j), Fn(j[0]) || Object.defineProperty(n, j, {
          configurable: !0,
          enumerable: !0,
          get: () => F[j],
          set: ue
        });
  }
  if (hn = !0, s)
    for (const F in s) {
      const j = s[F], Ve = I(j) ? j.bind(o, o) : I(j.get) ? j.get.bind(o, o) : ue;
      process.env.NODE_ENV !== "production" && Ve === ue && x(`Computed property "${F}" has no getter.`);
      const Xe = !I(j) && I(j.set) ? j.set.bind(o) : process.env.NODE_ENV !== "production" ? () => {
        x(
          `Write operation failed: computed property "${F}" is readonly.`
        );
      } : ue, Qe = oe({
        get: Ve,
        set: Xe
      });
      Object.defineProperty(n, F, {
        enumerable: !0,
        configurable: !0,
        get: () => Qe.value,
        set: (lt) => Qe.value = lt
      }), process.env.NODE_ENV !== "production" && Fe("Computed", F);
    }
  if (a)
    for (const F in a)
      ys(a[F], n, o, F);
  if (u) {
    const F = I(u) ? u.call(o) : u;
    Reflect.ownKeys(F).forEach((j) => {
      xs(j, F[j]);
    });
  }
  p && or(p, e, "c");
  function de(F, j) {
    T(j) ? j.forEach((Ve) => F(Ve.bind(o))) : j && F(j.bind(o));
  }
  if (de(bl, d), de(bs, b), de(vl, N), de(_l, V), de(hl, $), de(gl, ie), de(Nl, Y), de(xl, ee), de(El, Q), de(yl, D), de(jn, ne), de(wl, R), T(ye))
    if (ye.length) {
      const F = e.exposed || (e.exposed = {});
      ye.forEach((j) => {
        Object.defineProperty(F, j, {
          get: () => o[j],
          set: (Ve) => o[j] = Ve
        });
      });
    } else e.exposed || (e.exposed = {});
  S && e.render === ue && (e.render = S), $e != null && (e.inheritAttrs = $e), we && (e.components = we), Ct && (e.directives = Ct), R && gs(e);
}
function kl(e, t, o = ue) {
  T(e) && (e = gn(e));
  for (const n in e) {
    const r = e[n];
    let s;
    J(r) ? "default" in r ? s = yo(
      r.from || n,
      r.default,
      !0
    ) : s = yo(r.from || n) : s = yo(r), se(s) ? Object.defineProperty(t, n, {
      enumerable: !0,
      configurable: !0,
      get: () => s.value,
      set: (l) => s.value = l
    }) : t[n] = s, process.env.NODE_ENV !== "production" && o("Inject", n);
  }
}
function or(e, t, o) {
  Ye(
    T(e) ? e.map((n) => n.bind(t.proxy)) : e.bind(t.proxy),
    t,
    o
  );
}
function ys(e, t, o, n) {
  let r = n.includes(".") ? $s(o, n) : () => o[n];
  if (Z(e)) {
    const s = t[e];
    I(s) ? Vt(r, s) : process.env.NODE_ENV !== "production" && x(`Invalid watch handler specified by key "${e}"`, s);
  } else if (I(e))
    Vt(r, e.bind(o));
  else if (J(e))
    if (T(e))
      e.forEach((s) => ys(s, t, o, n));
    else {
      const s = I(e.handler) ? e.handler.bind(o) : t[e.handler];
      I(s) ? Vt(r, s, e) : process.env.NODE_ENV !== "production" && x(`Invalid watch handler specified by key "${e.handler}"`, s);
    }
  else process.env.NODE_ENV !== "production" && x(`Invalid watch option: "${n}"`, e);
}
function ws(e) {
  const t = e.type, { mixins: o, extends: n } = t, {
    mixins: r,
    optionsCache: s,
    config: { optionMergeStrategies: l }
  } = e.appContext, a = s.get(t);
  let u;
  return a ? u = a : !r.length && !o && !n ? u = t : (u = {}, r.length && r.forEach(
    (h) => Io(u, h, l, !0)
  ), Io(u, t, l)), J(t) && s.set(t, u), u;
}
function Io(e, t, o, n = !1) {
  const { mixins: r, extends: s } = t;
  s && Io(e, s, o, !0), r && r.forEach(
    (l) => Io(e, l, o, !0)
  );
  for (const l in t)
    if (n && l === "expose")
      process.env.NODE_ENV !== "production" && x(
        '"expose" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.'
      );
    else {
      const a = Il[l] || o && o[l];
      e[l] = a ? a(e[l], t[l]) : t[l];
    }
  return e;
}
const Il = {
  data: nr,
  props: rr,
  emits: rr,
  // objects
  methods: qt,
  computed: qt,
  // lifecycle
  beforeCreate: be,
  created: be,
  beforeMount: be,
  mounted: be,
  beforeUpdate: be,
  updated: be,
  beforeDestroy: be,
  beforeUnmount: be,
  destroyed: be,
  unmounted: be,
  activated: be,
  deactivated: be,
  errorCaptured: be,
  serverPrefetch: be,
  // assets
  components: qt,
  directives: qt,
  // watch
  watch: $l,
  // provide / inject
  provide: nr,
  inject: Pl
};
function nr(e, t) {
  return t ? e ? function() {
    return te(
      I(e) ? e.call(this, this) : e,
      I(t) ? t.call(this, this) : t
    );
  } : t : e;
}
function Pl(e, t) {
  return qt(gn(e), gn(t));
}
function gn(e) {
  if (T(e)) {
    const t = {};
    for (let o = 0; o < e.length; o++)
      t[e[o]] = e[o];
    return t;
  }
  return e;
}
function be(e, t) {
  return e ? [...new Set([].concat(e, t))] : t;
}
function qt(e, t) {
  return e ? te(/* @__PURE__ */ Object.create(null), e, t) : t;
}
function rr(e, t) {
  return e ? T(e) && T(t) ? [.../* @__PURE__ */ new Set([...e, ...t])] : te(
    /* @__PURE__ */ Object.create(null),
    tr(e),
    tr(t ?? {})
  ) : t;
}
function $l(e, t) {
  if (!e) return t;
  if (!t) return e;
  const o = te(/* @__PURE__ */ Object.create(null), e);
  for (const n in t)
    o[n] = be(e[n], t[n]);
  return o;
}
function Es() {
  return {
    app: null,
    config: {
      isNativeTag: Qs,
      performance: !1,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let Ml = 0;
function Rl(e, t) {
  return function(n, r = null) {
    I(n) || (n = te({}, n)), r != null && !J(r) && (process.env.NODE_ENV !== "production" && x("root props passed to app.mount() must be an object."), r = null);
    const s = Es(), l = /* @__PURE__ */ new WeakSet(), a = [];
    let u = !1;
    const h = s.app = {
      _uid: Ml++,
      _component: n,
      _props: r,
      _container: null,
      _context: s,
      _instance: null,
      version: mr,
      get config() {
        return s.config;
      },
      set config(p) {
        process.env.NODE_ENV !== "production" && x(
          "app.config cannot be replaced. Modify individual options instead."
        );
      },
      use(p, ...d) {
        return l.has(p) ? process.env.NODE_ENV !== "production" && x("Plugin has already been applied to target app.") : p && I(p.install) ? (l.add(p), p.install(h, ...d)) : I(p) ? (l.add(p), p(h, ...d)) : process.env.NODE_ENV !== "production" && x(
          'A plugin must either be a function or an object with an "install" function.'
        ), h;
      },
      mixin(p) {
        return s.mixins.includes(p) ? process.env.NODE_ENV !== "production" && x(
          "Mixin has already been applied to target app" + (p.name ? `: ${p.name}` : "")
        ) : s.mixins.push(p), h;
      },
      component(p, d) {
        return process.env.NODE_ENV !== "production" && wn(p, s.config), d ? (process.env.NODE_ENV !== "production" && s.components[p] && x(`Component "${p}" has already been registered in target app.`), s.components[p] = d, h) : s.components[p];
      },
      directive(p, d) {
        return process.env.NODE_ENV !== "production" && hs(p), d ? (process.env.NODE_ENV !== "production" && s.directives[p] && x(`Directive "${p}" has already been registered in target app.`), s.directives[p] = d, h) : s.directives[p];
      },
      mount(p, d, b) {
        if (u)
          process.env.NODE_ENV !== "production" && x(
            "App has already been mounted.\nIf you want to remount the same app, move your app creation logic into a factory function and create fresh app instances for each mount - e.g. `const createMyApp = () => createApp(App)`"
          );
        else {
          process.env.NODE_ENV !== "production" && p.__vue_app__ && x(
            "There is already an app instance mounted on the host container.\n If you want to mount another app on the same host container, you need to unmount the previous app by calling `app.unmount()` first."
          );
          const N = h._ceVNode || Ie(n, r);
          return N.appContext = s, b === !0 ? b = "svg" : b === !1 && (b = void 0), process.env.NODE_ENV !== "production" && (s.reload = () => {
            e(
              gt(N),
              p,
              b
            );
          }), e(N, p, b), u = !0, h._container = p, p.__vue_app__ = h, process.env.NODE_ENV !== "production" && (h._instance = N.component, ol(h, mr)), Bn(N.component);
        }
      },
      onUnmount(p) {
        process.env.NODE_ENV !== "production" && typeof p != "function" && x(
          `Expected function as first argument to app.onUnmount(), but got ${typeof p}`
        ), a.push(p);
      },
      unmount() {
        u ? (Ye(
          a,
          h._instance,
          16
        ), e(null, h._container), process.env.NODE_ENV !== "production" && (h._instance = null, nl(h)), delete h._container.__vue_app__) : process.env.NODE_ENV !== "production" && x("Cannot unmount an app that is not mounted.");
      },
      provide(p, d) {
        return process.env.NODE_ENV !== "production" && p in s.provides && x(
          `App already provides property with key "${String(p)}". It will be overwritten with the new value.`
        ), s.provides[p] = d, h;
      },
      runWithContext(p) {
        const d = Ft;
        Ft = h;
        try {
          return p();
        } finally {
          Ft = d;
        }
      }
    };
    return h;
  };
}
let Ft = null;
function xs(e, t) {
  if (!fe)
    process.env.NODE_ENV !== "production" && x("provide() can only be used inside setup().");
  else {
    let o = fe.provides;
    const n = fe.parent && fe.parent.provides;
    n === o && (o = fe.provides = Object.create(n)), o[e] = t;
  }
}
function yo(e, t, o = !1) {
  const n = fe || pe;
  if (n || Ft) {
    const r = Ft ? Ft._context.provides : n ? n.parent == null ? n.vnode.appContext && n.vnode.appContext.provides : n.parent.provides : void 0;
    if (r && e in r)
      return r[e];
    if (arguments.length > 1)
      return o && I(t) ? t.call(n && n.proxy) : t;
    process.env.NODE_ENV !== "production" && x(`injection "${String(e)}" not found.`);
  } else process.env.NODE_ENV !== "production" && x("inject() can only be used inside setup() or functional components.");
}
const Ns = {}, Os = () => Object.create(Ns), Ds = (e) => Object.getPrototypeOf(e) === Ns;
function jl(e, t, o, n = !1) {
  const r = {}, s = Os();
  e.propsDefaults = /* @__PURE__ */ Object.create(null), Vs(e, t, r, s);
  for (const l in e.propsOptions[0])
    l in r || (r[l] = void 0);
  process.env.NODE_ENV !== "production" && Cs(t || {}, r, e), o ? e.props = n ? r : Mi(r) : e.type.props ? e.props = r : e.props = s, e.attrs = s;
}
function Fl(e) {
  for (; e; ) {
    if (e.type.__hmrId) return !0;
    e = e.parent;
  }
}
function zl(e, t, o, n) {
  const {
    props: r,
    attrs: s,
    vnode: { patchFlag: l }
  } = e, a = M(r), [u] = e.propsOptions;
  let h = !1;
  if (
    // always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    !(process.env.NODE_ENV !== "production" && Fl(e)) && (n || l > 0) && !(l & 16)
  ) {
    if (l & 8) {
      const p = e.vnode.dynamicProps;
      for (let d = 0; d < p.length; d++) {
        let b = p[d];
        if (qo(e.emitsOptions, b))
          continue;
        const N = t[b];
        if (u)
          if (H(s, b))
            N !== s[b] && (s[b] = N, h = !0);
          else {
            const V = Oe(b);
            r[V] = mn(
              u,
              a,
              V,
              N,
              e,
              !1
            );
          }
        else
          N !== s[b] && (s[b] = N, h = !0);
      }
    }
  } else {
    Vs(e, t, r, s) && (h = !0);
    let p;
    for (const d in a)
      (!t || // for camelCase
      !H(t, d) && // it's possible the original props was passed in as kebab-case
      // and converted to camelCase (#955)
      ((p = Ae(d)) === d || !H(t, p))) && (u ? o && // for camelCase
      (o[d] !== void 0 || // for kebab-case
      o[p] !== void 0) && (r[d] = mn(
        u,
        a,
        d,
        void 0,
        e,
        !0
      )) : delete r[d]);
    if (s !== a)
      for (const d in s)
        (!t || !H(t, d)) && (delete s[d], h = !0);
  }
  h && Ke(e.attrs, "set", ""), process.env.NODE_ENV !== "production" && Cs(t || {}, r, e);
}
function Vs(e, t, o, n) {
  const [r, s] = e.propsOptions;
  let l = !1, a;
  if (t)
    for (let u in t) {
      if (Gt(u))
        continue;
      const h = t[u];
      let p;
      r && H(r, p = Oe(u)) ? !s || !s.includes(p) ? o[p] = h : (a || (a = {}))[p] = h : qo(e.emitsOptions, u) || (!(u in n) || h !== n[u]) && (n[u] = h, l = !0);
    }
  if (s) {
    const u = M(o), h = a || q;
    for (let p = 0; p < s.length; p++) {
      const d = s[p];
      o[d] = mn(
        r,
        u,
        d,
        h[d],
        e,
        !H(h, d)
      );
    }
  }
  return l;
}
function mn(e, t, o, n, r, s) {
  const l = e[o];
  if (l != null) {
    const a = H(l, "default");
    if (a && n === void 0) {
      const u = l.default;
      if (l.type !== Function && !l.skipFactory && I(u)) {
        const { propsDefaults: h } = r;
        if (o in h)
          n = h[o];
        else {
          const p = ao(r);
          n = h[o] = u.call(
            null,
            t
          ), p();
        }
      } else
        n = u;
      r.ce && r.ce._setProp(o, n);
    }
    l[
      0
      /* shouldCast */
    ] && (s && !a ? n = !1 : l[
      1
      /* shouldCastTrue */
    ] && (n === "" || n === Ae(o)) && (n = !0));
  }
  return n;
}
const Hl = /* @__PURE__ */ new WeakMap();
function Ss(e, t, o = !1) {
  const n = o ? Hl : t.propsCache, r = n.get(e);
  if (r)
    return r;
  const s = e.props, l = {}, a = [];
  let u = !1;
  if (!I(e)) {
    const p = (d) => {
      u = !0;
      const [b, N] = Ss(d, t, !0);
      te(l, b), N && a.push(...N);
    };
    !o && t.mixins.length && t.mixins.forEach(p), e.extends && p(e.extends), e.mixins && e.mixins.forEach(p);
  }
  if (!s && !u)
    return J(e) && n.set(e, $t), $t;
  if (T(s))
    for (let p = 0; p < s.length; p++) {
      process.env.NODE_ENV !== "production" && !Z(s[p]) && x("props must be strings when using array syntax.", s[p]);
      const d = Oe(s[p]);
      sr(d) && (l[d] = q);
    }
  else if (s) {
    process.env.NODE_ENV !== "production" && !J(s) && x("invalid props options", s);
    for (const p in s) {
      const d = Oe(p);
      if (sr(d)) {
        const b = s[p], N = l[d] = T(b) || I(b) ? { type: b } : te({}, b), V = N.type;
        let $ = !1, ie = !0;
        if (T(V))
          for (let U = 0; U < V.length; ++U) {
            const D = V[U], L = I(D) && D.name;
            if (L === "Boolean") {
              $ = !0;
              break;
            } else L === "String" && (ie = !1);
          }
        else
          $ = I(V) && V.name === "Boolean";
        N[
          0
          /* shouldCast */
        ] = $, N[
          1
          /* shouldCastTrue */
        ] = ie, ($ || H(N, "default")) && a.push(d);
      }
    }
  }
  const h = [l, a];
  return J(e) && n.set(e, h), h;
}
function sr(e) {
  return e[0] !== "$" && !Gt(e) ? !0 : (process.env.NODE_ENV !== "production" && x(`Invalid prop name: "${e}" is a reserved property.`), !1);
}
function Ll(e) {
  return e === null ? "null" : typeof e == "function" ? e.name || "" : typeof e == "object" && e.constructor && e.constructor.name || "";
}
function Cs(e, t, o) {
  const n = M(t), r = o.propsOptions[0], s = Object.keys(e).map((l) => Oe(l));
  for (const l in r) {
    let a = r[l];
    a != null && Bl(
      l,
      n[l],
      a,
      process.env.NODE_ENV !== "production" ? qe(n) : n,
      !s.includes(l)
    );
  }
}
function Bl(e, t, o, n, r) {
  const { type: s, required: l, validator: a, skipCheck: u } = o;
  if (l && r) {
    x('Missing required prop: "' + e + '"');
    return;
  }
  if (!(t == null && !l)) {
    if (s != null && s !== !0 && !u) {
      let h = !1;
      const p = T(s) ? s : [s], d = [];
      for (let b = 0; b < p.length && !h; b++) {
        const { valid: N, expectedType: V } = Wl(t, p[b]);
        d.push(V || ""), h = N;
      }
      if (!h) {
        x(Kl(e, t, d));
        return;
      }
    }
    a && !a(t, n) && x('Invalid prop: custom validator check failed for prop "' + e + '".');
  }
}
const Ul = /* @__PURE__ */ ot(
  "String,Number,Boolean,Function,Symbol,BigInt"
);
function Wl(e, t) {
  let o;
  const n = Ll(t);
  if (n === "null")
    o = e === null;
  else if (Ul(n)) {
    const r = typeof e;
    o = r === n.toLowerCase(), !o && r === "object" && (o = e instanceof t);
  } else n === "Object" ? o = J(e) : n === "Array" ? o = T(e) : o = e instanceof t;
  return {
    valid: o,
    expectedType: n
  };
}
function Kl(e, t, o) {
  if (o.length === 0)
    return `Prop type [] for prop "${e}" won't match anything. Did you mean to use type Array instead?`;
  let n = `Invalid prop: type check failed for prop "${e}". Expected ${o.map(zo).join(" | ")}`;
  const r = o[0], s = Dn(t), l = ir(t, r), a = ir(t, s);
  return o.length === 1 && lr(r) && !ql(r, s) && (n += ` with value ${l}`), n += `, got ${s} `, lr(s) && (n += `with value ${a}.`), n;
}
function ir(e, t) {
  return t === "String" ? `"${e}"` : t === "Number" ? `${Number(e)}` : `${e}`;
}
function lr(e) {
  return ["string", "number", "boolean"].some((o) => e.toLowerCase() === o);
}
function ql(...e) {
  return e.some((t) => t.toLowerCase() === "boolean");
}
const Ts = (e) => e[0] === "_" || e === "$stable", zn = (e) => T(e) ? e.map(Me) : [Me(e)], Gl = (e, t, o) => {
  if (t._n)
    return t;
  const n = ps((...r) => (process.env.NODE_ENV !== "production" && fe && (!o || o.root === fe.root) && x(
    `Slot "${e}" invoked outside of the render function: this will not track dependencies used in the slot. Invoke the slot function inside the render function instead.`
  ), zn(t(...r))), o);
  return n._c = !1, n;
}, As = (e, t, o) => {
  const n = e._ctx;
  for (const r in e) {
    if (Ts(r)) continue;
    const s = e[r];
    if (I(s))
      t[r] = Gl(r, s, n);
    else if (s != null) {
      process.env.NODE_ENV !== "production" && x(
        `Non-function value encountered for slot "${r}". Prefer function slots for better performance.`
      );
      const l = zn(s);
      t[r] = () => l;
    }
  }
}, ks = (e, t) => {
  process.env.NODE_ENV !== "production" && !Rn(e.vnode) && x(
    "Non-function value encountered for default slot. Prefer function slots for better performance."
  );
  const o = zn(t);
  e.slots.default = () => o;
}, bn = (e, t, o) => {
  for (const n in t)
    (o || n !== "_") && (e[n] = t[n]);
}, Jl = (e, t, o) => {
  const n = e.slots = Os();
  if (e.vnode.shapeFlag & 32) {
    const r = t._;
    r ? (bn(n, t, o), o && Do(n, "_", r, !0)) : As(t, n);
  } else t && ks(e, t);
}, Yl = (e, t, o) => {
  const { vnode: n, slots: r } = e;
  let s = !0, l = q;
  if (n.shapeFlag & 32) {
    const a = t._;
    a ? process.env.NODE_ENV !== "production" && Ge ? (bn(r, t, o), Ke(e, "set", "$slots")) : o && a === 1 ? s = !1 : bn(r, t, o) : (s = !t.$stable, As(t, r)), l = t;
  } else t && (ks(e, t), l = { default: 1 });
  if (s)
    for (const a in r)
      !Ts(a) && l[a] == null && delete r[a];
};
let Ut, pt;
function kt(e, t) {
  e.appContext.config.performance && Po() && pt.mark(`vue-${t}-${e.uid}`), process.env.NODE_ENV !== "production" && ll(e, t, Po() ? pt.now() : Date.now());
}
function It(e, t) {
  if (e.appContext.config.performance && Po()) {
    const o = `vue-${t}-${e.uid}`, n = o + ":end";
    pt.mark(n), pt.measure(
      `<${Go(e, e.type)}> ${t}`,
      o,
      n
    ), pt.clearMarks(o), pt.clearMarks(n);
  }
  process.env.NODE_ENV !== "production" && cl(e, t, Po() ? pt.now() : Date.now());
}
function Po() {
  return Ut !== void 0 || (typeof window < "u" && window.performance ? (Ut = !0, pt = window.performance) : Ut = !1), Ut;
}
function Xl() {
  const e = [];
  if (process.env.NODE_ENV !== "production" && e.length) {
    const t = e.length > 1;
    console.warn(
      `Feature flag${t ? "s" : ""} ${e.join(", ")} ${t ? "are" : "is"} not explicitly defined. You are running the esm-bundler build of Vue, which expects these compile-time feature flags to be globally injected via the bundler config in order to get better tree-shaking in the production bundle.

For more details, see https://link.vuejs.org/feature-flags.`
    );
  }
}
const Ce = fc;
function Ql(e) {
  return Zl(e);
}
function Zl(e, t) {
  Xl();
  const o = ro();
  o.__VUE__ = !0, process.env.NODE_ENV !== "production" && Pn(o.__VUE_DEVTOOLS_GLOBAL_HOOK__, o);
  const {
    insert: n,
    remove: r,
    patchProp: s,
    createElement: l,
    createText: a,
    createComment: u,
    setText: h,
    setElementText: p,
    parentNode: d,
    nextSibling: b,
    setScopeId: N = ue,
    insertStaticContent: V
  } = e, $ = (i, c, f, g = null, m = null, v = null, _ = void 0, w = null, E = process.env.NODE_ENV !== "production" && Ge ? !1 : !!c.dynamicChildren) => {
    if (i === c)
      return;
    i && !Wt(i, c) && (g = Tt(i), ze(i, m, v, !0), i = null), c.patchFlag === -2 && (E = !1, c.dynamicChildren = null);
    const { type: y, ref: A, shapeFlag: O } = c;
    switch (y) {
      case lo:
        ie(i, c, f, g);
        break;
      case De:
        U(i, c, f, g);
        break;
      case Eo:
        i == null ? D(c, f, g, _) : process.env.NODE_ENV !== "production" && L(i, c, f, _);
        break;
      case ae:
        Ct(
          i,
          c,
          f,
          g,
          m,
          v,
          _,
          w,
          E
        );
        break;
      default:
        O & 1 ? ee(
          i,
          c,
          f,
          g,
          m,
          v,
          _,
          w,
          E
        ) : O & 6 ? uo(
          i,
          c,
          f,
          g,
          m,
          v,
          _,
          w,
          E
        ) : O & 64 || O & 128 ? y.process(
          i,
          c,
          f,
          g,
          m,
          v,
          _,
          w,
          E,
          xe
        ) : process.env.NODE_ENV !== "production" && x("Invalid VNode type:", y, `(${typeof y})`);
    }
    A != null && m && ko(A, i && i.ref, v, c || i, !c);
  }, ie = (i, c, f, g) => {
    if (i == null)
      n(
        c.el = a(c.children),
        f,
        g
      );
    else {
      const m = c.el = i.el;
      c.children !== i.children && h(m, c.children);
    }
  }, U = (i, c, f, g) => {
    i == null ? n(
      c.el = u(c.children || ""),
      f,
      g
    ) : c.el = i.el;
  }, D = (i, c, f, g) => {
    [i.el, i.anchor] = V(
      i.children,
      c,
      f,
      g,
      i.el,
      i.anchor
    );
  }, L = (i, c, f, g) => {
    if (c.children !== i.children) {
      const m = b(i.anchor);
      S(i), [c.el, c.anchor] = V(
        c.children,
        f,
        m,
        g
      );
    } else
      c.el = i.el, c.anchor = i.anchor;
  }, ne = ({ el: i, anchor: c }, f, g) => {
    let m;
    for (; i && i !== c; )
      m = b(i), n(i, f, g), i = m;
    n(c, f, g);
  }, S = ({ el: i, anchor: c }) => {
    let f;
    for (; i && i !== c; )
      f = b(i), r(i), i = f;
    r(c);
  }, ee = (i, c, f, g, m, v, _, w, E) => {
    c.type === "svg" ? _ = "svg" : c.type === "math" && (_ = "mathml"), i == null ? Q(
      c,
      f,
      g,
      m,
      v,
      _,
      w,
      E
    ) : ye(
      i,
      c,
      m,
      v,
      _,
      w,
      E
    );
  }, Q = (i, c, f, g, m, v, _, w) => {
    let E, y;
    const { props: A, shapeFlag: O, transition: C, dirs: P } = i;
    if (E = i.el = l(
      i.type,
      v,
      A && A.is,
      A
    ), O & 8 ? p(E, i.children) : O & 16 && R(
      i.children,
      E,
      null,
      g,
      m,
      nn(i, v),
      _,
      w
    ), P && vt(i, null, g, "created"), Y(E, i, i.scopeId, _, g), A) {
      for (const X in A)
        X !== "value" && !Gt(X) && s(E, X, null, A[X], v, g);
      "value" in A && s(E, "value", null, A.value, v), (y = A.onVnodeBeforeMount) && Ue(y, g, i);
    }
    process.env.NODE_ENV !== "production" && (Do(E, "__vnode", i, !0), Do(E, "__vueParentComponent", g, !0)), P && vt(i, null, g, "beforeMount");
    const z = ec(m, C);
    z && C.beforeEnter(E), n(E, c, f), ((y = A && A.onVnodeMounted) || z || P) && Ce(() => {
      y && Ue(y, g, i), z && C.enter(E), P && vt(i, null, g, "mounted");
    }, m);
  }, Y = (i, c, f, g, m) => {
    if (f && N(i, f), g)
      for (let v = 0; v < g.length; v++)
        N(i, g[v]);
    if (m) {
      let v = m.subTree;
      if (process.env.NODE_ENV !== "production" && v.patchFlag > 0 && v.patchFlag & 2048 && (v = Hn(v.children) || v), c === v || js(v.type) && (v.ssContent === c || v.ssFallback === c)) {
        const _ = m.vnode;
        Y(
          i,
          _,
          _.scopeId,
          _.slotScopeIds,
          m.parent
        );
      }
    }
  }, R = (i, c, f, g, m, v, _, w, E = 0) => {
    for (let y = E; y < i.length; y++) {
      const A = i[y] = w ? ft(i[y]) : Me(i[y]);
      $(
        null,
        A,
        c,
        f,
        g,
        m,
        v,
        _,
        w
      );
    }
  }, ye = (i, c, f, g, m, v, _) => {
    const w = c.el = i.el;
    process.env.NODE_ENV !== "production" && (w.__vnode = c);
    let { patchFlag: E, dynamicChildren: y, dirs: A } = c;
    E |= i.patchFlag & 16;
    const O = i.props || q, C = c.props || q;
    let P;
    if (f && _t(f, !1), (P = C.onVnodeBeforeUpdate) && Ue(P, f, c, i), A && vt(c, i, f, "beforeUpdate"), f && _t(f, !0), process.env.NODE_ENV !== "production" && Ge && (E = 0, _ = !1, y = null), (O.innerHTML && C.innerHTML == null || O.textContent && C.textContent == null) && p(w, ""), y ? ($e(
      i.dynamicChildren,
      y,
      w,
      f,
      g,
      nn(c, m),
      v
    ), process.env.NODE_ENV !== "production" && wo(i, c)) : _ || Ve(
      i,
      c,
      w,
      null,
      f,
      g,
      nn(c, m),
      v,
      !1
    ), E > 0) {
      if (E & 16)
        we(w, O, C, f, m);
      else if (E & 2 && O.class !== C.class && s(w, "class", null, C.class, m), E & 4 && s(w, "style", O.style, C.style, m), E & 8) {
        const z = c.dynamicProps;
        for (let X = 0; X < z.length; X++) {
          const K = z[X], Se = O[K], Ne = C[K];
          (Ne !== Se || K === "value") && s(w, K, Se, Ne, m, f);
        }
      }
      E & 1 && i.children !== c.children && p(w, c.children);
    } else !_ && y == null && we(w, O, C, f, m);
    ((P = C.onVnodeUpdated) || A) && Ce(() => {
      P && Ue(P, f, c, i), A && vt(c, i, f, "updated");
    }, g);
  }, $e = (i, c, f, g, m, v, _) => {
    for (let w = 0; w < c.length; w++) {
      const E = i[w], y = c[w], A = (
        // oldVNode may be an errored async setup() component inside Suspense
        // which will not have a mounted element
        E.el && // - In the case of a Fragment, we need to provide the actual parent
        // of the Fragment itself so it can move its children.
        (E.type === ae || // - In the case of different nodes, there is going to be a replacement
        // which also requires the correct parent container
        !Wt(E, y) || // - In the case of a component, it could contain anything.
        E.shapeFlag & 70) ? d(E.el) : (
          // In other cases, the parent container is not actually used so we
          // just pass the block element here to avoid a DOM parentNode call.
          f
        )
      );
      $(
        E,
        y,
        A,
        null,
        g,
        m,
        v,
        _,
        !0
      );
    }
  }, we = (i, c, f, g, m) => {
    if (c !== f) {
      if (c !== q)
        for (const v in c)
          !Gt(v) && !(v in f) && s(
            i,
            v,
            c[v],
            null,
            m,
            g
          );
      for (const v in f) {
        if (Gt(v)) continue;
        const _ = f[v], w = c[v];
        _ !== w && v !== "value" && s(i, v, w, _, m, g);
      }
      "value" in f && s(i, "value", c.value, f.value, m);
    }
  }, Ct = (i, c, f, g, m, v, _, w, E) => {
    const y = c.el = i ? i.el : a(""), A = c.anchor = i ? i.anchor : a("");
    let { patchFlag: O, dynamicChildren: C, slotScopeIds: P } = c;
    process.env.NODE_ENV !== "production" && // #5523 dev root fragment may inherit directives
    (Ge || O & 2048) && (O = 0, E = !1, C = null), P && (w = w ? w.concat(P) : P), i == null ? (n(y, f, g), n(A, f, g), R(
      // #10007
      // such fragment like `<></>` will be compiled into
      // a fragment which doesn't have a children.
      // In this case fallback to an empty array
      c.children || [],
      f,
      A,
      m,
      v,
      _,
      w,
      E
    )) : O > 0 && O & 64 && C && // #2715 the previous fragment could've been a BAILed one as a result
    // of renderSlot() with no valid children
    i.dynamicChildren ? ($e(
      i.dynamicChildren,
      C,
      f,
      m,
      v,
      _,
      w
    ), process.env.NODE_ENV !== "production" ? wo(i, c) : (
      // #2080 if the stable fragment has a key, it's a <template v-for> that may
      //  get moved around. Make sure all root level vnodes inherit el.
      // #2134 or if it's a component root, it may also get moved around
      // as the component is being moved.
      (c.key != null || m && c === m.subTree) && wo(
        i,
        c,
        !0
        /* shallow */
      )
    )) : Ve(
      i,
      c,
      f,
      A,
      m,
      v,
      _,
      w,
      E
    );
  }, uo = (i, c, f, g, m, v, _, w, E) => {
    c.slotScopeIds = w, i == null ? c.shapeFlag & 512 ? m.ctx.activate(
      c,
      f,
      g,
      _,
      E
    ) : Fe(
      c,
      f,
      g,
      m,
      v,
      _,
      E
    ) : de(i, c, E);
  }, Fe = (i, c, f, g, m, v, _) => {
    const w = i.component = vc(
      i,
      g,
      m
    );
    if (process.env.NODE_ENV !== "production" && w.type.__hmrId && Qi(w), process.env.NODE_ENV !== "production" && (bo(i), kt(w, "mount")), Rn(i) && (w.ctx.renderer = xe), process.env.NODE_ENV !== "production" && kt(w, "init"), wc(w, !1, _), process.env.NODE_ENV !== "production" && It(w, "init"), w.asyncDep) {
      if (process.env.NODE_ENV !== "production" && Ge && (i.el = null), m && m.registerDep(w, F, _), !i.el) {
        const E = w.subTree = Ie(De);
        U(null, E, c, f);
      }
    } else
      F(
        w,
        i,
        c,
        f,
        m,
        v,
        _
      );
    process.env.NODE_ENV !== "production" && (vo(), It(w, "mount"));
  }, de = (i, c, f) => {
    const g = c.component = i.component;
    if (ac(i, c, f))
      if (g.asyncDep && !g.asyncResolved) {
        process.env.NODE_ENV !== "production" && bo(c), j(g, c, f), process.env.NODE_ENV !== "production" && vo();
        return;
      } else
        g.next = c, g.update();
    else
      c.el = i.el, g.vnode = c;
  }, F = (i, c, f, g, m, v, _) => {
    const w = () => {
      if (i.isMounted) {
        let { next: O, bu: C, u: P, parent: z, vnode: X } = i;
        {
          const Le = Is(i);
          if (Le) {
            O && (O.el = X.el, j(i, O, _)), Le.asyncDep.then(() => {
              i.isUnmounted || w();
            });
            return;
          }
        }
        let K = O, Se;
        process.env.NODE_ENV !== "production" && bo(O || i.vnode), _t(i, !1), O ? (O.el = X.el, j(i, O, _)) : O = X, C && Lt(C), (Se = O.props && O.props.onVnodeBeforeUpdate) && Ue(Se, z, O, X), _t(i, !0), process.env.NODE_ENV !== "production" && kt(i, "render");
        const Ne = ar(i);
        process.env.NODE_ENV !== "production" && It(i, "render");
        const He = i.subTree;
        i.subTree = Ne, process.env.NODE_ENV !== "production" && kt(i, "patch"), $(
          He,
          Ne,
          // parent may have changed if it's in a teleport
          d(He.el),
          // anchor may have changed if it's in a fragment
          Tt(He),
          i,
          m,
          v
        ), process.env.NODE_ENV !== "production" && It(i, "patch"), O.el = Ne.el, K === null && uc(i, Ne.el), P && Ce(P, m), (Se = O.props && O.props.onVnodeUpdated) && Ce(
          () => Ue(Se, z, O, X),
          m
        ), process.env.NODE_ENV !== "production" && us(i), process.env.NODE_ENV !== "production" && vo();
      } else {
        let O;
        const { el: C, props: P } = c, { bm: z, m: X, parent: K, root: Se, type: Ne } = i, He = jt(c);
        _t(i, !1), z && Lt(z), !He && (O = P && P.onVnodeBeforeMount) && Ue(O, K, c), _t(i, !0);
        {
          Se.ce && Se.ce._injectChildStyle(Ne), process.env.NODE_ENV !== "production" && kt(i, "render");
          const Le = i.subTree = ar(i);
          process.env.NODE_ENV !== "production" && It(i, "render"), process.env.NODE_ENV !== "production" && kt(i, "patch"), $(
            null,
            Le,
            f,
            g,
            i,
            m,
            v
          ), process.env.NODE_ENV !== "production" && It(i, "patch"), c.el = Le.el;
        }
        if (X && Ce(X, m), !He && (O = P && P.onVnodeMounted)) {
          const Le = c;
          Ce(
            () => Ue(O, K, Le),
            m
          );
        }
        (c.shapeFlag & 256 || K && jt(K.vnode) && K.vnode.shapeFlag & 256) && i.a && Ce(i.a, m), i.isMounted = !0, process.env.NODE_ENV !== "production" && rl(i), c = f = g = null;
      }
    };
    i.scope.on();
    const E = i.effect = new Rr(w);
    i.scope.off();
    const y = i.update = E.run.bind(E), A = i.job = E.runIfDirty.bind(E);
    A.i = i, A.id = i.uid, E.scheduler = () => Wo(A), _t(i, !0), process.env.NODE_ENV !== "production" && (E.onTrack = i.rtc ? (O) => Lt(i.rtc, O) : void 0, E.onTrigger = i.rtg ? (O) => Lt(i.rtg, O) : void 0), y();
  }, j = (i, c, f) => {
    c.component = i;
    const g = i.vnode.props;
    i.vnode = c, i.next = null, zl(i, c.props, g, f), Yl(i, c.children, f), rt(), Zn(i), st();
  }, Ve = (i, c, f, g, m, v, _, w, E = !1) => {
    const y = i && i.children, A = i ? i.shapeFlag : 0, O = c.children, { patchFlag: C, shapeFlag: P } = c;
    if (C > 0) {
      if (C & 128) {
        Qe(
          y,
          O,
          f,
          g,
          m,
          v,
          _,
          w,
          E
        );
        return;
      } else if (C & 256) {
        Xe(
          y,
          O,
          f,
          g,
          m,
          v,
          _,
          w,
          E
        );
        return;
      }
    }
    P & 8 ? (A & 16 && ct(y, m, v), O !== y && p(f, O)) : A & 16 ? P & 16 ? Qe(
      y,
      O,
      f,
      g,
      m,
      v,
      _,
      w,
      E
    ) : ct(y, m, v, !0) : (A & 8 && p(f, ""), P & 16 && R(
      O,
      f,
      g,
      m,
      v,
      _,
      w,
      E
    ));
  }, Xe = (i, c, f, g, m, v, _, w, E) => {
    i = i || $t, c = c || $t;
    const y = i.length, A = c.length, O = Math.min(y, A);
    let C;
    for (C = 0; C < O; C++) {
      const P = c[C] = E ? ft(c[C]) : Me(c[C]);
      $(
        i[C],
        P,
        f,
        null,
        m,
        v,
        _,
        w,
        E
      );
    }
    y > A ? ct(
      i,
      m,
      v,
      !0,
      !1,
      O
    ) : R(
      c,
      f,
      g,
      m,
      v,
      _,
      w,
      E,
      O
    );
  }, Qe = (i, c, f, g, m, v, _, w, E) => {
    let y = 0;
    const A = c.length;
    let O = i.length - 1, C = A - 1;
    for (; y <= O && y <= C; ) {
      const P = i[y], z = c[y] = E ? ft(c[y]) : Me(c[y]);
      if (Wt(P, z))
        $(
          P,
          z,
          f,
          null,
          m,
          v,
          _,
          w,
          E
        );
      else
        break;
      y++;
    }
    for (; y <= O && y <= C; ) {
      const P = i[O], z = c[C] = E ? ft(c[C]) : Me(c[C]);
      if (Wt(P, z))
        $(
          P,
          z,
          f,
          null,
          m,
          v,
          _,
          w,
          E
        );
      else
        break;
      O--, C--;
    }
    if (y > O) {
      if (y <= C) {
        const P = C + 1, z = P < A ? c[P].el : g;
        for (; y <= C; )
          $(
            null,
            c[y] = E ? ft(c[y]) : Me(c[y]),
            f,
            z,
            m,
            v,
            _,
            w,
            E
          ), y++;
      }
    } else if (y > C)
      for (; y <= O; )
        ze(i[y], m, v, !0), y++;
    else {
      const P = y, z = y, X = /* @__PURE__ */ new Map();
      for (y = z; y <= C; y++) {
        const me = c[y] = E ? ft(c[y]) : Me(c[y]);
        me.key != null && (process.env.NODE_ENV !== "production" && X.has(me.key) && x(
          "Duplicate keys found during update:",
          JSON.stringify(me.key),
          "Make sure keys are unique."
        ), X.set(me.key, y));
      }
      let K, Se = 0;
      const Ne = C - z + 1;
      let He = !1, Le = 0;
      const Ht = new Array(Ne);
      for (y = 0; y < Ne; y++) Ht[y] = 0;
      for (y = P; y <= O; y++) {
        const me = i[y];
        if (Se >= Ne) {
          ze(me, m, v, !0);
          continue;
        }
        let Be;
        if (me.key != null)
          Be = X.get(me.key);
        else
          for (K = z; K <= C; K++)
            if (Ht[K - z] === 0 && Wt(me, c[K])) {
              Be = K;
              break;
            }
        Be === void 0 ? ze(me, m, v, !0) : (Ht[Be - z] = y + 1, Be >= Le ? Le = Be : He = !0, $(
          me,
          c[Be],
          f,
          null,
          m,
          v,
          _,
          w,
          E
        ), Se++);
      }
      const Kn = He ? tc(Ht) : $t;
      for (K = Kn.length - 1, y = Ne - 1; y >= 0; y--) {
        const me = z + y, Be = c[me], qn = me + 1 < A ? c[me + 1].el : g;
        Ht[y] === 0 ? $(
          null,
          Be,
          f,
          qn,
          m,
          v,
          _,
          w,
          E
        ) : He && (K < 0 || y !== Kn[K] ? lt(Be, f, qn, 2) : K--);
      }
    }
  }, lt = (i, c, f, g, m = null) => {
    const { el: v, type: _, transition: w, children: E, shapeFlag: y } = i;
    if (y & 6) {
      lt(i.component.subTree, c, f, g);
      return;
    }
    if (y & 128) {
      i.suspense.move(c, f, g);
      return;
    }
    if (y & 64) {
      _.move(i, c, f, xe);
      return;
    }
    if (_ === ae) {
      n(v, c, f);
      for (let O = 0; O < E.length; O++)
        lt(E[O], c, f, g);
      n(i.anchor, c, f);
      return;
    }
    if (_ === Eo) {
      ne(i, c, f);
      return;
    }
    if (g !== 2 && y & 1 && w)
      if (g === 0)
        w.beforeEnter(v), n(v, c, f), Ce(() => w.enter(v), m);
      else {
        const { leave: O, delayLeave: C, afterLeave: P } = w, z = () => n(v, c, f), X = () => {
          O(v, () => {
            z(), P && P();
          });
        };
        C ? C(v, z, X) : X();
      }
    else
      n(v, c, f);
  }, ze = (i, c, f, g = !1, m = !1) => {
    const {
      type: v,
      props: _,
      ref: w,
      children: E,
      dynamicChildren: y,
      shapeFlag: A,
      patchFlag: O,
      dirs: C,
      cacheIndex: P
    } = i;
    if (O === -2 && (m = !1), w != null && ko(w, null, f, i, !0), P != null && (c.renderCache[P] = void 0), A & 256) {
      c.ctx.deactivate(i);
      return;
    }
    const z = A & 1 && C, X = !jt(i);
    let K;
    if (X && (K = _ && _.onVnodeBeforeUnmount) && Ue(K, c, i), A & 6)
      po(i.component, f, g);
    else {
      if (A & 128) {
        i.suspense.unmount(f, g);
        return;
      }
      z && vt(i, null, c, "beforeUnmount"), A & 64 ? i.type.remove(
        i,
        c,
        f,
        xe,
        g
      ) : y && // #5154
      // when v-once is used inside a block, setBlockTracking(-1) marks the
      // parent block with hasOnce: true
      // so that it doesn't take the fast path during unmount - otherwise
      // components nested in v-once are never unmounted.
      !y.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
      (v !== ae || O > 0 && O & 64) ? ct(
        y,
        c,
        f,
        !1,
        !0
      ) : (v === ae && O & 384 || !m && A & 16) && ct(E, c, f), g && Ee(i);
    }
    (X && (K = _ && _.onVnodeUnmounted) || z) && Ce(() => {
      K && Ue(K, c, i), z && vt(i, null, c, "unmounted");
    }, f);
  }, Ee = (i) => {
    const { type: c, el: f, anchor: g, transition: m } = i;
    if (c === ae) {
      process.env.NODE_ENV !== "production" && i.patchFlag > 0 && i.patchFlag & 2048 && m && !m.persisted ? i.children.forEach((_) => {
        _.type === De ? r(_.el) : Ee(_);
      }) : fo(f, g);
      return;
    }
    if (c === Eo) {
      S(i);
      return;
    }
    const v = () => {
      r(f), m && !m.persisted && m.afterLeave && m.afterLeave();
    };
    if (i.shapeFlag & 1 && m && !m.persisted) {
      const { leave: _, delayLeave: w } = m, E = () => _(f, v);
      w ? w(i.el, v, E) : E();
    } else
      v();
  }, fo = (i, c) => {
    let f;
    for (; i !== c; )
      f = b(i), r(i), i = f;
    r(c);
  }, po = (i, c, f) => {
    process.env.NODE_ENV !== "production" && i.type.__hmrId && Zi(i);
    const { bum: g, scope: m, job: v, subTree: _, um: w, m: E, a: y } = i;
    cr(E), cr(y), g && Lt(g), m.stop(), v && (v.flags |= 8, ze(_, i, c, f)), w && Ce(w, c), Ce(() => {
      i.isUnmounted = !0;
    }, c), c && c.pendingBranch && !c.isUnmounted && i.asyncDep && !i.asyncResolved && i.suspenseId === c.pendingId && (c.deps--, c.deps === 0 && c.resolve()), process.env.NODE_ENV !== "production" && il(i);
  }, ct = (i, c, f, g = !1, m = !1, v = 0) => {
    for (let _ = v; _ < i.length; _++)
      ze(i[_], c, f, g, m);
  }, Tt = (i) => {
    if (i.shapeFlag & 6)
      return Tt(i.component.subTree);
    if (i.shapeFlag & 128)
      return i.suspense.next();
    const c = b(i.anchor || i.el), f = c && c[ul];
    return f ? b(f) : c;
  };
  let mt = !1;
  const bt = (i, c, f) => {
    i == null ? c._vnode && ze(c._vnode, null, null, !0) : $(
      c._vnode || null,
      i,
      c,
      null,
      null,
      null,
      f
    ), c._vnode = i, mt || (mt = !0, Zn(), ls(), mt = !1);
  }, xe = {
    p: $,
    um: ze,
    m: lt,
    r: Ee,
    mt: Fe,
    mc: R,
    pc: Ve,
    pbc: $e,
    n: Tt,
    o: e
  };
  return {
    render: bt,
    hydrate: void 0,
    createApp: Rl(bt)
  };
}
function nn({ type: e, props: t }, o) {
  return o === "svg" && e === "foreignObject" || o === "mathml" && e === "annotation-xml" && t && t.encoding && t.encoding.includes("html") ? void 0 : o;
}
function _t({ effect: e, job: t }, o) {
  o ? (e.flags |= 32, t.flags |= 4) : (e.flags &= -33, t.flags &= -5);
}
function ec(e, t) {
  return (!e || e && !e.pendingBranch) && t && !t.persisted;
}
function wo(e, t, o = !1) {
  const n = e.children, r = t.children;
  if (T(n) && T(r))
    for (let s = 0; s < n.length; s++) {
      const l = n[s];
      let a = r[s];
      a.shapeFlag & 1 && !a.dynamicChildren && ((a.patchFlag <= 0 || a.patchFlag === 32) && (a = r[s] = ft(r[s]), a.el = l.el), !o && a.patchFlag !== -2 && wo(l, a)), a.type === lo && (a.el = l.el), process.env.NODE_ENV !== "production" && a.type === De && !a.el && (a.el = l.el);
    }
}
function tc(e) {
  const t = e.slice(), o = [0];
  let n, r, s, l, a;
  const u = e.length;
  for (n = 0; n < u; n++) {
    const h = e[n];
    if (h !== 0) {
      if (r = o[o.length - 1], e[r] < h) {
        t[n] = r, o.push(n);
        continue;
      }
      for (s = 0, l = o.length - 1; s < l; )
        a = s + l >> 1, e[o[a]] < h ? s = a + 1 : l = a;
      h < e[o[s]] && (s > 0 && (t[n] = o[s - 1]), o[s] = n);
    }
  }
  for (s = o.length, l = o[s - 1]; s-- > 0; )
    o[s] = l, l = t[l];
  return o;
}
function Is(e) {
  const t = e.subTree.component;
  if (t)
    return t.asyncDep && !t.asyncResolved ? t : Is(t);
}
function cr(e) {
  if (e)
    for (let t = 0; t < e.length; t++)
      e[t].flags |= 8;
}
const oc = Symbol.for("v-scx"), nc = () => {
  {
    const e = yo(oc);
    return e || process.env.NODE_ENV !== "production" && x(
      "Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build."
    ), e;
  }
};
function Vt(e, t, o) {
  return process.env.NODE_ENV !== "production" && !I(t) && x(
    "`watch(fn, options?)` signature has been moved to a separate API. Use `watchEffect(fn, options?)` instead. `watch` now only supports `watch(source, cb, options?) signature."
  ), Ps(e, t, o);
}
function Ps(e, t, o = q) {
  const { immediate: n, deep: r, flush: s, once: l } = o;
  process.env.NODE_ENV !== "production" && !t && (n !== void 0 && x(
    'watch() "immediate" option is only respected when using the watch(source, callback, options?) signature.'
  ), r !== void 0 && x(
    'watch() "deep" option is only respected when using the watch(source, callback, options?) signature.'
  ), l !== void 0 && x(
    'watch() "once" option is only respected when using the watch(source, callback, options?) signature.'
  ));
  const a = te({}, o);
  process.env.NODE_ENV !== "production" && (a.onWarn = x);
  const u = t && n || !t && s !== "post";
  let h;
  if (oo) {
    if (s === "sync") {
      const N = nc();
      h = N.__watcherHandles || (N.__watcherHandles = []);
    } else if (!u) {
      const N = () => {
      };
      return N.stop = ue, N.resume = ue, N.pause = ue, N;
    }
  }
  const p = fe;
  a.call = (N, V, $) => Ye(N, p, V, $);
  let d = !1;
  s === "post" ? a.scheduler = (N) => {
    Ce(N, p && p.suspense);
  } : s !== "sync" && (d = !0, a.scheduler = (N, V) => {
    V ? N() : Wo(N);
  }), a.augmentJob = (N) => {
    t && (N.flags |= 4), d && (N.flags |= 2, p && (N.id = p.uid, N.i = p));
  };
  const b = Ui(e, t, a);
  return oo && (h ? h.push(b) : u && b()), b;
}
function rc(e, t, o) {
  const n = this.proxy, r = Z(e) ? e.includes(".") ? $s(n, e) : () => n[e] : e.bind(n, n);
  let s;
  I(t) ? s = t : (s = t.handler, o = t);
  const l = ao(this), a = Ps(r, s.bind(n), o);
  return l(), a;
}
function $s(e, t) {
  const o = t.split(".");
  return () => {
    let n = e;
    for (let r = 0; r < o.length && n; r++)
      n = n[o[r]];
    return n;
  };
}
const sc = (e, t) => t === "modelValue" || t === "model-value" ? e.modelModifiers : e[`${t}Modifiers`] || e[`${Oe(t)}Modifiers`] || e[`${Ae(t)}Modifiers`];
function ic(e, t, ...o) {
  if (e.isUnmounted) return;
  const n = e.vnode.props || q;
  if (process.env.NODE_ENV !== "production") {
    const {
      emitsOptions: p,
      propsOptions: [d]
    } = e;
    if (p)
      if (!(t in p))
        (!d || !(yt(Oe(t)) in d)) && x(
          `Component emitted event "${t}" but it is neither declared in the emits option nor as an "${yt(Oe(t))}" prop.`
        );
      else {
        const b = p[t];
        I(b) && (b(...o) || x(
          `Invalid event arguments: event validation failed for event "${t}".`
        ));
      }
  }
  let r = o;
  const s = t.startsWith("update:"), l = s && sc(n, t.slice(7));
  if (l && (l.trim && (r = o.map((p) => Z(p) ? p.trim() : p)), l.number && (r = o.map(ni))), process.env.NODE_ENV !== "production" && al(e, t, r), process.env.NODE_ENV !== "production") {
    const p = t.toLowerCase();
    p !== t && n[yt(p)] && x(
      `Event "${p}" is emitted in component ${Go(
        e,
        e.type
      )} but the handler is registered for "${t}". Note that HTML attributes are case-insensitive and you cannot use v-on to listen to camelCase events when using in-DOM templates. You should probably use "${Ae(
        t
      )}" instead of "${t}".`
    );
  }
  let a, u = n[a = yt(t)] || // also try camelCase event handler (#2249)
  n[a = yt(Oe(t))];
  !u && s && (u = n[a = yt(Ae(t))]), u && Ye(
    u,
    e,
    6,
    r
  );
  const h = n[a + "Once"];
  if (h) {
    if (!e.emitted)
      e.emitted = {};
    else if (e.emitted[a])
      return;
    e.emitted[a] = !0, Ye(
      h,
      e,
      6,
      r
    );
  }
}
function Ms(e, t, o = !1) {
  const n = t.emitsCache, r = n.get(e);
  if (r !== void 0)
    return r;
  const s = e.emits;
  let l = {}, a = !1;
  if (!I(e)) {
    const u = (h) => {
      const p = Ms(h, t, !0);
      p && (a = !0, te(l, p));
    };
    !o && t.mixins.length && t.mixins.forEach(u), e.extends && u(e.extends), e.mixins && e.mixins.forEach(u);
  }
  return !s && !a ? (J(e) && n.set(e, null), null) : (T(s) ? s.forEach((u) => l[u] = null) : te(l, s), J(e) && n.set(e, l), l);
}
function qo(e, t) {
  return !e || !no(t) ? !1 : (t = t.slice(2).replace(/Once$/, ""), H(e, t[0].toLowerCase() + t.slice(1)) || H(e, Ae(t)) || H(e, t));
}
let vn = !1;
function $o() {
  vn = !0;
}
function ar(e) {
  const {
    type: t,
    vnode: o,
    proxy: n,
    withProxy: r,
    propsOptions: [s],
    slots: l,
    attrs: a,
    emit: u,
    render: h,
    renderCache: p,
    props: d,
    data: b,
    setupState: N,
    ctx: V,
    inheritAttrs: $
  } = e, ie = Ao(e);
  let U, D;
  process.env.NODE_ENV !== "production" && (vn = !1);
  try {
    if (o.shapeFlag & 4) {
      const S = r || n, ee = process.env.NODE_ENV !== "production" && N.__isScriptSetup ? new Proxy(S, {
        get(Q, Y, R) {
          return x(
            `Property '${String(
              Y
            )}' was accessed via 'this'. Avoid using 'this' in templates.`
          ), Reflect.get(Q, Y, R);
        }
      }) : S;
      U = Me(
        h.call(
          ee,
          S,
          p,
          process.env.NODE_ENV !== "production" ? qe(d) : d,
          N,
          b,
          V
        )
      ), D = a;
    } else {
      const S = t;
      process.env.NODE_ENV !== "production" && a === d && $o(), U = Me(
        S.length > 1 ? S(
          process.env.NODE_ENV !== "production" ? qe(d) : d,
          process.env.NODE_ENV !== "production" ? {
            get attrs() {
              return $o(), qe(a);
            },
            slots: l,
            emit: u
          } : { attrs: a, slots: l, emit: u }
        ) : S(
          process.env.NODE_ENV !== "production" ? qe(d) : d,
          null
        )
      ), D = t.props ? a : lc(a);
    }
  } catch (S) {
    Xt.length = 0, so(S, e, 1), U = Ie(De);
  }
  let L = U, ne;
  if (process.env.NODE_ENV !== "production" && U.patchFlag > 0 && U.patchFlag & 2048 && ([L, ne] = Rs(U)), D && $ !== !1) {
    const S = Object.keys(D), { shapeFlag: ee } = L;
    if (S.length) {
      if (ee & 7)
        s && S.some(Oo) && (D = cc(
          D,
          s
        )), L = gt(L, D, !1, !0);
      else if (process.env.NODE_ENV !== "production" && !vn && L.type !== De) {
        const Q = Object.keys(a), Y = [], R = [];
        for (let ye = 0, $e = Q.length; ye < $e; ye++) {
          const we = Q[ye];
          no(we) ? Oo(we) || Y.push(we[2].toLowerCase() + we.slice(3)) : R.push(we);
        }
        R.length && x(
          `Extraneous non-props attributes (${R.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text or teleport root nodes.`
        ), Y.length && x(
          `Extraneous non-emits event listeners (${Y.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes. If the listener is intended to be a component custom event listener only, declare it using the "emits" option.`
        );
      }
    }
  }
  return o.dirs && (process.env.NODE_ENV !== "production" && !ur(L) && x(
    "Runtime directive used on component with non-element root node. The directives will not function as intended."
  ), L = gt(L, null, !1, !0), L.dirs = L.dirs ? L.dirs.concat(o.dirs) : o.dirs), o.transition && (process.env.NODE_ENV !== "production" && !ur(L) && x(
    "Component inside <Transition> renders non-element root node that cannot be animated."
  ), Mn(L, o.transition)), process.env.NODE_ENV !== "production" && ne ? ne(L) : U = L, Ao(ie), U;
}
const Rs = (e) => {
  const t = e.children, o = e.dynamicChildren, n = Hn(t, !1);
  if (n) {
    if (process.env.NODE_ENV !== "production" && n.patchFlag > 0 && n.patchFlag & 2048)
      return Rs(n);
  } else return [e, void 0];
  const r = t.indexOf(n), s = o ? o.indexOf(n) : -1, l = (a) => {
    t[r] = a, o && (s > -1 ? o[s] = a : a.patchFlag > 0 && (e.dynamicChildren = [...o, a]));
  };
  return [Me(n), l];
};
function Hn(e, t = !0) {
  let o;
  for (let n = 0; n < e.length; n++) {
    const r = e[n];
    if (co(r)) {
      if (r.type !== De || r.children === "v-if") {
        if (o)
          return;
        if (o = r, process.env.NODE_ENV !== "production" && t && o.patchFlag > 0 && o.patchFlag & 2048)
          return Hn(o.children);
      }
    } else
      return;
  }
  return o;
}
const lc = (e) => {
  let t;
  for (const o in e)
    (o === "class" || o === "style" || no(o)) && ((t || (t = {}))[o] = e[o]);
  return t;
}, cc = (e, t) => {
  const o = {};
  for (const n in e)
    (!Oo(n) || !(n.slice(9) in t)) && (o[n] = e[n]);
  return o;
}, ur = (e) => e.shapeFlag & 7 || e.type === De;
function ac(e, t, o) {
  const { props: n, children: r, component: s } = e, { props: l, children: a, patchFlag: u } = t, h = s.emitsOptions;
  if (process.env.NODE_ENV !== "production" && (r || a) && Ge || t.dirs || t.transition)
    return !0;
  if (o && u >= 0) {
    if (u & 1024)
      return !0;
    if (u & 16)
      return n ? fr(n, l, h) : !!l;
    if (u & 8) {
      const p = t.dynamicProps;
      for (let d = 0; d < p.length; d++) {
        const b = p[d];
        if (l[b] !== n[b] && !qo(h, b))
          return !0;
      }
    }
  } else
    return (r || a) && (!a || !a.$stable) ? !0 : n === l ? !1 : n ? l ? fr(n, l, h) : !0 : !!l;
  return !1;
}
function fr(e, t, o) {
  const n = Object.keys(t);
  if (n.length !== Object.keys(e).length)
    return !0;
  for (let r = 0; r < n.length; r++) {
    const s = n[r];
    if (t[s] !== e[s] && !qo(o, s))
      return !0;
  }
  return !1;
}
function uc({ vnode: e, parent: t }, o) {
  for (; t; ) {
    const n = t.subTree;
    if (n.suspense && n.suspense.activeBranch === e && (n.el = e.el), n === e)
      (e = t.vnode).el = o, t = t.parent;
    else
      break;
  }
}
const js = (e) => e.__isSuspense;
function fc(e, t) {
  t && t.pendingBranch ? T(e) ? t.effects.push(...e) : t.effects.push(e) : is(e);
}
const ae = Symbol.for("v-fgt"), lo = Symbol.for("v-txt"), De = Symbol.for("v-cmt"), Eo = Symbol.for("v-stc"), Xt = [];
let ke = null;
function B(e = !1) {
  Xt.push(ke = e ? null : []);
}
function dc() {
  Xt.pop(), ke = Xt[Xt.length - 1] || null;
}
let to = 1;
function dr(e, t = !1) {
  to += e, e < 0 && ke && t && (ke.hasOnce = !0);
}
function Fs(e) {
  return e.dynamicChildren = to > 0 ? ke || $t : null, dc(), to > 0 && ke && ke.push(e), e;
}
function G(e, t, o, n, r, s) {
  return Fs(
    k(
      e,
      t,
      o,
      n,
      r,
      s,
      !0
    )
  );
}
function _n(e, t, o, n, r) {
  return Fs(
    Ie(
      e,
      t,
      o,
      n,
      r,
      !0
    )
  );
}
function co(e) {
  return e ? e.__v_isVNode === !0 : !1;
}
function Wt(e, t) {
  if (process.env.NODE_ENV !== "production" && t.shapeFlag & 6 && e.component) {
    const o = _o.get(t.type);
    if (o && o.has(e.component))
      return e.shapeFlag &= -257, t.shapeFlag &= -513, !1;
  }
  return e.type === t.type && e.key === t.key;
}
const pc = (...e) => Hs(
  ...e
), zs = ({ key: e }) => e ?? null, xo = ({
  ref: e,
  ref_key: t,
  ref_for: o
}) => (typeof e == "number" && (e = "" + e), e != null ? Z(e) || se(e) || I(e) ? { i: pe, r: e, k: t, f: !!o } : e : null);
function k(e, t = null, o = null, n = 0, r = null, s = e === ae ? 0 : 1, l = !1, a = !1) {
  const u = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e,
    props: t,
    key: t && zs(t),
    ref: t && xo(t),
    scopeId: ds,
    slotScopeIds: null,
    children: o,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: s,
    patchFlag: n,
    dynamicProps: r,
    dynamicChildren: null,
    appContext: null,
    ctx: pe
  };
  return a ? (Ln(u, o), s & 128 && e.normalize(u)) : o && (u.shapeFlag |= Z(o) ? 8 : 16), process.env.NODE_ENV !== "production" && u.key !== u.key && x("VNode created with invalid key (NaN). VNode type:", u.type), to > 0 && // avoid a block node from tracking itself
  !l && // has current parent block
  ke && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (u.patchFlag > 0 || s & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  u.patchFlag !== 32 && ke.push(u), u;
}
const Ie = process.env.NODE_ENV !== "production" ? pc : Hs;
function Hs(e, t = null, o = null, n = 0, r = null, s = !1) {
  if ((!e || e === Ol) && (process.env.NODE_ENV !== "production" && !e && x(`Invalid vnode type when creating vnode: ${e}.`), e = De), co(e)) {
    const a = gt(
      e,
      t,
      !0
      /* mergeRef: true */
    );
    return o && Ln(a, o), to > 0 && !s && ke && (a.shapeFlag & 6 ? ke[ke.indexOf(e)] = a : ke.push(a)), a.patchFlag = -2, a;
  }
  if (qs(e) && (e = e.__vccOpts), t) {
    t = hc(t);
    let { class: a, style: u } = t;
    a && !Z(a) && (t.class = Mt(a)), J(u) && (Vo(u) && !T(u) && (u = te({}, u)), t.style = le(u));
  }
  const l = Z(e) ? 1 : js(e) ? 128 : fl(e) ? 64 : J(e) ? 4 : I(e) ? 2 : 0;
  return process.env.NODE_ENV !== "production" && l & 4 && Vo(e) && (e = M(e), x(
    "Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.",
    `
Component that was made reactive: `,
    e
  )), k(
    e,
    t,
    o,
    n,
    r,
    l,
    s,
    !0
  );
}
function hc(e) {
  return e ? Vo(e) || Ds(e) ? te({}, e) : e : null;
}
function gt(e, t, o = !1, n = !1) {
  const { props: r, ref: s, patchFlag: l, children: a, transition: u } = e, h = t ? gc(r || {}, t) : r, p = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e.type,
    props: h,
    key: h && zs(h),
    ref: t && t.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      o && s ? T(s) ? s.concat(xo(t)) : [s, xo(t)] : xo(t)
    ) : s,
    scopeId: e.scopeId,
    slotScopeIds: e.slotScopeIds,
    children: process.env.NODE_ENV !== "production" && l === -1 && T(a) ? a.map(Ls) : a,
    target: e.target,
    targetStart: e.targetStart,
    targetAnchor: e.targetAnchor,
    staticCount: e.staticCount,
    shapeFlag: e.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: t && e.type !== ae ? l === -1 ? 16 : l | 16 : l,
    dynamicProps: e.dynamicProps,
    dynamicChildren: e.dynamicChildren,
    appContext: e.appContext,
    dirs: e.dirs,
    transition: u,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: e.component,
    suspense: e.suspense,
    ssContent: e.ssContent && gt(e.ssContent),
    ssFallback: e.ssFallback && gt(e.ssFallback),
    el: e.el,
    anchor: e.anchor,
    ctx: e.ctx,
    ce: e.ce
  };
  return u && n && Mn(
    p,
    u.clone(p)
  ), p;
}
function Ls(e) {
  const t = gt(e);
  return T(e.children) && (t.children = e.children.map(Ls)), t;
}
function Bs(e = " ", t = 0) {
  return Ie(lo, null, e, t);
}
function he(e = "", t = !1) {
  return t ? (B(), _n(De, null, e)) : Ie(De, null, e);
}
function Me(e) {
  return e == null || typeof e == "boolean" ? Ie(De) : T(e) ? Ie(
    ae,
    null,
    // #3666, avoid reference pollution when reusing vnode
    e.slice()
  ) : co(e) ? ft(e) : Ie(lo, null, String(e));
}
function ft(e) {
  return e.el === null && e.patchFlag !== -1 || e.memo ? e : gt(e);
}
function Ln(e, t) {
  let o = 0;
  const { shapeFlag: n } = e;
  if (t == null)
    t = null;
  else if (T(t))
    o = 16;
  else if (typeof t == "object")
    if (n & 65) {
      const r = t.default;
      r && (r._c && (r._d = !1), Ln(e, r()), r._c && (r._d = !0));
      return;
    } else {
      o = 32;
      const r = t._;
      !r && !Ds(t) ? t._ctx = pe : r === 3 && pe && (pe.slots._ === 1 ? t._ = 1 : (t._ = 2, e.patchFlag |= 1024));
    }
  else I(t) ? (t = { default: t, _ctx: pe }, o = 32) : (t = String(t), n & 64 ? (o = 16, t = [Bs(t)]) : o = 8);
  e.children = t, e.shapeFlag |= o;
}
function gc(...e) {
  const t = {};
  for (let o = 0; o < e.length; o++) {
    const n = e[o];
    for (const r in n)
      if (r === "class")
        t.class !== n.class && (t.class = Mt([t.class, n.class]));
      else if (r === "style")
        t.style = le([t.style, n.style]);
      else if (no(r)) {
        const s = t[r], l = n[r];
        l && s !== l && !(T(s) && s.includes(l)) && (t[r] = s ? [].concat(s, l) : l);
      } else r !== "" && (t[r] = n[r]);
  }
  return t;
}
function Ue(e, t, o, n = null) {
  Ye(e, t, 7, [
    o,
    n
  ]);
}
const mc = Es();
let bc = 0;
function vc(e, t, o) {
  const n = e.type, r = (t ? t.appContext : e.appContext) || mc, s = {
    uid: bc++,
    vnode: e,
    type: n,
    parent: t,
    appContext: r,
    root: null,
    // to be immediately set
    next: null,
    subTree: null,
    // will be set synchronously right after creation
    effect: null,
    update: null,
    // will be set synchronously right after creation
    job: null,
    scope: new mi(
      !0
      /* detached */
    ),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: t ? t.provides : Object.create(r.provides),
    ids: t ? t.ids : ["", 0, 0],
    accessCache: null,
    renderCache: [],
    // local resolved assets
    components: null,
    directives: null,
    // resolved props and emits options
    propsOptions: Ss(n, r),
    emitsOptions: Ms(n, r),
    // emit
    emit: null,
    // to be set immediately
    emitted: null,
    // props default value
    propsDefaults: q,
    // inheritAttrs
    inheritAttrs: n.inheritAttrs,
    // state
    ctx: q,
    data: q,
    props: q,
    attrs: q,
    slots: q,
    refs: q,
    setupState: q,
    setupContext: null,
    // suspense related
    suspense: o,
    suspenseId: o ? o.pendingId : 0,
    asyncDep: null,
    asyncResolved: !1,
    // lifecycle hooks
    // not using enums here because it results in computed properties
    isMounted: !1,
    isUnmounted: !1,
    isDeactivated: !1,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  return process.env.NODE_ENV !== "production" ? s.ctx = Vl(s) : s.ctx = { _: s }, s.root = t ? t.root : s, s.emit = ic.bind(null, s), e.ce && e.ce(s), s;
}
let fe = null;
const _c = () => fe || pe;
let Mo, yn;
{
  const e = ro(), t = (o, n) => {
    let r;
    return (r = e[o]) || (r = e[o] = []), r.push(n), (s) => {
      r.length > 1 ? r.forEach((l) => l(s)) : r[0](s);
    };
  };
  Mo = t(
    "__VUE_INSTANCE_SETTERS__",
    (o) => fe = o
  ), yn = t(
    "__VUE_SSR_SETTERS__",
    (o) => oo = o
  );
}
const ao = (e) => {
  const t = fe;
  return Mo(e), e.scope.on(), () => {
    e.scope.off(), Mo(t);
  };
}, pr = () => {
  fe && fe.scope.off(), Mo(null);
}, yc = /* @__PURE__ */ ot("slot,component");
function wn(e, { isNativeTag: t }) {
  (yc(e) || t(e)) && x(
    "Do not use built-in or reserved HTML elements as component id: " + e
  );
}
function Us(e) {
  return e.vnode.shapeFlag & 4;
}
let oo = !1;
function wc(e, t = !1, o = !1) {
  t && yn(t);
  const { props: n, children: r } = e.vnode, s = Us(e);
  jl(e, n, s, t), Jl(e, r, o);
  const l = s ? Ec(e, t) : void 0;
  return t && yn(!1), l;
}
function Ec(e, t) {
  var o;
  const n = e.type;
  if (process.env.NODE_ENV !== "production") {
    if (n.name && wn(n.name, e.appContext.config), n.components) {
      const s = Object.keys(n.components);
      for (let l = 0; l < s.length; l++)
        wn(s[l], e.appContext.config);
    }
    if (n.directives) {
      const s = Object.keys(n.directives);
      for (let l = 0; l < s.length; l++)
        hs(s[l]);
    }
    n.compilerOptions && xc() && x(
      '"compilerOptions" is only supported when using a build of Vue that includes the runtime compiler. Since you are using a runtime-only build, the options should be passed via your build tool config instead.'
    );
  }
  e.accessCache = /* @__PURE__ */ Object.create(null), e.proxy = new Proxy(e.ctx, _s), process.env.NODE_ENV !== "production" && Sl(e);
  const { setup: r } = n;
  if (r) {
    rt();
    const s = e.setupContext = r.length > 1 ? Oc(e) : null, l = ao(e), a = zt(
      r,
      e,
      0,
      [
        process.env.NODE_ENV !== "production" ? qe(e.props) : e.props,
        s
      ]
    ), u = On(a);
    if (st(), l(), (u || e.sp) && !jt(e) && gs(e), u) {
      if (a.then(pr, pr), t)
        return a.then((h) => {
          hr(e, h, t);
        }).catch((h) => {
          so(h, e, 0);
        });
      if (e.asyncDep = a, process.env.NODE_ENV !== "production" && !e.suspense) {
        const h = (o = n.name) != null ? o : "Anonymous";
        x(
          `Component <${h}>: setup function returned a promise, but no <Suspense> boundary was found in the parent component tree. A component with async setup() must be nested in a <Suspense> in order to be rendered.`
        );
      }
    } else
      hr(e, a, t);
  } else
    Ws(e, t);
}
function hr(e, t, o) {
  I(t) ? e.type.__ssrInlineRender ? e.ssrRender = t : e.render = t : J(t) ? (process.env.NODE_ENV !== "production" && co(t) && x(
    "setup() should not return VNodes directly - return a render function instead."
  ), process.env.NODE_ENV !== "production" && (e.devtoolsRawSetupState = t), e.setupState = ts(t), process.env.NODE_ENV !== "production" && Cl(e)) : process.env.NODE_ENV !== "production" && t !== void 0 && x(
    `setup() should return an object. Received: ${t === null ? "null" : typeof t}`
  ), Ws(e, o);
}
const xc = () => !0;
function Ws(e, t, o) {
  const n = e.type;
  e.render || (e.render = n.render || ue);
  {
    const r = ao(e);
    rt();
    try {
      Al(e);
    } finally {
      st(), r();
    }
  }
  process.env.NODE_ENV !== "production" && !n.render && e.render === ue && !t && (n.template ? x(
    'Component provided template option but runtime compilation is not supported in this build of Vue. Configure your bundler to alias "vue" to "vue/dist/vue.esm-bundler.js".'
  ) : x("Component is missing template or render function: ", n));
}
const gr = process.env.NODE_ENV !== "production" ? {
  get(e, t) {
    return $o(), ce(e, "get", ""), e[t];
  },
  set() {
    return x("setupContext.attrs is readonly."), !1;
  },
  deleteProperty() {
    return x("setupContext.attrs is readonly."), !1;
  }
} : {
  get(e, t) {
    return ce(e, "get", ""), e[t];
  }
};
function Nc(e) {
  return new Proxy(e.slots, {
    get(t, o) {
      return ce(e, "get", "$slots"), t[o];
    }
  });
}
function Oc(e) {
  const t = (o) => {
    if (process.env.NODE_ENV !== "production" && (e.exposed && x("expose() should be called only once per setup()."), o != null)) {
      let n = typeof o;
      n === "object" && (T(o) ? n = "array" : se(o) && (n = "ref")), n !== "object" && x(
        `expose() should be passed a plain object, received ${n}.`
      );
    }
    e.exposed = o || {};
  };
  if (process.env.NODE_ENV !== "production") {
    let o, n;
    return Object.freeze({
      get attrs() {
        return o || (o = new Proxy(e.attrs, gr));
      },
      get slots() {
        return n || (n = Nc(e));
      },
      get emit() {
        return (r, ...s) => e.emit(r, ...s);
      },
      expose: t
    });
  } else
    return {
      attrs: new Proxy(e.attrs, gr),
      slots: e.slots,
      emit: e.emit,
      expose: t
    };
}
function Bn(e) {
  return e.exposed ? e.exposeProxy || (e.exposeProxy = new Proxy(ts(Ri(e.exposed)), {
    get(t, o) {
      if (o in t)
        return t[o];
      if (o in Dt)
        return Dt[o](e);
    },
    has(t, o) {
      return o in t || o in Dt;
    }
  })) : e.proxy;
}
const Dc = /(?:^|[-_])(\w)/g, Vc = (e) => e.replace(Dc, (t) => t.toUpperCase()).replace(/[-_]/g, "");
function Ks(e, t = !0) {
  return I(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function Go(e, t, o = !1) {
  let n = Ks(t);
  if (!n && t.__file) {
    const r = t.__file.match(/([^/\\]+)\.\w+$/);
    r && (n = r[1]);
  }
  if (!n && e && e.parent) {
    const r = (s) => {
      for (const l in s)
        if (s[l] === t)
          return l;
    };
    n = r(
      e.components || e.parent.type.components
    ) || r(e.appContext.components);
  }
  return n ? Vc(n) : o ? "App" : "Anonymous";
}
function qs(e) {
  return I(e) && "__vccOpts" in e;
}
const oe = (e, t) => {
  const o = Li(e, t, oo);
  if (process.env.NODE_ENV !== "production") {
    const n = _c();
    n && n.appContext.config.warnRecursiveComputed && (o._warnRecursive = !0);
  }
  return o;
};
function Sc() {
  if (process.env.NODE_ENV === "production" || typeof window > "u")
    return;
  const e = { style: "color:#3ba776" }, t = { style: "color:#1677ff" }, o = { style: "color:#f5222d" }, n = { style: "color:#eb2f96" }, r = {
    __vue_custom_formatter: !0,
    header(d) {
      return J(d) ? d.__isVue ? ["div", e, "VueInstance"] : se(d) ? [
        "div",
        {},
        ["span", e, p(d)],
        "<",
        // avoid debugger accessing value affecting behavior
        a("_value" in d ? d._value : d),
        ">"
      ] : Nt(d) ? [
        "div",
        {},
        ["span", e, _e(d) ? "ShallowReactive" : "Reactive"],
        "<",
        a(d),
        `>${tt(d) ? " (readonly)" : ""}`
      ] : tt(d) ? [
        "div",
        {},
        ["span", e, _e(d) ? "ShallowReadonly" : "Readonly"],
        "<",
        a(d),
        ">"
      ] : null : null;
    },
    hasBody(d) {
      return d && d.__isVue;
    },
    body(d) {
      if (d && d.__isVue)
        return [
          "div",
          {},
          ...s(d.$)
        ];
    }
  };
  function s(d) {
    const b = [];
    d.type.props && d.props && b.push(l("props", M(d.props))), d.setupState !== q && b.push(l("setup", d.setupState)), d.data !== q && b.push(l("data", M(d.data)));
    const N = u(d, "computed");
    N && b.push(l("computed", N));
    const V = u(d, "inject");
    return V && b.push(l("injected", V)), b.push([
      "div",
      {},
      [
        "span",
        {
          style: n.style + ";opacity:0.66"
        },
        "$ (internal): "
      ],
      ["object", { object: d }]
    ]), b;
  }
  function l(d, b) {
    return b = te({}, b), Object.keys(b).length ? [
      "div",
      { style: "line-height:1.25em;margin-bottom:0.6em" },
      [
        "div",
        {
          style: "color:#476582"
        },
        d
      ],
      [
        "div",
        {
          style: "padding-left:1.25em"
        },
        ...Object.keys(b).map((N) => [
          "div",
          {},
          ["span", n, N + ": "],
          a(b[N], !1)
        ])
      ]
    ] : ["span", {}];
  }
  function a(d, b = !0) {
    return typeof d == "number" ? ["span", t, d] : typeof d == "string" ? ["span", o, JSON.stringify(d)] : typeof d == "boolean" ? ["span", n, d] : J(d) ? ["object", { object: b ? M(d) : d }] : ["span", o, String(d)];
  }
  function u(d, b) {
    const N = d.type;
    if (I(N))
      return;
    const V = {};
    for (const $ in d.ctx)
      h(N, $, b) && (V[$] = d.ctx[$]);
    return V;
  }
  function h(d, b, N) {
    const V = d[N];
    if (T(V) && V.includes(b) || J(V) && b in V || d.extends && h(d.extends, b, N) || d.mixins && d.mixins.some(($) => h($, b, N)))
      return !0;
  }
  function p(d) {
    return _e(d) ? "ShallowRef" : d.effect ? "ComputedRef" : "Ref";
  }
  window.devtoolsFormatters ? window.devtoolsFormatters.push(r) : window.devtoolsFormatters = [r];
}
const mr = "3.5.13", Pe = process.env.NODE_ENV !== "production" ? x : ue;
process.env.NODE_ENV;
process.env.NODE_ENV;
/**
* @vue/runtime-dom v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
let En;
const br = typeof window < "u" && window.trustedTypes;
if (br)
  try {
    En = /* @__PURE__ */ br.createPolicy("vue", {
      createHTML: (e) => e
    });
  } catch (e) {
    process.env.NODE_ENV !== "production" && Pe(`Error creating trusted types policy: ${e}`);
  }
const Gs = En ? (e) => En.createHTML(e) : (e) => e, Cc = "http://www.w3.org/2000/svg", Tc = "http://www.w3.org/1998/Math/MathML", et = typeof document < "u" ? document : null, vr = et && /* @__PURE__ */ et.createElement("template"), Ac = {
  insert: (e, t, o) => {
    t.insertBefore(e, o || null);
  },
  remove: (e) => {
    const t = e.parentNode;
    t && t.removeChild(e);
  },
  createElement: (e, t, o, n) => {
    const r = t === "svg" ? et.createElementNS(Cc, e) : t === "mathml" ? et.createElementNS(Tc, e) : o ? et.createElement(e, { is: o }) : et.createElement(e);
    return e === "select" && n && n.multiple != null && r.setAttribute("multiple", n.multiple), r;
  },
  createText: (e) => et.createTextNode(e),
  createComment: (e) => et.createComment(e),
  setText: (e, t) => {
    e.nodeValue = t;
  },
  setElementText: (e, t) => {
    e.textContent = t;
  },
  parentNode: (e) => e.parentNode,
  nextSibling: (e) => e.nextSibling,
  querySelector: (e) => et.querySelector(e),
  setScopeId(e, t) {
    e.setAttribute(t, "");
  },
  // __UNSAFE__
  // Reason: innerHTML.
  // Static content here can only come from compiled templates.
  // As long as the user only uses trusted templates, this is safe.
  insertStaticContent(e, t, o, n, r, s) {
    const l = o ? o.previousSibling : t.lastChild;
    if (r && (r === s || r.nextSibling))
      for (; t.insertBefore(r.cloneNode(!0), o), !(r === s || !(r = r.nextSibling)); )
        ;
    else {
      vr.innerHTML = Gs(
        n === "svg" ? `<svg>${e}</svg>` : n === "mathml" ? `<math>${e}</math>` : e
      );
      const a = vr.content;
      if (n === "svg" || n === "mathml") {
        const u = a.firstChild;
        for (; u.firstChild; )
          a.appendChild(u.firstChild);
        a.removeChild(u);
      }
      t.insertBefore(a, o);
    }
    return [
      // first
      l ? l.nextSibling : t.firstChild,
      // last
      o ? o.previousSibling : t.lastChild
    ];
  }
}, kc = Symbol("_vtc");
function Ic(e, t, o) {
  const n = e[kc];
  n && (t = (t ? [t, ...n] : [...n]).join(" ")), t == null ? e.removeAttribute("class") : o ? e.setAttribute("class", t) : e.className = t;
}
const _r = Symbol("_vod"), Pc = Symbol("_vsh");
process.env.NODE_ENV;
const $c = Symbol(process.env.NODE_ENV !== "production" ? "CSS_VAR_TEXT" : ""), Mc = /(^|;)\s*display\s*:/;
function Rc(e, t, o) {
  const n = e.style, r = Z(o);
  let s = !1;
  if (o && !r) {
    if (t)
      if (Z(t))
        for (const l of t.split(";")) {
          const a = l.slice(0, l.indexOf(":")).trim();
          o[a] == null && No(n, a, "");
        }
      else
        for (const l in t)
          o[l] == null && No(n, l, "");
    for (const l in o)
      l === "display" && (s = !0), No(n, l, o[l]);
  } else if (r) {
    if (t !== o) {
      const l = n[$c];
      l && (o += ";" + l), n.cssText = o, s = Mc.test(o);
    }
  } else t && e.removeAttribute("style");
  _r in e && (e[_r] = s ? n.display : "", e[Pc] && (n.display = "none"));
}
const jc = /[^\\];\s*$/, yr = /\s*!important$/;
function No(e, t, o) {
  if (T(o))
    o.forEach((n) => No(e, t, n));
  else if (o == null && (o = ""), process.env.NODE_ENV !== "production" && jc.test(o) && Pe(
    `Unexpected semicolon at the end of '${t}' style value: '${o}'`
  ), t.startsWith("--"))
    e.setProperty(t, o);
  else {
    const n = Fc(e, t);
    yr.test(o) ? e.setProperty(
      Ae(n),
      o.replace(yr, ""),
      "important"
    ) : e[n] = o;
  }
}
const wr = ["Webkit", "Moz", "ms"], rn = {};
function Fc(e, t) {
  const o = rn[t];
  if (o)
    return o;
  let n = Oe(t);
  if (n !== "filter" && n in e)
    return rn[t] = n;
  n = zo(n);
  for (let r = 0; r < wr.length; r++) {
    const s = wr[r] + n;
    if (s in e)
      return rn[t] = s;
  }
  return t;
}
const Er = "http://www.w3.org/1999/xlink";
function xr(e, t, o, n, r, s = gi(t)) {
  n && t.startsWith("xlink:") ? o == null ? e.removeAttributeNS(Er, t.slice(6, t.length)) : e.setAttributeNS(Er, t, o) : o == null || s && !Pr(o) ? e.removeAttribute(t) : e.setAttribute(
    t,
    s ? "" : nt(o) ? String(o) : o
  );
}
function Nr(e, t, o, n, r) {
  if (t === "innerHTML" || t === "textContent") {
    o != null && (e[t] = t === "innerHTML" ? Gs(o) : o);
    return;
  }
  const s = e.tagName;
  if (t === "value" && s !== "PROGRESS" && // custom elements may use _value internally
  !s.includes("-")) {
    const a = s === "OPTION" ? e.getAttribute("value") || "" : e.value, u = o == null ? (
      // #11647: value should be set as empty string for null and undefined,
      // but <input type="checkbox"> should be set as 'on'.
      e.type === "checkbox" ? "on" : ""
    ) : String(o);
    (a !== u || !("_value" in e)) && (e.value = u), o == null && e.removeAttribute(t), e._value = o;
    return;
  }
  let l = !1;
  if (o === "" || o == null) {
    const a = typeof e[t];
    a === "boolean" ? o = Pr(o) : o == null && a === "string" ? (o = "", l = !0) : a === "number" && (o = 0, l = !0);
  }
  try {
    e[t] = o;
  } catch (a) {
    process.env.NODE_ENV !== "production" && !l && Pe(
      `Failed setting prop "${t}" on <${s.toLowerCase()}>: value ${o} is invalid.`,
      a
    );
  }
  l && e.removeAttribute(r || t);
}
function zc(e, t, o, n) {
  e.addEventListener(t, o, n);
}
function Hc(e, t, o, n) {
  e.removeEventListener(t, o, n);
}
const Or = Symbol("_vei");
function Lc(e, t, o, n, r = null) {
  const s = e[Or] || (e[Or] = {}), l = s[t];
  if (n && l)
    l.value = process.env.NODE_ENV !== "production" ? Vr(n, t) : n;
  else {
    const [a, u] = Bc(t);
    if (n) {
      const h = s[t] = Kc(
        process.env.NODE_ENV !== "production" ? Vr(n, t) : n,
        r
      );
      zc(e, a, h, u);
    } else l && (Hc(e, a, l, u), s[t] = void 0);
  }
}
const Dr = /(?:Once|Passive|Capture)$/;
function Bc(e) {
  let t;
  if (Dr.test(e)) {
    t = {};
    let n;
    for (; n = e.match(Dr); )
      e = e.slice(0, e.length - n[0].length), t[n[0].toLowerCase()] = !0;
  }
  return [e[2] === ":" ? e.slice(3) : Ae(e.slice(2)), t];
}
let sn = 0;
const Uc = /* @__PURE__ */ Promise.resolve(), Wc = () => sn || (Uc.then(() => sn = 0), sn = Date.now());
function Kc(e, t) {
  const o = (n) => {
    if (!n._vts)
      n._vts = Date.now();
    else if (n._vts <= o.attached)
      return;
    Ye(
      qc(n, o.value),
      t,
      5,
      [n]
    );
  };
  return o.value = e, o.attached = Wc(), o;
}
function Vr(e, t) {
  return I(e) || T(e) ? e : (Pe(
    `Wrong type passed as event handler to ${t} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof e}.`
  ), ue);
}
function qc(e, t) {
  if (T(t)) {
    const o = e.stopImmediatePropagation;
    return e.stopImmediatePropagation = () => {
      o.call(e), e._stopped = !0;
    }, t.map(
      (n) => (r) => !r._stopped && n && n(r)
    );
  } else
    return t;
}
const Sr = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // lowercase letter
e.charCodeAt(2) > 96 && e.charCodeAt(2) < 123, Gc = (e, t, o, n, r, s) => {
  const l = r === "svg";
  t === "class" ? Ic(e, n, l) : t === "style" ? Rc(e, o, n) : no(t) ? Oo(t) || Lc(e, t, o, n, s) : (t[0] === "." ? (t = t.slice(1), !0) : t[0] === "^" ? (t = t.slice(1), !1) : Jc(e, t, n, l)) ? (Nr(e, t, n), !e.tagName.includes("-") && (t === "value" || t === "checked" || t === "selected") && xr(e, t, n, l, s, t !== "value")) : /* #11081 force set props for possible async custom element */ e._isVueCE && (/[A-Z]/.test(t) || !Z(n)) ? Nr(e, Oe(t), n, s, t) : (t === "true-value" ? e._trueValue = n : t === "false-value" && (e._falseValue = n), xr(e, t, n, l));
};
function Jc(e, t, o, n) {
  if (n)
    return !!(t === "innerHTML" || t === "textContent" || t in e && Sr(t) && I(o));
  if (t === "spellcheck" || t === "draggable" || t === "translate" || t === "form" || t === "list" && e.tagName === "INPUT" || t === "type" && e.tagName === "TEXTAREA")
    return !1;
  if (t === "width" || t === "height") {
    const r = e.tagName;
    if (r === "IMG" || r === "VIDEO" || r === "CANVAS" || r === "SOURCE")
      return !1;
  }
  return Sr(t) && Z(o) ? !1 : t in e;
}
const Cr = {};
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function Yc(e, t, o) {
  const n = /* @__PURE__ */ dl(e, t);
  jo(n) && te(n, t);
  class r extends Un {
    constructor(l) {
      super(n, l, o);
    }
  }
  return r.def = n, r;
}
const Xc = typeof HTMLElement < "u" ? HTMLElement : class {
};
class Un extends Xc {
  constructor(t, o = {}, n = Ar) {
    super(), this._def = t, this._props = o, this._createApp = n, this._isVueCE = !0, this._instance = null, this._app = null, this._nonce = this._def.nonce, this._connected = !1, this._resolved = !1, this._numberProps = null, this._styleChildren = /* @__PURE__ */ new WeakSet(), this._ob = null, this.shadowRoot && n !== Ar ? this._root = this.shadowRoot : (process.env.NODE_ENV !== "production" && this.shadowRoot && Pe(
      "Custom element has pre-rendered declarative shadow root but is not defined as hydratable. Use `defineSSRCustomElement`."
    ), t.shadowRoot !== !1 ? (this.attachShadow({ mode: "open" }), this._root = this.shadowRoot) : this._root = this), this._def.__asyncLoader || this._resolveProps(this._def);
  }
  connectedCallback() {
    if (!this.isConnected) return;
    this.shadowRoot || this._parseSlots(), this._connected = !0;
    let t = this;
    for (; t = t && (t.parentNode || t.host); )
      if (t instanceof Un) {
        this._parent = t;
        break;
      }
    this._instance || (this._resolved ? (this._setParent(), this._update()) : t && t._pendingResolve ? this._pendingResolve = t._pendingResolve.then(() => {
      this._pendingResolve = void 0, this._resolveDef();
    }) : this._resolveDef());
  }
  _setParent(t = this._parent) {
    t && (this._instance.parent = t._instance, this._instance.provides = t._instance.provides);
  }
  disconnectedCallback() {
    this._connected = !1, rs(() => {
      this._connected || (this._ob && (this._ob.disconnect(), this._ob = null), this._app && this._app.unmount(), this._instance && (this._instance.ce = void 0), this._app = this._instance = null);
    });
  }
  /**
   * resolve inner component definition (handle possible async component)
   */
  _resolveDef() {
    if (this._pendingResolve)
      return;
    for (let n = 0; n < this.attributes.length; n++)
      this._setAttr(this.attributes[n].name);
    this._ob = new MutationObserver((n) => {
      for (const r of n)
        this._setAttr(r.attributeName);
    }), this._ob.observe(this, { attributes: !0 });
    const t = (n, r = !1) => {
      this._resolved = !0, this._pendingResolve = void 0;
      const { props: s, styles: l } = n;
      let a;
      if (s && !T(s))
        for (const u in s) {
          const h = s[u];
          (h === Number || h && h.type === Number) && (u in this._props && (this._props[u] = Gn(this._props[u])), (a || (a = /* @__PURE__ */ Object.create(null)))[Oe(u)] = !0);
        }
      this._numberProps = a, r && this._resolveProps(n), this.shadowRoot ? this._applyStyles(l) : process.env.NODE_ENV !== "production" && l && Pe(
        "Custom element style injection is not supported when using shadowRoot: false"
      ), this._mount(n);
    }, o = this._def.__asyncLoader;
    o ? this._pendingResolve = o().then(
      (n) => t(this._def = n, !0)
    ) : t(this._def);
  }
  _mount(t) {
    process.env.NODE_ENV !== "production" && !t.name && (t.name = "VueElement"), this._app = this._createApp(t), t.configureApp && t.configureApp(this._app), this._app._ceVNode = this._createVNode(), this._app.mount(this._root);
    const o = this._instance && this._instance.exposed;
    if (o)
      for (const n in o)
        H(this, n) ? process.env.NODE_ENV !== "production" && Pe(`Exposed property "${n}" already exists on custom element.`) : Object.defineProperty(this, n, {
          // unwrap ref to be consistent with public instance behavior
          get: () => es(o[n])
        });
  }
  _resolveProps(t) {
    const { props: o } = t, n = T(o) ? o : Object.keys(o || {});
    for (const r of Object.keys(this))
      r[0] !== "_" && n.includes(r) && this._setProp(r, this[r]);
    for (const r of n.map(Oe))
      Object.defineProperty(this, r, {
        get() {
          return this._getProp(r);
        },
        set(s) {
          this._setProp(r, s, !0, !0);
        }
      });
  }
  _setAttr(t) {
    if (t.startsWith("data-v-")) return;
    const o = this.hasAttribute(t);
    let n = o ? this.getAttribute(t) : Cr;
    const r = Oe(t);
    o && this._numberProps && this._numberProps[r] && (n = Gn(n)), this._setProp(r, n, !1, !0);
  }
  /**
   * @internal
   */
  _getProp(t) {
    return this._props[t];
  }
  /**
   * @internal
   */
  _setProp(t, o, n = !0, r = !1) {
    if (o !== this._props[t] && (o === Cr ? delete this._props[t] : (this._props[t] = o, t === "key" && this._app && (this._app._ceVNode.key = o)), r && this._instance && this._update(), n)) {
      const s = this._ob;
      s && s.disconnect(), o === !0 ? this.setAttribute(Ae(t), "") : typeof o == "string" || typeof o == "number" ? this.setAttribute(Ae(t), o + "") : o || this.removeAttribute(Ae(t)), s && s.observe(this, { attributes: !0 });
    }
  }
  _update() {
    Zc(this._createVNode(), this._root);
  }
  _createVNode() {
    const t = {};
    this.shadowRoot || (t.onVnodeMounted = t.onVnodeUpdated = this._renderSlots.bind(this));
    const o = Ie(this._def, te(t, this._props));
    return this._instance || (o.ce = (n) => {
      this._instance = n, n.ce = this, n.isCE = !0, process.env.NODE_ENV !== "production" && (n.ceReload = (s) => {
        this._styles && (this._styles.forEach((l) => this._root.removeChild(l)), this._styles.length = 0), this._applyStyles(s), this._instance = null, this._update();
      });
      const r = (s, l) => {
        this.dispatchEvent(
          new CustomEvent(
            s,
            jo(l[0]) ? te({ detail: l }, l[0]) : { detail: l }
          )
        );
      };
      n.emit = (s, ...l) => {
        r(s, l), Ae(s) !== s && r(Ae(s), l);
      }, this._setParent();
    }), o;
  }
  _applyStyles(t, o) {
    if (!t) return;
    if (o) {
      if (o === this._def || this._styleChildren.has(o))
        return;
      this._styleChildren.add(o);
    }
    const n = this._nonce;
    for (let r = t.length - 1; r >= 0; r--) {
      const s = document.createElement("style");
      if (n && s.setAttribute("nonce", n), s.textContent = t[r], this.shadowRoot.prepend(s), process.env.NODE_ENV !== "production")
        if (o) {
          if (o.__hmrId) {
            this._childStyles || (this._childStyles = /* @__PURE__ */ new Map());
            let l = this._childStyles.get(o.__hmrId);
            l || this._childStyles.set(o.__hmrId, l = []), l.push(s);
          }
        } else
          (this._styles || (this._styles = [])).push(s);
    }
  }
  /**
   * Only called when shadowRoot is false
   */
  _parseSlots() {
    const t = this._slots = {};
    let o;
    for (; o = this.firstChild; ) {
      const n = o.nodeType === 1 && o.getAttribute("slot") || "default";
      (t[n] || (t[n] = [])).push(o), this.removeChild(o);
    }
  }
  /**
   * Only called when shadowRoot is false
   */
  _renderSlots() {
    const t = (this._teleportTarget || this).querySelectorAll("slot"), o = this._instance.type.__scopeId;
    for (let n = 0; n < t.length; n++) {
      const r = t[n], s = r.getAttribute("name") || "default", l = this._slots[s], a = r.parentNode;
      if (l)
        for (const u of l) {
          if (o && u.nodeType === 1) {
            const h = o + "-s", p = document.createTreeWalker(u, 1);
            u.setAttribute(h, "");
            let d;
            for (; d = p.nextNode(); )
              d.setAttribute(h, "");
          }
          a.insertBefore(u, r);
        }
      else
        for (; r.firstChild; ) a.insertBefore(r.firstChild, r);
      a.removeChild(r);
    }
  }
  /**
   * @internal
   */
  _injectChildStyle(t) {
    this._applyStyles(t.styles, t);
  }
  /**
   * @internal
   */
  _removeChildStyle(t) {
    if (process.env.NODE_ENV !== "production" && (this._styleChildren.delete(t), this._childStyles && t.__hmrId)) {
      const o = this._childStyles.get(t.__hmrId);
      o && (o.forEach((n) => this._root.removeChild(n)), o.length = 0);
    }
  }
}
const Qc = /* @__PURE__ */ te({ patchProp: Gc }, Ac);
let Tr;
function Js() {
  return Tr || (Tr = Ql(Qc));
}
const Zc = (...e) => {
  Js().render(...e);
}, Ar = (...e) => {
  const t = Js().createApp(...e);
  process.env.NODE_ENV !== "production" && (ta(t), oa(t));
  const { mount: o } = t;
  return t.mount = (n) => {
    const r = na(n);
    if (!r) return;
    const s = t._component;
    !I(s) && !s.render && !s.template && (s.template = r.innerHTML), r.nodeType === 1 && (r.textContent = "");
    const l = o(r, !1, ea(r));
    return r instanceof Element && (r.removeAttribute("v-cloak"), r.setAttribute("data-v-app", "")), l;
  }, t;
};
function ea(e) {
  if (e instanceof SVGElement)
    return "svg";
  if (typeof MathMLElement == "function" && e instanceof MathMLElement)
    return "mathml";
}
function ta(e) {
  Object.defineProperty(e.config, "isNativeTag", {
    value: (t) => fi(t) || di(t) || pi(t),
    writable: !1
  });
}
function oa(e) {
  {
    const t = e.config.isCustomElement;
    Object.defineProperty(e.config, "isCustomElement", {
      get() {
        return t;
      },
      set() {
        Pe(
          "The `isCustomElement` config option is deprecated. Use `compilerOptions.isCustomElement` instead."
        );
      }
    });
    const o = e.config.compilerOptions, n = 'The `compilerOptions` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, `compilerOptions` must be passed to `@vue/compiler-dom` in the build setup instead.\n- For vue-loader: pass it via vue-loader\'s `compilerOptions` loader option.\n- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader\n- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc';
    Object.defineProperty(e.config, "compilerOptions", {
      get() {
        return Pe(n), o;
      },
      set() {
        Pe(n);
      }
    });
  }
}
function na(e) {
  if (Z(e)) {
    const t = document.querySelector(e);
    return process.env.NODE_ENV !== "production" && !t && Pe(
      `Failed to mount app: mount target selector "${e}" returned null.`
    ), t;
  }
  return process.env.NODE_ENV !== "production" && window.ShadowRoot && e instanceof window.ShadowRoot && e.mode === "closed" && Pe(
    'mounting on a ShadowRoot with `{mode: "closed"}` may lead to unpredictable bugs'
  ), e;
}
/**
* vue v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function ra() {
  Sc();
}
process.env.NODE_ENV !== "production" && ra();
const sa = (e, t) => {
  const o = e.__vccOpts || e;
  for (const [n, r] of t)
    o[n] = r;
  return o;
};
function Ys(e) {
  let t = 0, o = 0, n = 0;
  return e.length === 4 ? (t = parseInt(e[1] + e[1], 16), o = parseInt(e[2] + e[2], 16), n = parseInt(e[3] + e[3], 16)) : e.length === 7 && (t = parseInt(e.substring(1, 3), 16), o = parseInt(e.substring(3, 5), 16), n = parseInt(e.substring(5, 7), 16)), { r: t, g: o, b: n };
}
function Xs(e) {
  const t = e.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/) || e.match(/rgba\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)/);
  return t ? {
    r: parseInt(t[1]),
    g: parseInt(t[2]),
    b: parseInt(t[3])
  } : null;
}
function xn(e) {
  let t, o, n;
  if (e.startsWith("#")) {
    const s = Ys(e);
    t = s.r, o = s.g, n = s.b;
  } else if (e.startsWith("rgb")) {
    const s = Xs(e);
    if (s)
      t = s.r, o = s.g, n = s.b;
    else
      return "white";
  } else
    return "white";
  return (0.299 * t + 0.587 * o + 0.114 * n) / 255 > 0.5 ? "black" : "white";
}
function ia(e, t) {
  let o, n, r;
  if (e.startsWith("#")) {
    const l = Ys(e);
    o = l.r, n = l.g, r = l.b;
  } else if (e.startsWith("rgb")) {
    const l = Xs(e);
    if (l)
      o = l.r, n = l.g, r = l.b;
    else
      return e;
  } else
    return e;
  const s = 1 + t;
  return o = Math.min(255, Math.floor(o * s)), n = Math.min(255, Math.floor(n * s)), r = Math.min(255, Math.floor(r * s)), `rgb(${o}, ${n}, ${r})`;
}
const la = {
  key: 0,
  class: "fixed inset-0 z-[999] flex items-center justify-center"
}, ca = { class: "bg-white p-6 rounded-lg shadow-xl relative max-w-md mx-auto" }, aa = { class: "text-xl font-bold mb-4 text-gray-800" }, ua = { class: "text-gray-700 mb-6" }, fa = { class: "flex justify-end" }, da = {
  __name: "InfoPopup",
  props: {
    modelValue: {
      type: Boolean,
      default: !1
    },
    title: {
      type: String,
      default: "Information"
    },
    message: {
      type: String,
      default: ""
    },
    primaryColor: {
      // New prop for primary button color
      type: String,
      default: "#FFFFFF"
      // Default to the existing primary color from your palette
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const o = e, n = t, r = oe(() => xn(o.primaryColor));
    function s() {
      n("update:modelValue", !1);
    }
    return Vt(() => o.modelValue, (l) => {
      console.log("InfoPopup: modelValue changed to:", l);
    }), console.log("InfoPopup component setup. Initial modelValue:", o.modelValue), (l, a) => e.modelValue ? (B(), G("div", la, [
      k("div", {
        class: "absolute inset-0 bg-black opacity-50",
        onClick: s
      }),
      k("div", ca, [
        k("h3", aa, re(e.title), 1),
        k("p", ua, re(e.message), 1),
        k("div", fa, [
          k("button", {
            onClick: s,
            style: le({ backgroundColor: e.primaryColor, color: r.value }),
            class: "px-4 py-2 bg-indigo-600 text-white rounded-lg"
          }, " OK ", 4)
        ])
      ])
    ])) : he("", !0);
  }
}, pa = {
  __name: "MyPortal",
  setup(e) {
    return (t, o) => Dl(t.$slots, "default");
  }
};
function ha(e) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch (t) {
    return console.log("error in cloneMe: " + t.message), console.trace(), e;
  }
}
const ga = '*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:#e5e7eb}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]:where(:not([hidden=until-found])){display:none}.container{width:100%}@media (min-width: 640px){.container{max-width:640px}}@media (min-width: 768px){.container{max-width:768px}}@media (min-width: 1024px){.container{max-width:1024px}}@media (min-width: 1280px){.container{max-width:1280px}}@media (min-width: 1536px){.container{max-width:1536px}}.visible{visibility:visible}.fixed{position:fixed}.absolute{position:absolute}.relative{position:relative}.inset-0{top:0;right:0;bottom:0;left:0}.right-4{right:1rem}.top-4{top:1rem}.z-\\[90\\]{z-index:90}.z-\\[999\\]{z-index:999}.mx-auto{margin-left:auto;margin-right:auto}.mb-2{margin-bottom:.5rem}.mb-3{margin-bottom:.75rem}.mb-4{margin-bottom:1rem}.mb-5{margin-bottom:1.25rem}.mb-6{margin-bottom:1.5rem}.ml-10{margin-left:2.5rem}.mt-1{margin-top:.25rem}.mt-2{margin-top:.5rem}.mt-3{margin-top:.75rem}.mt-6{margin-top:1.5rem}.mt-8{margin-top:2rem}.flex{display:flex}.grid{display:grid}.hidden{display:none}.h-10{height:2.5rem}.h-2\\.5{height:.625rem}.h-5{height:1.25rem}.h-56{height:14rem}.h-6{height:1.5rem}.h-full{height:100%}.w-10{width:2.5rem}.w-5{width:1.25rem}.w-6{width:1.5rem}.w-full{width:100%}.max-w-md{max-width:28rem}.flex-shrink-0{flex-shrink:0}.flex-grow{flex-grow:1}.rotate-180{--tw-rotate: 180deg;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.transform{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.cursor-pointer{cursor:pointer}.resize{resize:both}.grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.flex-col{flex-direction:column}.items-start{align-items:flex-start}.items-center{align-items:center}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.gap-3{gap:.75rem}.gap-6{gap:1.5rem}.space-x-4>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(1rem * var(--tw-space-x-reverse));margin-left:calc(1rem * calc(1 - var(--tw-space-x-reverse)))}.space-y-6>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(1.5rem * var(--tw-space-y-reverse))}.overflow-hidden{overflow:hidden}.overflow-y-auto{overflow-y:auto}.rounded-2xl{border-radius:1rem}.rounded-full{border-radius:9999px}.rounded-lg{border-radius:.5rem}.rounded-xl{border-radius:.75rem}.border{border-width:1px}.border-t{border-top-width:1px}.border-gray-200{--tw-border-opacity: 1;border-color:rgb(229 231 235 / var(--tw-border-opacity, 1))}.border-gray-400{--tw-border-opacity: 1;border-color:rgb(156 163 175 / var(--tw-border-opacity, 1))}.bg-black{--tw-bg-opacity: 1;background-color:rgb(0 0 0 / var(--tw-bg-opacity, 1))}.bg-gray-200{--tw-bg-opacity: 1;background-color:rgb(229 231 235 / var(--tw-bg-opacity, 1))}.bg-gray-50{--tw-bg-opacity: 1;background-color:rgb(249 250 251 / var(--tw-bg-opacity, 1))}.bg-indigo-600{--tw-bg-opacity: 1;background-color:rgb(79 70 229 / var(--tw-bg-opacity, 1))}.bg-white{--tw-bg-opacity: 1;background-color:rgb(255 255 255 / var(--tw-bg-opacity, 1))}.object-cover{-o-object-fit:cover;object-fit:cover}.p-4{padding:1rem}.p-6{padding:1.5rem}.p-8{padding:2rem}.px-4{padding-left:1rem;padding-right:1rem}.px-6{padding-left:1.5rem;padding-right:1.5rem}.px-8{padding-left:2rem;padding-right:2rem}.py-2{padding-top:.5rem;padding-bottom:.5rem}.py-3{padding-top:.75rem;padding-bottom:.75rem}.py-4{padding-top:1rem;padding-bottom:1rem}.pb-0{padding-bottom:0}.pb-6{padding-bottom:1.5rem}.pt-0{padding-top:0}.text-left{text-align:left}.text-center{text-align:center}.text-2xl{font-size:1.5rem;line-height:2rem}.text-3xl{font-size:1.875rem;line-height:2.25rem}.text-lg{font-size:1.125rem;line-height:1.75rem}.text-sm{font-size:.875rem;line-height:1.25rem}.text-xl{font-size:1.25rem;line-height:1.75rem}.font-bold{font-weight:700}.font-medium{font-weight:500}.font-normal{font-weight:400}.font-semibold{font-weight:600}.text-gray-500{--tw-text-opacity: 1;color:rgb(107 114 128 / var(--tw-text-opacity, 1))}.text-gray-600{--tw-text-opacity: 1;color:rgb(75 85 99 / var(--tw-text-opacity, 1))}.text-gray-700{--tw-text-opacity: 1;color:rgb(55 65 81 / var(--tw-text-opacity, 1))}.text-gray-800{--tw-text-opacity: 1;color:rgb(31 41 55 / var(--tw-text-opacity, 1))}.text-white{--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity, 1))}.opacity-50{opacity:.5}.shadow{--tw-shadow: 0 1px 3px 0 rgb(0 0 0 / .1), 0 1px 2px -1px rgb(0 0 0 / .1);--tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.shadow-lg{--tw-shadow: 0 10px 15px -3px rgb(0 0 0 / .1), 0 4px 6px -4px rgb(0 0 0 / .1);--tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.shadow-md{--tw-shadow: 0 4px 6px -1px rgb(0 0 0 / .1), 0 2px 4px -2px rgb(0 0 0 / .1);--tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.shadow-sm{--tw-shadow: 0 1px 2px 0 rgb(0 0 0 / .05);--tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.shadow-xl{--tw-shadow: 0 20px 25px -5px rgb(0 0 0 / .1), 0 8px 10px -6px rgb(0 0 0 / .1);--tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.transition-all{transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-colors{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-transform{transition-property:transform;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.duration-200{transition-duration:.2s}.duration-300{transition-duration:.3s}.ease-in-out{transition-timing-function:cubic-bezier(.4,0,.2,1)}.item-grid-bottom{z-index:3}.maxHeightDescription{max-height:100px;overflow:hidden}.stepTitle{font-size:1.5em;line-height:1.3}.item-additionals-textSize{font-size:1.2em;line-height:1.25}.optionImage{width:122px;height:122px}.layout-grid{min-height:100px;min-width:75vw;width:calc(100% - 50px);max-height:92vh;overflow:hidden;display:grid;grid-template-rows:auto minmax(0,1fr) min-content;margin:0 25px}.item-additionals{max-height:100%}.item-additionals .description{color:#4b5563}.quantity-button{display:flex;height:2.5rem;width:2.5rem;align-items:center;justify-content:center;border-radius:9999px;font-size:1.25rem;line-height:1.75rem;font-weight:700;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke;transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1);background-color:#e2e8f0;color:#475569;box-shadow:0 2px 4px #0000000d}.quantity-button:hover{background-color:#cbd5e1}.quantity-button.increment:hover{filter:brightness(.85)}.add-to-cart-button{border-radius:9999px;padding:.75rem 2rem;font-weight:700;--tw-shadow: 0 10px 15px -3px rgb(0 0 0 / .1), 0 4px 6px -4px rgb(0 0 0 / .1);--tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow);transition-property:color,background-color,border-color,text-decoration-color,fill,stroke;transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1);font-size:1.2em;line-height:1.25}.add-to-cart-button:hover{filter:brightness(.85)}.add-to-cart-button:disabled{cursor:not-allowed}.add-to-cart-button:disabled:hover{filter:none}.accordion-item{background-color:#fff}.options-grid{item-grid-template-columns:repeat(auto-fill,minmax(200px,1fr))}.hover\\:bg-gray-100:hover{--tw-bg-opacity: 1;background-color:rgb(243 244 246 / var(--tw-bg-opacity, 1))}.hover\\:bg-gray-50:hover{--tw-bg-opacity: 1;background-color:rgb(249 250 251 / var(--tw-bg-opacity, 1))}.hover\\:text-gray-700:hover{--tw-text-opacity: 1;color:rgb(55 65 81 / var(--tw-text-opacity, 1))}.focus\\:outline-none:focus{outline:2px solid transparent;outline-offset:2px}.focus\\:ring-2:focus{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 #0000)}.focus\\:ring-primary:focus{--tw-ring-opacity: 1;--tw-ring-color: rgb(158 127 255 / var(--tw-ring-opacity, 1))}.focus\\:ring-opacity-50:focus{--tw-ring-opacity: .5}@media (min-width: 640px){.sm\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.sm\\:grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}}@media (min-width: 768px){.md\\:w-2\\/5{width:40%}.md\\:flex-row{flex-direction:row}}@media (min-width: 1024px){.lg\\:grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}}', ma = { class: "layout-grid bg-white rounded-2xl shadow-md relative" }, ba = { class: "item-grid-top" }, va = { class: "relative p-8 pb-0" }, _a = { class: "flex flex-col md:flex-row items-start gap-6 mb-6" }, ya = {
  key: 0,
  class: "flex-shrink-0 w-full md:w-2/5 h-56"
}, wa = ["src", "alt"], Ea = { class: "flex-grow" }, xa = { class: "text-3xl font-bold text-gray-800" }, Na = ["innerHTML"], Oa = {
  key: 0,
  class: "text-sm text-gray-500 mt-2"
}, Da = {
  key: 0,
  class: "size-selection mt-6"
}, Va = { class: "grid grid-cols-2 sm:grid-cols-3 gap-3" }, Sa = ["onClick"], Ca = { class: "item-grid-middle p-8 pb-0 pt-0" }, Ta = {
  key: 0,
  class: "progress-indicator text-center mb-6"
}, Aa = { class: "text-lg font-semibold text-gray-700" }, ka = { class: "w-full bg-gray-200 rounded-full h-2.5 mt-2" }, Ia = { class: "item-additionals scrollable-area overflow-y-auto w-full mx-auto relative pb-6" }, Pa = {
  key: 0,
  class: "replace-article-variants-section mt-3"
}, $a = { class: "stepTitle font-semibold text-gray-700 mb-5" }, Ma = { class: "grid grid-cols-2 sm:grid-cols-3 gap-3 mb-6" }, Ra = ["onClick"], ja = ["src", "alt"], Fa = { class: "w-full" }, za = {
  key: 1,
  class: "variants-accordion space-y-6"
}, Ha = { class: "accordion-item border border-gray-400 rounded-lg overflow-hidden" }, La = { class: "accordion-header w-full flex justify-between items-center p-4 stepTitle font-semibold text-left text-gray-700 bg-gray-50 hover:bg-gray-100 transition-colors duration-200" }, Ba = { class: "flex flex-col" }, Ua = {
  key: 0,
  class: "text-sm font-normal text-gray-500 mt-1"
}, Wa = { class: "accordion-content p-4" }, Ka = { class: "options-grid grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" }, qa = ["onClick"], Ga = ["src", "alt"], Ja = { class: "w-full" }, Ya = { key: 1 }, Xa = { class: "item-grid-bottom" }, Qa = { class: "add-to-cart-section px-8 py-4 border-t border-gray-200 flex items-center justify-between" }, Za = { class: "flex items-center space-x-4" }, eu = { class: "text-2xl font-bold text-gray-800" }, tu = { class: "flex items-center space-x-4" }, ou = ["disabled"], nu = {
  __name: "WcApp",
  props: {
    article: {
      type: String,
      default: ""
    },
    items: {
      type: String,
      default: "[]"
    },
    title: {
      type: String,
      default: "title"
    },
    primaryColor: {
      // New prop for primary button color
      type: String,
      default: "#FFFFFF"
      // Default to the existing primary color from your palette
    },
    itemType: {
      type: String,
      default: "foodOrder"
    }
  },
  emits: ["close-additionals", "click-image", "add-to-cart"],
  setup(e, { emit: t }) {
    const o = t, n = at(!1), r = at(""), s = at(""), l = (i, c, f) => {
      r.value = i, s.value = c, n.value = f;
    };
    xs("setPopup", l);
    const a = e, u = Bo({}), h = at(1), p = at(null), d = at([]), b = (i) => !i || !Array.isArray(i.options) ? [] : i.options.filter((c) => c && typeof c == "object" && c.active !== !1), N = (i) => {
      console.log("initializeSelections...");
      for (const c in u)
        delete u[c];
      i && i.extras && i.extras.variants && i.extras.variants.forEach((c) => {
        const f = Array.isArray(c.options) ? c.options.filter((g) => g && typeof g == "object") : [];
        if (c.multi)
          u[c.title] = [];
        else {
          let g = null;
          !g && c.implicit && f.length > 0 && (g = f[0]), g ? u[c.title] = [g.id] : u[c.title] = [];
        }
      }), i && i.sizes && i.sizes.length > 0 ? p.value = i.sizes[0].vol : p.value = null;
    }, V = at(window.innerHeight), $ = () => {
      V.value = window.innerHeight;
    };
    bs(() => {
      window.addEventListener("resize", $);
    }), jn(() => {
      window.removeEventListener("resize", $);
    });
    const ie = oe(() => V.value), U = oe(() => ie.value >= 1500);
    Vt(() => a.article, (i) => {
      if (i && typeof i == "string" && i.trim() !== "")
        try {
          const c = JSON.parse(i);
          console.log("articleData", c), N(c);
        } catch (c) {
          console.error("Failed to parse article JSON:", c);
        }
      else
        console.warn("Received empty or invalid article prop, skipping JSON parsing.");
    }, { immediate: !0 });
    const D = oe(() => {
      try {
        return JSON.parse(a.article);
      } catch {
        return {
          nameDE: "Burger#1",
          descriptionDE: "direkt vom BBQ-Grill und echtem Raucharoma",
          posId: "3406",
          // "sizes": [
          //   {
          //     "vol": "300g",
          //     "price": 11.5
          //   },
          //   {
          //     "vol": "120g",
          //     "price": 5.9
          //   }
          // ],
          extras: {
            variants: [
              {
                // Beispiel für replaceArticle: true
                title: "Hauptgericht ersetzen",
                options: [
                  {
                    id: "replace-opt-1",
                    posId: "R1",
                    labelDE: "Großer Salat",
                    cost: 12,
                    imageUrl: "https://images.pexels.com/photos/1059905/pexels-photo-1059905.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                  },
                  {
                    id: "replace-opt-2",
                    posId: "R2",
                    labelDE: "Veggie Bowl",
                    cost: 10.5,
                    imageUrl: "https://images.pexels.com/photos/1640777/pexels-photo-1640777.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                  }
                ],
                multi: !1,
                optional: !1,
                replaceArticle: !0,
                dropdown: !1,
                implicit: !1
              },
              {
                title: "Beispiel mit Implizit",
                options: [
                  {
                    id: "ia6vgda26kemhgg2fiu",
                    posId: "7347700000000002",
                    labelDE: "Pfand",
                    labelEN: "",
                    cost: 0.15,
                    articleNo: ""
                  }
                ],
                multi: !1,
                optional: !1,
                replaceArticle: !1,
                dropdown: !1,
                implicit: !0
              },
              {
                title: "Min-Max Beispiel",
                multi: !0,
                replaceArticle: !1,
                dropdown: !1,
                options: [
                  {
                    id: "aufvrlttbaamhgg9ihj",
                    posId: "4902",
                    labelDE: "Rinderstreifen",
                    cost: 6,
                    articleNo: ""
                  },
                  {
                    id: "e9p5jxa1bpvmhgg9ihj",
                    posId: "4903",
                    labelDE: "King Prawns",
                    cost: 7,
                    articleNo: ""
                  },
                  {
                    id: "5wdcmo5dgqsmhgg9ihj",
                    posId: "4904",
                    labelDE: "Hähnchenbrust",
                    cost: 5,
                    articleNo: ""
                  },
                  {
                    id: "6ksdkiit8tdmhgvdmb0",
                    posId: "89",
                    labelDE: "Portion Pommes Frites",
                    labelEN: "",
                    cost: 1.8,
                    articleNo: ""
                  },
                  {
                    id: "m3eset3ullmhgve1r8",
                    posId: "38",
                    labelDE: "Portion Kartoffelsalat mit Beilagen",
                    labelEN: "",
                    cost: 1.5,
                    articleNo: ""
                  }
                ],
                freeArticles: 2,
                maxOptions: 4,
                min: 1
                // Added for testing Rule 3
              },
              {
                title: "Salatbeilage",
                options: [
                  {
                    id: "76s5mc4rsa5mhgg6c9s",
                    posId: "850f3d2b-69a4-4584-836e-f8f17a19d709",
                    labelDE: "Pommes Frites",
                    labelEN: "",
                    cost: 0,
                    articleNo: ""
                  },
                  {
                    id: "qnu73ht3p5mhgg6evk",
                    posId: "62b81be3-8565-469a-8755-51d05acc9c05",
                    labelDE: "Vollkornbrot",
                    labelEN: "",
                    cost: 1,
                    articleNo: ""
                  }
                ],
                multi: !1,
                optional: !1,
                replaceArticle: !1,
                dropdown: !1,
                implicit: !1
              },
              {
                title: "Dynamische bei Pommes",
                options: [
                  {
                    id: "sjjxuw9hm5mhgg7yue",
                    posId: "3e56f167-aa33-470c-8c36-653e23bc9128",
                    labelDE: "Ketchup",
                    labelEN: "",
                    cost: 0.2,
                    articleNo: ""
                  }
                ],
                multi: !0,
                replaceArticle: !1,
                dropdown: !1,
                trigger: "76s5mc4rsa5mhgg6c9s"
              },
              {
                title: "Extras?",
                multi: !0,
                replaceArticle: !1,
                dropdown: !1,
                options: [
                  {
                    id: "2lq3r4ugkavkprfevzy",
                    posId: "3410",
                    labelDE: "Extra Bacon",
                    cost: 1.5,
                    active: !1
                  },
                  {
                    id: "1od82o2vwfvkprfevzz",
                    posId: "3411",
                    labelDE: "Extra Käse",
                    cost: 1
                  }
                ]
              },
              {
                title: "Beilage",
                optional: !1,
                multi: !1,
                optional: !0,
                replaceArticle: !1,
                dropdown: !1,
                trigger: "2vu700ui35omkb9kkrq",
                implicit: !1,
                separateLineItem: !1
              }
            ]
          },
          substances: {
            aA: !0,
            aE: !0,
            lBIO: !0,
            aC: !0,
            z3: !0,
            z4: !0
          },
          gramm: 0,
          image: "https://file.qsignal.eu/demo1besttaste/images/foods/ajesh-tp-1633525.jpg",
          moreImages: [],
          validStores: [],
          streichPreis: 20.99,
          neu: !0,
          days: [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7"
          ]
        };
      }
    }), L = oe(() => {
      var i, c;
      return ((c = (i = D.value) == null ? void 0 : i.extras) == null ? void 0 : c.variants) || [];
    }), ne = oe(
      () => L.value.filter((i) => i.replaceArticle === !0)
    ), S = oe(
      () => L.value.filter((i) => i.replaceArticle !== !0)
    ), ee = (i) => {
      if (!i.trigger)
        return !0;
      const c = i.trigger;
      for (const f in u)
        if ((u[f] || []).includes(c))
          return !0;
      return !1;
    }, Q = oe(() => {
      const i = [];
      return ne.value.forEach((c) => {
        b(c).length > 0 && i.push({ ...c, type: "replace" });
      }), S.value.forEach((c) => {
        b(c).length > 0 && ee(c) && i.push({ ...c, type: "normal" });
      }), i;
    }), Y = at(0), R = oe(() => Q.value[Y.value]);
    Vt(Y, (i) => {
      d.value = [];
      const c = Q.value[i];
      c && c.type === "normal" && d.value.push(c.title);
    }, { immediate: !0 });
    const ye = {
      fPork: "Schweinefleisch",
      fBeef: "Rindfleisch",
      fOther: "Anderes Fleisch",
      aA: "Gluten",
      aB: "Krebstiere",
      aC: "Eier von Geflügel",
      aD: "Fisch",
      aE: "Erdnüsse",
      aF: "Sojabohnen",
      aG: "Milch und Milcherzeugnisse",
      aH: "Schalenfrüchte",
      aL: "Sellerie",
      aM: "Senf",
      aN: "Sesamen",
      aO: "Schwefeloxid und Sulfite",
      aP: "Lupinen",
      aR: "Weichtiere",
      z1: "Konservierungsstoff",
      z2: "Geschmacksverstärker",
      z3: "Antioxidationsmittel",
      z4: "Farbstoff",
      z5: "Phosphat",
      z6: "chininhaltig",
      z7: "koffeinhaltig",
      z8: "geschwefelt",
      z9: "Saccharin",
      z10: "Aspartam/ Phenylalaninquelle",
      z11: "Cyclamat",
      z12: "Acesulfam",
      z13: "geschwärzt",
      z14: "gewachst",
      z15: "gentechnisch"
    }, $e = oe(() => {
      if (!D.value || !D.value.substances)
        return "";
      const i = [];
      for (const c in D.value.substances)
        D.value.substances[c] && ye[c] && i.push(ye[c]);
      return i.join(", ");
    });
    oe(() => {
      if (!D.value) return 0;
      const i = D.value.sizes && D.value.sizes.length > 0, c = ne.value.length > 0;
      if (i && c) {
        let f = 1 / 0;
        return ne.value.forEach((g) => {
          g.options.forEach((m) => {
            m && typeof m.cost == "number" && (f = Math.min(f, m.cost));
          });
        }), f === 1 / 0 ? 0 : f;
      } else {
        if (i)
          return Math.min(...D.value.sizes.map((f) => f.price));
        if (c) {
          let f = 1 / 0;
          return ne.value.forEach((g) => {
            g.options.forEach((m) => {
              m && typeof m.cost == "number" && (f = Math.min(f, m.cost));
            });
          }), f === 1 / 0 ? 0 : f;
        }
      }
      return 0;
    }), oe(() => D.value ? !!(D.value.sizes && D.value.sizes.length > 1 || ne.value.length > 0) : !1);
    const we = (i) => {
      if (!i)
        return "";
      const c = [];
      for (const f in i)
        i[f] && ye[f] && c.push(ye[f]);
      return c.join(", ");
    }, Ct = () => {
      h.value++;
    }, uo = () => {
      h.value > 1 && h.value--;
    }, Fe = (i) => {
      p.value = i;
    }, de = oe(() => {
      let i = 0, c = !1;
      for (const g of ne.value) {
        const m = u[g.title] || [];
        if (m.length > 0) {
          const v = m[0], _ = g.options.find((w) => w && w.id === v);
          if (_ && typeof _.cost == "number") {
            i = _.cost, c = !0;
            break;
          }
        }
      }
      if (!c && D.value && D.value.sizes && D.value.sizes.length > 0) {
        const g = D.value.sizes.find((m) => m.vol === p.value);
        i = g ? g.price : D.value.sizes[0].price;
      }
      let f = 0;
      return D.value && D.value.extras && D.value.extras.variants && D.value.extras.variants.forEach((g) => {
        if (g.replaceArticle !== !0) {
          const m = u[g.title] || [];
          if (m.length > 0) {
            const v = m.map((_) => g.options.find((w) => w && w.id === _)).filter((_) => _ && typeof _.cost == "number" && _.cost > 0);
            if (g.multi && g.freeArticles && g.freeArticles > 0) {
              v.sort((_, w) => w.cost - _.cost);
              for (let _ = g.freeArticles; _ < v.length; _++)
                f += v[_].cost;
            } else
              v.forEach((_) => {
                f += _.cost;
              });
          }
        }
      }), (i + f) * h.value;
    }), F = oe(() => {
      const i = R.value;
      return !i || i.type === "normal" && !ee(i) || i.optional || i.multi ? !0 : (u[i.title] || []).length > 0;
    }), j = oe(() => {
      if (!Q.value.length)
        return !1;
      if (!Xe.value)
        return !0;
      const i = R.value;
      if (!i)
        return console.log("isAddToCartButtonDisabled: No variant, returning true (disabled)"), !0;
      if (i.type === "normal" && !ee(i))
        return console.log(`isAddToCartButtonDisabled: Variant "${i.title}" is hidden, returning false (enabled)`), !1;
      const c = u[i.title] || [];
      if (i.min && i.min > 0) {
        const g = c.length < i.min;
        return console.log(`Rule 3 (min > 0): ${c.length} < ${i.min} -> Disabled: ${g}`), g;
      }
      if (i.multi || i.optional)
        return console.log("Rule 1 (multi=true) or Rule 2 (optional=true): Disabled: false"), !1;
      const f = c.length === 0;
      return console.log(`Rule 4 (!multi && !optional && !min): ${c.length} === 0 -> Disabled: ${f}`), f;
    }), Ve = oe(() => Y.value === 0), Xe = oe(() => Y.value === Q.value.length - 1 || !Q.value.length), Qe = () => {
      if (!F.value) {
        l("Auswahl erforderlich", `Bitte wähle eine Option bei "${R.value.title}" aus, bevor du fortfährst.`, !0);
        return;
      }
      Xe.value || Y.value++;
    }, lt = () => {
      Ve.value || Y.value--;
    }, ze = () => {
      if (console.log("addToCart function called!"), j.value)
        return;
      for (const c of Q.value)
        if (!(c.type === "normal" && !ee(c)))
          if (c.min && c.min > 0) {
            if ((u[c.title] || []).length < c.min) {
              l("Auswahl erforderlich", `Bitte wähle mindestens ${c.min} Option(en) bei "${c.title}" aus, bevor du den Artikel in den Korb legst.`, !0), Y.value = Q.value.findIndex((g) => g.title === c.title);
              return;
            }
          } else {
            if (c.optional || c.multi)
              continue;
            if ((u[c.title] || []).length === 0) {
              l("Auswahl erforderlich", `Bitte wähle eine Option bei "${c.title}" aus, bevor du den Artikel in den Korb legst.`, !0), Y.value = Q.value.findIndex((g) => g.title === c.title);
              return;
            }
          }
      const i = ha({
        article: D.value,
        selectedVariants: u,
        selectedSize: p.value,
        quantity: h.value,
        itemType: a.itemType,
        totalPrice: de.value
      });
      console.log("Adding to cart:", i), o("add-to-cart", JSON.stringify(i));
    }, Ee = (i, c) => (u[i.title] || []).includes(c), fo = (i, c) => {
      let f = u[i.title] || [];
      const g = i.implicit && !i.optional && b(i).length === 1;
      let m = !1;
      if (f.includes(c)) {
        if (g && f.length === 1) {
          l("Auswahl erforderlich", `Diese Option muss bei "${i.title}" ausgewählt bleiben.`, !0);
          return;
        }
        u[i.title] = f.filter((v) => v !== c);
      } else if (!i.multi)
        u[i.title] = [c], m = !0;
      else {
        if (i.maxOptions && f.length >= i.maxOptions) {
          l("Auswahlbegrenzung erreicht", `Du kannst maximal ${i.maxOptions} Optionen bei "${i.title}" auswählen.`, !0);
          return;
        }
        u[i.title] = [...f, c], m = !0;
      }
      m && (!i.multi || i.replaceArticle === !0 || i.multi && i.maxOptions && u[i.title].length === i.maxOptions) && Qe();
    }, po = (i) => {
      const c = [];
      return (i.multi || i.optional) && c.push("Optional"), i.freeArticles && i.freeArticles > 0 && c.push(`${i.freeArticles} Optionen inbegriffen`), i.maxOptions && i.maxOptions > 0 && c.push(`Wähle bis zu ${i.maxOptions} Optionen`), c.join(", ");
    }, ct = () => {
      o("close-additionals");
    }, Tt = () => {
      D.value && D.value.image && o("click-image", D.value.image);
    }, mt = oe(() => xn(a.primaryColor)), bt = oe(() => ia(a.primaryColor, 0.2)), xe = oe(() => xn(bt.value)), Wn = oe(() => j.value ? {
      backgroundColor: "#e2e8f0",
      // A light grey for disabled state (tailwind gray-200)
      color: "#a3a3a3",
      // Darker grey text (tailwind gray-400)
      cursor: "not-allowed",
      opacity: "0.7",
      // Slightly faded
      boxShadow: "none"
      // No shadow when disabled
    } : {
      backgroundColor: a.primaryColor,
      color: mt.value,
      cursor: "pointer",
      opacity: "1",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
      // Re-apply shadow for active state
    });
    return Vt(() => a.itemType, (i) => {
      i && typeof i == "string" && i.trim() !== "" ? console.log("itemType", i) : console.warn("Received empty or invalid itemType prop");
    }, { immediate: !0 }), (i, c) => (B(), G(ae, null, [
      k("div", ma, [
        k("div", ba, [
          k("div", va, [
            k("button", {
              onClick: ct,
              class: "absolute top-4 right-4 text-gray-500 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50 transition-colors duration-200"
            }, c[1] || (c[1] = [
              k("svg", {
                class: "w-6 h-6",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                k("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M6 18L18 6M6 6l12 12"
                })
              ], -1)
            ])),
            k("div", _a, [
              D.value.image && U.value ? (B(), G("div", ya, [
                k("img", {
                  src: D.value.image,
                  alt: D.value.nameDE,
                  class: "w-full h-full object-cover rounded-xl shadow-lg border border-gray-200 cursor-pointer",
                  onClick: Tt
                }, null, 8, wa)
              ])) : he("", !0),
              k("div", Ea, [
                k("h2", xa, re(D.value.nameDE), 1),
                k("div", null, [
                  k("div", {
                    class: "description text-gray-600 mt-2",
                    innerHTML: D.value.descriptionDE
                  }, null, 8, Na),
                  $e.value ? (B(), G("div", Oa, [
                    c[2] || (c[2] = k("span", { class: "font-semibold" }, "Enthält:", -1)),
                    Bs(" " + re($e.value), 1)
                  ])) : he("", !0)
                ])
              ])
            ]),
            D.value.sizes && D.value.sizes.length > 1 ? (B(), G("div", Da, [
              c[3] || (c[3] = k("h3", { class: "item-additionals-textSize font-semibold text-gray-700 mb-3" }, "Größe wählen:", -1)),
              k("div", Va, [
                (B(!0), G(ae, null, tn(D.value.sizes, (f) => (B(), G("button", {
                  key: f.vol,
                  onClick: (g) => Fe(f.vol),
                  class: Mt(["size-option p-4 border rounded-xl cursor-pointer transition-all duration-200 ease-in-out flex flex-col items-center justify-center", {
                    "hover:bg-gray-50": p.value !== f.vol
                  }]),
                  style: le(p.value === f.vol ? { backgroundColor: bt.value, borderColor: a.primaryColor, boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)" } : { borderColor: "#cbd5e1" })
                }, [
                  k("span", {
                    class: "item-additionals-textSize font-medium",
                    style: le(p.value === f.vol ? { color: xe.value } : {})
                  }, re(f.vol), 5),
                  k("span", {
                    class: "text-md font-semibold mt-1",
                    style: le(p.value === f.vol ? { color: xe.value } : {})
                  }, re(f.price.toFixed(2)) + "€", 5)
                ], 14, Sa))), 128))
              ])
            ])) : he("", !0)
          ])
        ]),
        k("div", Ca, [
          Q.value.length > 0 && U.value ? (B(), G("div", Ta, [
            k("span", Aa, " Schritt " + re(Y.value + 1) + " von " + re(Q.value.length), 1),
            k("div", ka, [
              k("div", {
                class: "h-2.5 rounded-full transition-all duration-300 ease-in-out",
                style: le({ width: (Y.value + 1) / Q.value.length * 100 + "%", backgroundColor: a.primaryColor })
              }, null, 4)
            ])
          ])) : he("", !0),
          k("div", Ia, [
            R.value ? (B(), G(ae, { key: 0 }, [
              R.value.type === "replace" ? (B(), G("div", Pa, [
                k("h3", $a, re(R.value.title), 1),
                k("div", Ma, [
                  (B(!0), G(ae, null, tn(b(R.value), (f) => (B(), G("div", {
                    key: f.id,
                    onClick: (g) => fo(R.value, f.id),
                    class: Mt(["size-option p-4 border rounded-xl cursor-pointer transition-all duration-200 ease-in-out flex flex-col items-center justify-center", {
                      "hover:bg-gray-50": !Ee(R.value, f.id)
                    }]),
                    style: le(Ee(R.value, f.id) ? { backgroundColor: bt.value, borderColor: a.primaryColor, boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)" } : { borderColor: "#cbd5e1" })
                  }, [
                    f.imageUrl ? (B(), G("img", {
                      key: 0,
                      src: f.imageUrl,
                      alt: f.labelDE,
                      class: "optionImage object-cover rounded-full mb-2 border border-gray-200 shadow-sm"
                    }, null, 8, ja)) : he("", !0),
                    k("div", Fa, [
                      k("span", {
                        class: "item-additionals-textSize font-medium",
                        style: le(Ee(R.value, f.id) ? { color: xe.value } : {})
                      }, re(f.labelDE), 5),
                      f.cost > 0 ? (B(), G("span", {
                        key: 0,
                        class: "text-sm font-semibold",
                        style: le(Ee(R.value, f.id) ? { color: xe.value } : {})
                      }, " +" + re(f.cost.toFixed(2)) + "€ ", 5)) : he("", !0)
                    ]),
                    f.substances ? (B(), G("div", {
                      key: 1,
                      style: le(Ee(R.value, f.id) ? { color: xe.value } : {})
                    }, re(we(f.substances)), 5)) : he("", !0)
                  ], 14, Ra))), 128))
                ])
              ])) : R.value.type === "normal" ? (B(), G("div", za, [
                k("div", Ha, [
                  k("div", La, [
                    k("div", Ba, [
                      k("span", null, re(R.value.title), 1),
                      po(R.value) ? (B(), G("span", Ua, re(po(R.value)), 1)) : he("", !0)
                    ])
                  ]),
                  k("div", Wa, [
                    k("div", Ka, [
                      (B(!0), G(ae, null, tn(b(R.value), (f) => (B(), G("div", {
                        key: f.id,
                        onClick: (g) => fo(R.value, f.id),
                        class: Mt(["option-item p-4 border rounded-xl cursor-pointer transition-all duration-200 ease-in-out flex flex-col items-center justify-center text-center", {
                          "hover:bg-gray-50": !Ee(R.value, f.id)
                        }]),
                        style: le(Ee(R.value, f.id) ? { backgroundColor: bt.value, borderColor: a.primaryColor, boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)" } : { borderColor: "#cbd5e1" })
                      }, [
                        f.imageUrl ? (B(), G("img", {
                          key: 0,
                          src: f.imageUrl,
                          alt: f.labelDE,
                          class: "optionImage object-cover rounded-full mb-2 border border-gray-200 shadow-sm"
                        }, null, 8, Ga)) : he("", !0),
                        k("div", Ja, [
                          k("span", {
                            class: "item-additionals-textSize font-medium",
                            style: le(Ee(R.value, f.id) ? { color: xe.value } : {})
                          }, re(f.labelDE), 5),
                          f.cost > 0 ? (B(), G("span", {
                            key: 0,
                            class: "text-sm font-semibold",
                            style: le(Ee(R.value, f.id) ? { color: xe.value } : {})
                          }, " +" + re(f.cost.toFixed(2)) + "€ ", 5)) : he("", !0)
                        ]),
                        f.substances ? (B(), G("div", {
                          key: 1,
                          style: le(Ee(R.value, f.id) ? { color: xe.value } : {})
                        }, re(we(f.substances)), 5)) : he("", !0)
                      ], 14, qa))), 128))
                    ])
                  ])
                ])
              ])) : he("", !0)
            ], 64)) : (B(), G("p", Ya))
          ])
        ]),
        k("div", Xa, [
          k("div", Qa, [
            k("div", Za, [
              Xe.value ? he("", !0) : (B(), G("button", {
                key: 0,
                onClick: ct,
                class: "px-6 py-3 rounded-full font-bold item-additionals-textSize shadow-lg transition-colors duration-200 ease-in-out",
                style: { backgroundColor: "#e2e8f0", color: "#475569" }
              }, " Abbrechen ")),
              Xe.value ? (B(), G(ae, { key: 1 }, [
                k("button", {
                  onClick: uo,
                  class: "quantity-button decrement",
                  style: { "padding-bottom": "4px" }
                }, "- "),
                k("span", eu, re(h.value), 1),
                k("button", {
                  onClick: Ct,
                  class: "quantity-button increment",
                  style: le([{ "padding-bottom": "4px" }, { backgroundColor: a.primaryColor, color: mt.value }])
                }, "+ ", 4)
              ], 64)) : he("", !0)
            ]),
            k("div", tu, [
              Ve.value ? he("", !0) : (B(), G("button", {
                key: 0,
                onClick: lt,
                class: "px-6 py-3 rounded-full font-bold item-additionals-textSize shadow-lg transition-colors duration-200 ease-in-out",
                style: { backgroundColor: "#e2e8f0", color: "#475569" }
              }, " Zurück ")),
              Xe.value ? (B(), G("button", {
                key: 2,
                onClick: ze,
                class: "add-to-cart-button ml-10",
                style: le(Wn.value),
                disabled: j.value
              }, " In den Korb (" + re(de.value.toFixed(2)) + "€) ", 13, ou)) : (B(), G("button", {
                key: 1,
                onClick: Qe,
                class: "px-6 py-3 rounded-full font-bold item-additionals-textSize shadow-lg transition-colors duration-200 ease-in-out",
                style: le({ backgroundColor: a.primaryColor, color: mt.value })
              }, " Weiter ", 4))
            ])
          ])
        ])
      ]),
      Ie(pa, null, {
        default: ps(() => [
          Ie(da, {
            "primary-color": e.primaryColor,
            title: r.value,
            message: s.value,
            modelValue: n.value,
            "onUpdate:modelValue": c[0] || (c[0] = (f) => n.value = f)
          }, null, 8, ["primary-color", "title", "message", "modelValue"])
        ]),
        _: 1
      })
    ], 64));
  }
}, ru = /* @__PURE__ */ sa(nu, [["styles", [ga]]]), su = /* @__PURE__ */ Yc(ru);
customElements.define("item-additionals", su);
